/* Subida de diseño para los transfers DTF · Imprimirlo
 * Sube el archivo con la subida nativa de Shopify (multipart), sin apps.
 * Lee la variante elegida del selector del tema y traduce la resolución
 * a una nota de calidad entendible por el cliente.
 */
(function () {
  'use strict';

  function $(root, sel) { return root.querySelector(sel); }
  function money(c) { return (c / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); }
  function fmt(n, d) { return Number(n).toLocaleString('es-ES', { minimumFractionDigits: d || 0, maximumFractionDigits: d == null ? 1 : d }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // "Pecho (hasta 9,9×9,9 cm)" -> {w: 99, h: 99} en mm
  function medidaDe(texto) {
    var m = String(texto).match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*cm/i);
    if (!m) return null;
    return { w: parseFloat(m[1].replace(',', '.')) * 10, h: parseFloat(m[2].replace(',', '.')) * 10 };
  }

  /* «Hasta 120 cm²» -> 120. Las BANDAS DE SUPERFICIE (22/10/2026, Xavi: «que sea por cm², sin saltos»): cada diseño paga la banda más pequeña cuya
     superficie cubre ancho × alto, con un 5 % de escalón entre una y la siguiente; las cajas de medidas de antes siguen existiendo. */
  function areaDe(texto) {
    var m = String(texto).match(/(\d+(?:[.,]\d+)?)\s*cm\s*²/i);
    return m ? parseFloat(m[1].replace(',', '.')) : null;
  }

  // "20 uds" -> 20
  function cantidadDe(texto) {
    var m = String(texto).match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  function Subida(root) {
    this.root = root;
    this.cfg = JSON.parse($(root, '[data-sdtf-config]').textContent);
    this.archivo = null; this.busy = false;
    this.leerPausa();                 // lo que traiga el enlace manda sobre lo que haya por defecto
    this.bind();
    this.montarPausa();
    this.montarTelas();
    this.montarMedida();
    this.montarOpciones();
    this.montarPega();
    this.montarMedidaMedia();
    this.montarPrecioTema();
    this.recuperarPausa();            // si el diseño está en este aparato, vuelve solo
    this.actualizar();
  }

  /* ---------- DEJAR EL PEDIDO EN PAUSA Y SEGUIR EN EL ORDENADOR ----------
   *
   * El caso real: entra desde Instagram con el móvil y el logo bueno lo tiene
   * en el ordenador del trabajo. Hoy ese cliente se va y no vuelve.
   *
   * La tentación era dejarle pedir sin archivo y que lo mandara por correo
   * después. No sirve: sin el archivo delante nadie puede medir nada, así que
   * declara «5 × 8» de cabeza, llega un diseño de 8 × 14 y ya no cabe en lo
   * que ha pagado. El problema no es el archivo, es el aparato.
   *
   * Así que no se pausa el pedido: se guarda LO ELEGIDO en el propio enlace y
   * se sigue donde esté el archivo. El diseño no viaja en el enlace —ni cabe
   * ni tiene por qué—, y eso se le dice, que si no se cree que lo hemos
   * guardado nosotros. */
  /* ---------- EL DISEÑO, GUARDADO EN ESTE APARATO ----------
   *
   * El enlace se lleva lo elegido, pero el archivo no cabe en una URL. Y sin
   * una app propia la tienda no tiene dónde guardarme el archivo de alguien
   * que todavía no ha comprado: Shopify solo lo sube cuando entra en el
   * carrito. Xavi lo vio enseguida: «lo de seguir en otro momento está muy
   * bien pero si no guarda el diseño... no lo veo».
   *
   * Lo que sí se puede, y es la mitad de los casos, es guardarlo en el propio
   * navegador: «lo dejo ahora y sigo esta noche desde el mismo móvil». El
   * archivo se queda en IndexedDB —que aguanta un PNG de 20 MB sin
   * despeinarse, al revés que localStorage— con una llave que viaja en el
   * enlace. Al abrirlo en ESTE aparato vuelve todo, diseño incluido; abierto
   * en otro, vuelve lo elegido y el archivo se suelta otra vez.
   *
   * No sale del navegador del cliente: ni se manda, ni lo vemos, ni hay nada
   * que borrar en ningún servidor. Y lo que tenga más de 30 días se tira solo,
   * que un pedido a medias de hace dos meses ya no es un pedido a medias. */
  var ALMACEN = 'imprimirlo-pausa', TABLA = 'diseños', DIAS = 30;

  function abrirBase() {
    return new Promise(function (ok, no) {
      if (!window.indexedDB) return no(new Error('sin indexedDB'));
      var pet = indexedDB.open(ALMACEN, 1);
      pet.onupgradeneeded = function () {
        if (!pet.result.objectStoreNames.contains(TABLA)) pet.result.createObjectStore(TABLA);
      };
      pet.onsuccess = function () { ok(pet.result); };
      pet.onerror = function () { no(pet.error || new Error('no se abre')); };
    });
  }

  function guardarDiseño(llave, dato) {
    return abrirBase().then(function (db) {
      return new Promise(function (ok, no) {
        var tx = db.transaction(TABLA, 'readwrite'), t = tx.objectStore(TABLA);
        t.put(dato, llave);
        // de paso, la limpieza: lo viejo fuera
        var corte = Date.now() - DIAS * 864e5;
        var cur = t.openCursor();
        cur.onsuccess = function () {
          var c = cur.result;
          if (!c) return;
          if (!c.value || !c.value.fecha || c.value.fecha < corte) c.delete();
          c.continue();
        };
        tx.oncomplete = function () { db.close(); ok(true); };
        tx.onerror = function () { db.close(); no(tx.error); };
      });
    });
  }

  function leerDiseño(llave) {
    return abrirBase().then(function (db) {
      return new Promise(function (ok) {
        var tx = db.transaction(TABLA, 'readonly');
        var pet = tx.objectStore(TABLA).get(llave);
        pet.onsuccess = function () { db.close(); ok(pet.result || null); };
        pet.onerror = function () { db.close(); ok(null); };
      });
    });
  }

  function llaveNueva() {
    return 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
  }

  Subida.prototype.leerPausa = function () {
    var q = {};
    try {
      (location.search || '').replace(/^\?/, '').split('&').forEach(function (par) {
        if (!par) return;
        var t = par.split('=');
        q[decodeURIComponent(t[0])] = decodeURIComponent((t[1] || '').replace(/\+/g, ' '));
      });
    } catch (e) { q = {}; }
    this.pausa = q;
  };

  Subida.prototype.enlacePausa = function () {
    var p = [], v = this.variante();
    if (this.cfg.pegatina) {
      if (v) p.push('v=' + (v._pack ? v._pack.id : v.id));
      if (v && v._libre) p.push('l=' + v._libre);
      if (this.libre() && this.iman) p.push('im=' + this.iman.forma + '_' + Math.round(this.iman.w) + '_' + Math.round(this.iman.h));
    }
    else {
      if (this.anchoCm) p.push('a=' + this.anchoCm);
      if (this.telaSel) p.push('t=' + encodeURIComponent(this.telaSel));
      if (this.telaSel === 'otro' && this.otroHex) p.push('h=' + encodeURIComponent(this.otroHex));
      if (this.cantSel) p.push('c=' + encodeURIComponent(this.cantSel));
    }
    // la llave del diseño guardado en este aparato, si lo hay
    if (this.llavePausa) p.push('g=' + encodeURIComponent(this.llavePausa));
    return location.origin + location.pathname + (p.length ? '?' + p.join('&') : '');
  };

  /* Se guarda al pulsar el botón, no todo el rato: el cliente que solo está
     mirando no tiene por qué dejarse el archivo metido en el navegador. */
  Subida.prototype.guardarPausa = async function () {
    var a = this.archivo;
    if (!a || !a.file) return null;
    var llave = this.llavePausa || llaveNueva();
    try {
      await guardarDiseño(llave, {
        file: a.file, nombre: a.file.name, arreglos: (a.arreglos || []).slice(),
        /* LOS PÍXELES DE VERDAD VIAJAN CON EL ARCHIVO. Si se le afinaron los
           bordes, el fichero guardado ya viene ampliado, y medir la calidad
           sobre esos píxeles diría que el archivo es mejor de lo que es.
           Ampliar no añade detalle, y eso no se maquilla ni aquí. */
        pxCalidad: (a.pxCalidad || a.px || null), fecha: Date.now()
      });
      this.llavePausa = llave;
      return llave;
    } catch (e) { return null; }     // navegador en privado, sin sitio, lo que sea
  };

  /* Al abrir el enlace: si el diseño está en ESTE aparato, se pone solo. */
  Subida.prototype.recuperarPausa = async function () {
    var llave = this.pausa && this.pausa.g;
    if (!llave || this.archivo) return false;
    var dato = null;
    try { dato = await leerDiseño(llave); } catch (e) { dato = null; }
    if (!dato || !dato.file) { this.pausaPerdida = !!llave; this.pintarPausa(); return false; }
    this.llavePausa = llave;
    try {
      await this.cargar(dato.file);
    } catch (e) { return false; }
    /* Los arreglos se anotan DESPUÉS de cargar y no como `extra`: ese camino
       espera el archivo de antes para poder deshacer, y aquí no lo hay —se
       guardó el archivo ya arreglado, que es el que se va a imprimir—. */
    if (this.archivo) {
      if (dato.arreglos && dato.arreglos.length) this.archivo.arreglos = dato.arreglos.slice();
      if (dato.pxCalidad) this.archivo.pxCalidad = dato.pxCalidad;
      this.pintarArchivo();
      this.actualizar();
    }
    return true;
  };

  Subida.prototype.montarPausa = function () {
    var self = this, caja = $(this.root, '[data-pausa]');
    if (!caja) return;
    var campo = $(caja, '[data-pausa-url]');
    var bWa = $(caja, '[data-pausa-wa]');
    var bCorreo = $(caja, '[data-pausa-correo]');
    var aviso = $(caja, '[data-pausa-ok]');

    /* ENVIAR POR WHATSAPP, no copiar el enlace (Xavi, 01/10: «todo tiene que ir así»).
       Se guarda el diseño en este aparato y se abre WhatsApp con el enlace ya escrito:
       se lo manda a sí mismo, a quien le hace el diseño o a quien decide. */
    if (bWa) bWa.addEventListener('click', async function () {
      await self.guardarPausa();
      var url = self.enlacePausa();
      var texto = 'Mi pedido en Imprimirlo: ' + (document.title || '').replace(/\s*[·|–-]\s*Imprimirlo.*$/i, '') +
        '\nSigue donde lo he dejado: ' + url;
      if (aviso) { aviso.hidden = true; }
      window.open('https://wa.me/?text=' + encodeURIComponent(texto), '_blank', 'noopener');
    });

    if (bCorreo) bCorreo.addEventListener('click', async function () {
      await self.guardarPausa();
      var url = self.enlacePausa();
      var asunto = 'Mi pedido en Imprimirlo';
      var cuerpo = 'Abre este enlace en el ordenador, donde tengas el diseño, ' +
        'y sigue el pedido con todo lo que ya habías elegido:\n\n' + url + '\n';
      location.href = 'mailto:?subject=' + encodeURIComponent(asunto) +
        '&body=' + encodeURIComponent(cuerpo);
    });
  };

  Subida.prototype.pintarPausa = function () {
    var caja = $(this.root, '[data-pausa]');
    if (!caja) return;
    var t = $(caja, '[data-pausa-t]');
    if (!t) return;
    t.innerHTML = this.pausaPerdida && !this.archivo
      ? '<b>Aquí tienes lo que elegiste.</b> El diseño se quedó guardado en el aparato desde el que ' +
        'empezaste, así que en este solo tienes que volver a soltarlo: lo demás ya está puesto.'
      : this.archivo
        ? '<b>¿Prefieres pensártelo?</b> Mándate el enlace por WhatsApp y sigue cuando quieras. En este mismo aparato ' +
          'te lo dejamos todo puesto, diseño incluido; si lo abres en otro, solo tendrás que volver a ' +
          'soltar el archivo.'
        : '<b>¿El diseño lo tienes en el ordenador?</b> Mándate el enlace por WhatsApp con lo que ya has elegido y ' +
          'termina el pedido allí, que es donde está el archivo.';
  };

  Subida.prototype.bind = function () {
    var self = this, r = this.root;
    var input = $(r, '[data-file]'), drop = $(r, '[data-drop]');
    input.addEventListener('change', function () { self.cargar(input.files[0]); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { self.cargar(e.dataTransfer.files[0]); });
    /* El diseño que viene del carrito («Así quedaría tu diseño en…», Xavi 19/10): carrito-mockups.js lo deja en sessionStorage al pulsar
       un producto de esa tira y aquí se carga solo, como si lo hubiera soltado ahora. Una sola vez y solo si es reciente. */
    try {
      var pend = sessionStorage.getItem('imp_diseno_carrito');
      if (pend) {
        sessionStorage.removeItem('imp_diseno_carrito');
        var po = JSON.parse(pend);
        if (po && po.src && Date.now() - po.t < 30 * 60 * 1000 && window.File) {
          fetch(po.src).then(function (rr) { return rr.blob(); }).then(function (b) {
            if (!b || !b.size || self.archivo) return;
            self.cargar(new File([b], 'tu-diseno.png', { type: b.type || 'image/png' }));
          }).catch(function () { /* sin diseño: queda vacío, como siempre */ });
        }
      }
    } catch (e0) { /* sin sessionStorage */ }
    $(r, '[data-quitar]').addEventListener('click', function () { self.archivo = null; self._texto = null; self.pintarArchivo(); self.actualizar(); });
    // botón «Añadir texto»: está en dos sitios (junto a la subida y en la cabecera de la previa, que vive fuera de .sdtf)
    // doble clic en el texto (en la previa o en la miniatura) = editarlo
    document.addEventListener('dblclick', function (e) {
      var z = e.target.closest && e.target.closest('[data-pega-lienzo], [data-thumb]');
      if (!z || !self._texto || !(r.contains(z) || (self.cajaPega && self.cajaPega.contains(z)))) return;
      var ed = $(r, '[data-texto-ed]');
      if (ed) { e.preventDefault(); self.abrirTexto(ed); }
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-texto-abrir]');
      if (b && (r.contains(b) || (self.cajaPega && self.cajaPega.contains(b)))) { e.preventDefault(); self.abrirTexto(b); }
    });
    var acepta = $(r, '[data-acepta]');
    if (acepta) acepta.addEventListener('change', function () { self.actualizar(); });
    var repaso = $(r, '[data-repaso]');
    if (repaso) repaso.addEventListener('change', function () { self.repasoTocado = true; self.actualizar(); });
    Array.prototype.forEach.call(r.querySelectorAll('[data-fix]'), function (b) {
      b.addEventListener('click', function () {
        // «Quitar el fondo» es la ventana 2.0 (elegir qué colores quitar); el resto, como siempre
        if (b.dataset.fix === 'fondo' && window.QuitarFondo) self.quitarFondo2();
        else self.arreglar(b.dataset.fix);
      });
    });
    var des = $(r, '[data-deshacer]');
    if (des) des.addEventListener('click', function () { self.deshacer(); });
    var tMas = $(r, '[data-tol-mas]'), tMenos = $(r, '[data-tol-menos]');
    if (tMas) tMas.addEventListener('click', function () { self.ajustarFondo(1); });
    if (tMenos) tMenos.addEventListener('click', function () { self.ajustarFondo(-1); });
    if (window.QuitarFondo && tMas && tMenos) {
      // con la ventana 2.0, los −/+ sobran: un solo botón para volver a ajustar el fondo
      tMas.hidden = true; tMenos.hidden = true;
      var tBtns = tMas.parentNode, bAj = document.createElement('button');
      bAj.type = 'button'; bAj.className = 'sdtf-tol__b'; bAj.textContent = 'Ajustar el fondo: elegir qué colores quitar';
      bAj.addEventListener('click', function () { self.quitarFondo2(); });
      tBtns.appendChild(bAj);
    }
    var vVer = $(r, '[data-vector-ver]');
    if (vVer) vVer.addEventListener('click', function () { self.verVector(); });
    var vChk = $(r, '[data-vector-check]');
    if (vChk) vChk.addEventListener('change', function () { self.actualizar(); });
    $(r, '[data-add]').addEventListener('click', function () { self.alCarrito(); });
    var bp = $(r, '[data-presupuesto]');
    if (bp) bp.addEventListener('click', function () { self.presupuestoListo(); });
    // el selector de variantes del tema: cualquier cambio recalcula
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios, .product-form__input, [name="id"]')) {
        setTimeout(function () { self.actualizar(); }, 30);
      }
    });
    window.addEventListener('popstate', function () { self.actualizar(); });
  };

  /* ---------- lo que se muda a la columna de la foto ----------
   *
   * En PC esa columna es espacio muerto: una foto de archivo de un producto
   * que no es el suyo, ocupando media pantalla mientras el formulario se hace
   * largo. Así que se muda ahí la previa y se queda pegada al scroll.
   *
   * En móvil no hay dos columnas y la galería va arriba del todo, así que se
   * queda donde estaba. Es UN solo bloque que cambia de sitio, no dos copias:
   * así no hay dos lienzos que pintar ni forma de que digan cosas distintas.
   */
  Subida.prototype.mudarAFoto = function (caja) {
    if (!caja) return null;
    var col = document.querySelector('.product__media-wrapper, .product__media-gallery');
    if (!col) return null;                  // otro tema: se queda como está
    this.galeria = col;
    var marca = document.createComment('previa');
    caja.parentNode.insertBefore(marca, caja);
    var self = this;
    var ancha = window.matchMedia('(min-width: 990px)');
    function colocar() {
      if (ancha.matches) {
        if (caja.parentNode !== col) col.insertBefore(caja, col.firstChild);
        caja.classList.add('sdtf-pega--media');
      } else {
        if (caja.parentNode === col) marca.parentNode.insertBefore(caja, marca.nextSibling);
        caja.classList.remove('sdtf-pega--media');
      }
      self.actualizar();
    }
    if (ancha.addEventListener) ancha.addEventListener('change', colocar);
    else if (ancha.addListener) ancha.addListener(colocar);
    colocar();
    return caja;
  };

  Subida.prototype.montarPega = function () {
    if (!this.cfg.pegatina) return;
    this.cajaPega = this.mudarAFoto($(this.root, '[data-pega]')) || this.cajaPega;
  };

  /* En transfers lo que se muda es el BLOQUE DEL ANCHO entero, con su barra
     dentro. Lo pidió Xavi: en PC la foto de producto es una foto de archivo que
     no es la suya y no pinta nada, mientras el formulario se hace largo. Así
     que esa columna pasa a ser la previa —y la barra va al lado, que es donde
     sirve: arrastras y ves crecer el diseño sin moverte—. */
  Subida.prototype.montarMedidaMedia = function () {
    if (this.cfg.pegatina) return;
    this.cajaMedida = this.mudarAFoto(this.cajaMedida) || this.cajaMedida;
  };

  /* ---------- selector propio (solo pegatinas) ----------
   *
   * El de Dawn son 22 píldoras iguales con el texto de la opción dentro, y
   * en una pegatina eso no se lee: un tamaño en centímetros nadie se lo
   * imagina, y la escalera de precios —que es el argumento de venta— queda
   * escondida hasta que vas clicando. Aquí el tamaño se DIBUJA a escala entre
   * las opciones y cada cantidad lleva su precio por unidad debajo.
   */
  Subida.prototype.montarOpciones = function () {
    var self = this, r = this.root;
    var caja = $(r, '[data-opciones]');
    if (!caja || !this.cfg.pegatina || !this.cfg.variantes.length) return;
    var nombres = this.cfg.opciones || [];
    this.valores = nombres.map(function (_, i) {
      var out = [];
      self.cfg.variantes.forEach(function (v) {
        var o = v.opts[i];
        if (o != null && out.indexOf(o) === -1) out.push(o);
      });
      return out;
    });
    this.sel = this.valores.map(function (v) { return v[0]; });
    /* TAMAÑO POR DEFECTO: 6 CM, EN LAS TRES FICHAS — Xavi, 28/09. Antes salía
       marcado el primero de la lista (el más pequeño); ahora se busca, entre
       los valores de ESTA ficha, el que tenga el lado más cercano a 6 cm, sea
       cual sea el texto exacto («Redonda 6 cm», «Cuadrada 6 × 6 cm», el
       tamaño máximo «6 × 6 cm» de troquelada…). Si algún día cambian las
       tallas, esto se sigue ajustando solo, sin tocar código. */
    if (window.PegatinaCorte) {
      nombres.forEach(function (_, i) {
        var candidatas = self.valores[i]
          .map(function (v) { return { v: v, f: PegatinaCorte.formatoDe(v) }; })
          .filter(function (x) { return x.f; });
        if (!candidatas.length) return;
        candidatas.sort(function (a, b) {
          return Math.abs(Math.max(a.f.w, a.f.h) - 60) - Math.abs(Math.max(b.f.w, b.f.h) - 60);
        });
        self.sel[i] = candidatas[0].v;
      });
    }
    // si viene de un enlace en pausa, se recupera exactamente lo que había elegido
    var vp = this.pausa && this.pausa.v;
    if (vp) {
      var guardada = this.cfg.variantes.filter(function (x) { return String(x.id) === String(vp); })[0];
      if (guardada) this.sel = guardada.opts.slice();
    }
    if (this.libreVale() && this.pausa && this.pausa.l) {
      var nl = parseInt(this.pausa.l, 10);
      if (nl >= ESCALONES[0] && nl <= LIBRE_MAX) { this.cantLibre = nl; this._libreTxt = String(nl); }
    }
    if (this.libre()) this.arrancarIman(vp);
    // el acabado por defecto (pegatinas con borde blanco, imanes sin él) tiene que estar puesto ANTES del primer cálculo,
    // si no la primera previa sale sin borde hasta que se toca el grosor
    if (this.filete == null) this.filete = !this.cfg.iman;
    caja.hidden = false;
    this.pintarOpciones();
  };

  // el sustantivo que toca en los textos: «pegatina(s)» o, en la ficha de
  // chapas, «chapa(s)» — para no llamar «pegatinas» a lo que el cliente pidió
  // como chapas.
  // el motor de tamaño libre (forma + medida escrita) lo usan los imanes y las pegatinas «a tu medida»
  Subida.prototype.libre = function () { return !!(this.cfg.iman || this.cfg.libre); };
  Subida.prototype.nombrePega = function (plural) {
    if (this.cfg.iman) return plural ? 'imanes' : 'imán';
    var s = this.cfg.chapa ? 'chapa' : 'pegatina';
    return plural ? s + 's' : s;
  };
  // «el imán» / «la pegatina» y el género de lo que va detrás (entera/entero, una/uno)
  Subida.prototype.elNombre = function () { return (this.cfg.iman ? 'el ' : 'la ') + this.nombrePega(); };
  Subida.prototype.gen = function (a, o) { return this.cfg.iman ? o : a; };

  // la variante que casa con lo elegido
  Subida.prototype.varianteSel = function () {
    var sel = this.sel;
    if (!sel) return null;
    return this.cfg.variantes.filter(function (v) {
      return sel.every(function (s, i) { return v.opts[i] === s; });
    })[0] || null;
  };

  /* EL FORMATO DE UNA VARIANTE. En pegatinas sale del texto de la opción
     («Redonda 5 cm»); en imanes no: el cliente escribe la forma y el tamaño y
     la variante es solo la caja de precio donde eso entra, así que el formato
     es el que ha pedido, no el de la caja. */
  Subida.prototype.formatoVar = function (v) {
    if (this.libre() && this.iman) return this.formatoIman();
    var f = null;
    (v ? v.opts : []).forEach(function (o) { var x = window.PegatinaCorte && PegatinaCorte.formatoDe(o); if (x) f = x; });
    return f;
  };

  // la de una opción concreta cambiada, para poder enseñar su precio
  Subida.prototype.varianteCon = function (i, valor) {
    var sel = (this.sel || []).slice();
    sel[i] = valor;
    return this.cfg.variantes.filter(function (v) {
      return sel.every(function (s, j) { return v.opts[j] === s; });
    })[0] || null;
  };

  function unidadesDe(opts) {
    var n = 1;
    opts.forEach(function (o) { if (/ud/i.test(o)) n = cantidadDe(o); });
    return n;
  }

  /* CUÁNTO MÁS BARATA SALE LA UNIDAD AL SUBIR DE ESCALÓN.
   *
   * Es lo único que le falta al selector de cantidad para que se entienda de un
   * vistazo: el €/ud ya está, pero un 0,19 no dice nada hasta que lo comparas
   * con el 0,80 de comprar pocas.
   *
   * SE COMPARA CONTRA EL ESCALÓN MÁS PEQUEÑO DE VERDAD, no contra un precio
   * inventado. La competencia hace esto tachando un precio —«~~110 €~~ 69 €»—
   * donde el tachado es el de 50 unidades multiplicado por dos, o sea un precio
   * que no ha pagado nadie nunca. Aparte de que una reducción de precio tiene
   * que ser sobre el más bajo aplicado en los 30 días anteriores, es que no
   * hace falta: «un 37 % menos que comprando 50» es verdad y convence igual.
   * Devuelve null si no hay nada honesto que contar. */
  function ahorroUnidad(varBase, udsBase, varAqui, udsAqui) {
    if (!varBase || !varAqui || !(udsAqui > udsBase) || !udsBase) return null;
    var base = varBase.precio / udsBase, aqui = varAqui.precio / udsAqui;
    if (!(base > 0) || aqui >= base) return null;
    var pct = Math.round((1 - aqui / base) * 100);
    return pct >= 5 ? pct : null;
  }

  /* ---------- IMANES: forma + tamaño libre + precio por cantidad ----------
   *
   * Xavi (01/10): «me gusta más el sistema de DTF. No son tamaños cerrados.
   * Indicas forma y tamaño y tienes precios por cantidad». Como en los
   * transfers, las variantes son cajas de nuestra lista de precios (opción
   * «Tamaño»: «hasta 8,5 × 5,5 cm»…) que el cliente no ve: escribe lo que
   * quiere y buscamos la caja MÁS BARATA donde entra, girando si hace falta.
   * La forma (rectangular, redonda, a su silueta) no cambia el precio: viaja
   * como propiedad y dice al plóter por dónde cortar.
   */
  var IMAN_MIN = 20;       // mm: por debajo de 2 cm no se corta bien un imán

  Subida.prototype.arrancarIman = function (variantePausa) {
    var self = this, nombres = this.cfg.opciones || [];
    this.iTam = -1; this.iCant = -1;
    nombres.forEach(function (n, i) {
      if (/cantidad/i.test(n)) self.iCant = i;
      else if (self.iTam === -1 && (self.valores[i] || []).some(function (x) { return PegatinaCorte.formatoDe(x); })) self.iTam = i;
    });
    this.iman = this.cfg.iman ? { forma: 'cuadrada', w: 85, h: 55 } : { forma: 'cuadrada', w: 60, h: 60 };
    // las fichas de pegatinas son tres (redondas, cuadradas, troqueladas): cada una con su forma fija
    if (this.cfg.formaFija) this.iman.forma = this.cfg.formaFija;
    if (this.iman.forma === 'libre') this.iman.w = this.iman.h = 60;
    // de entrada, 100 unidades si existen: es el escalón que se entiende
    var cants = this.valores[this.iCant] || [];
    var cien = cants.filter(function (c) { return cantidadDe(c) === 100; })[0];
    this.sel[this.iCant] = cien || cants[0];
    if (variantePausa) {
      var g = this.cfg.variantes.filter(function (x) { return String(x.id) === String(variantePausa); })[0];
      var f = g && PegatinaCorte.formatoDe(g.opts[this.iTam]);
      if (f) { this.iman.w = f.w; this.iman.h = f.h; }
      // y si el enlace trae la forma y la medida exactas, esas mandan
      var im = this.pausa && this.pausa.im && String(this.pausa.im).split('_');
      if (im && im.length === 3 && /^(cuadrada|redonda|libre)$/.test(im[0]) && +im[1] > 0 && +im[2] > 0 && (!this.cfg.formaFija || im[0] === this.cfg.formaFija)) {
        this.iman.forma = im[0]; this.iman.w = +im[1]; this.iman.h = +im[2];
      }
    }
    this.ajustarCajaIman();
  };

  // el tamaño máximo de las cajas, para avisar si se pasa
  Subida.prototype.cajasIman = function () {
    if (this._cajasIman) return this._cajasIman;
    var out = [];
    (this.valores[this.iTam] || []).forEach(function (val) {
      var f = PegatinaCorte.formatoDe(val);
      if (f) out.push({ valor: val, w: f.w, h: f.h });
    });
    this._cajasIman = out;
    return out;
  };

  Subida.prototype.maxIman = function () {
    var m = 0;
    this.cajasIman().forEach(function (c) { m = Math.max(m, c.w, c.h); });
    return m;
  };

  // lo que ha pedido, ya con límites: la redonda es un círculo (alto = ancho)
  Subida.prototype.formatoIman = function () {
    var i = this.iman, max = this.maxIman() || 120;
    var w = Math.max(IMAN_MIN, Math.min(max, i.w || IMAN_MIN));
    var h = i.forma === 'redonda' ? w : Math.max(IMAN_MIN, Math.min(max, i.h || IMAN_MIN));
    return { w: w, h: h, forma: i.forma };
  };

  /* LA FORMA SIGUE AL DISEÑO. Un póster vertical no puede salir en un imán
     horizontal (Xavi, 01/10): al subir el archivo se gira el tamaño pedido
     (8,5 × 5,5 → 5,5 × 8,5) para que tenga la misma orientación que el diseño.
     Se hace una vez por archivo; después manda el cliente, que además puede
     girarlo con el botón. */
  /* «A TU FORMA»: LA PROPORCIÓN LA PONE EL DISEÑO, no el cliente (como en los
     transfers). Si escribe el ancho, el alto sale solo, y al revés; y los dos
     campos enseñan siempre lo que de verdad se va a cortar (Xavi, 01/10: «las
     medidas no se actualizan»). Sin archivo no hay proporción: campos libres. */
  Subida.prototype.propIman = function () {
    var a = this.archivo;
    return a && a.px && a.px[0] > 0 ? a.px[1] / a.px[0] : 0;
  };
  Subida.prototype.ajustarLibreIman = function (base) {
    var st = this.iman, prop = this.propIman(), max = this.maxIman() || 120;
    if (!prop || st.forma !== 'libre') return;
    var lado = base === 'h' ? st.h : (base === 'w' ? st.w : Math.max(st.w, st.h));
    var w, h;
    if (base === 'h' || (!base && prop > 1)) { h = lado; w = h / prop; }
    else { w = lado; h = w * prop; }
    var k = Math.min(1, max / Math.max(w, h));
    st.w = Math.max(IMAN_MIN, w * k); st.h = Math.max(IMAN_MIN, h * k);
  };
  Subida.prototype.valoresIman = function () {
    var self = this, caja = $(this.root, '[data-opciones]');
    if (!caja) return;
    Array.prototype.forEach.call(caja.querySelectorAll('.sdtf-iman__campo input'), function (inp) {
      if (document.activeElement === inp) return;
      inp.value = String(Math.round(self.iman[inp.getAttribute('data-clave')] / 10 * 10) / 10);
    });
  };

  Subida.prototype.orientarIman = function (forzar) {
    var a = this.archivo, st = this.iman;
    if (!a || !a.px || !st || st.forma === 'redonda') return false;
    if (st.forma === 'libre') { this.ajustarLibreIman(); return true; }
    var prop = a.px[1] / a.px[0], vertical = prop > 1.05, horizontal = prop < 0.95;
    // pegatinas a medida: si el cliente aún no ha tocado el tamaño, la pegatina toma la proporción del diseño
    // (6 × 6 por defecto + diseño apaisado = pegatina cuadrada con fondo de sobra)
    if (this.cfg.libre && !st.tocado && (vertical || horizontal)) {
      // la medida cuenta el borde y el margen de seguridad: el diseño llena justo lo que queda dentro
      var lado = Math.max(st.w, st.h), w2, h2, m2 = 2 * Math.max(2, this.filete === false ? 2 : (this.borde || 2));
      if (prop > 1) { h2 = lado; w2 = (lado - m2) / prop + m2; } else { w2 = lado; h2 = (lado - m2) * prop + m2; }
      st.w = Math.max(IMAN_MIN, Math.round(w2 * 2) / 2); st.h = Math.max(IMAN_MIN, Math.round(h2 * 2) / 2);
      return true;
    }
    if ((vertical && st.w > st.h) || (horizontal && st.h > st.w)) {
      var t = st.w; st.w = st.h; st.h = t;
      return true;
    }
    return false;
  };

  // la caja más barata donde entra, con la cantidad que haya marcada
  Subida.prototype.ajustarCajaIman = function () {
    var self = this, f = this.formatoIman(), mejor = null;
    this.cajasIman().forEach(function (c) {
      var cabe = (f.w <= c.w && f.h <= c.h) || (f.w <= c.h && f.h <= c.w);
      if (!cabe) return;
      var v = self.cfg.variantes.filter(function (x) {
        return x.opts[self.iTam] === c.valor && x.opts.every(function (o, j) { return j === self.iTam || o === self.sel[j]; });
      })[0];
      if (v && (!mejor || v.precio < mejor.precio)) mejor = { valor: c.valor, precio: v.precio };
    });
    if (mejor) this.sel[this.iTam] = mejor.valor;
    return !!mejor;
  };

  Subida.prototype.pintarOpcionesIman = function () {
    var self = this, caja = $(this.root, '[data-opciones]');
    if (!caja || !this.valores || !this.iman) return;
    caja.innerHTML = '';
    var st = this.iman;
    this.ajustarCajaIman();

    // 0 · TIPO (y cualquier otra opción que no sea medida ni cantidad): Estándar / Resistente
    (this.cfg.opciones || []).forEach(function (nombre, i) {
      if (i === self.iTam || i === self.iCant) return;
      var vals = self.valores[i];
      if (!vals || vals.length < 2) return;
      var tt = document.createElement('p'); tt.className = 'sdtf-op__t'; tt.textContent = nombre; caja.appendChild(tt);
      var fl = document.createElement('div'); fl.className = 'sdtf-op__fila es-tipos';
      vals.forEach(function (val) {
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'sdtf-op__b' + (self.sel[i] === val ? ' is-on' : '');
        b.setAttribute('aria-pressed', self.sel[i] === val ? 'true' : 'false');
        var partes = String(val).split(/\s*·\s*/);
        var t1 = document.createElement('b'); t1.textContent = partes[0]; b.appendChild(t1);
        if (partes[1]) { var t2 = document.createElement('small'); t2.textContent = partes[1]; b.appendChild(t2); }
        b.addEventListener('click', function () {
          self.sel[i] = val;
          self.pintarOpcionesIman();
          self.actualizar();
        });
        fl.appendChild(b);
      });
      caja.appendChild(fl);
    });

    // 1 · FORMA
    var formas = document.createElement('div'); formas.className = 'sdtf-op__fila es-iman-formas';
    if (!this.cfg.formaFija) { var t1 = document.createElement('p'); t1.className = 'sdtf-op__t'; t1.textContent = 'Forma'; caja.appendChild(t1); }
    [['cuadrada', 'Rectangular', '3px'], ['redonda', 'Redonda', '50%'],
     ['libre', 'A tu forma', '28% 72% 38% 62% / 64% 30% 70% 36%']].forEach(function (o) {
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'sdtf-op__b' + (st.forma === o[0] ? ' is-on' : '');
      b.setAttribute('aria-pressed', st.forma === o[0] ? 'true' : 'false');
      var fig = document.createElement('span'); fig.className = 'sdtf-op__fig';
      var i2 = document.createElement('i'); i2.style.width = '34px'; i2.style.height = o[0] === 'cuadrada' ? '24px' : '34px';
      i2.style.borderRadius = o[2];
      if (o[0] === 'libre') {
        // silueta irregular, de troquel: nada que se parezca a un círculo
        i2.style.width = '44px'; i2.style.height = '36px'; i2.style.borderRadius = '0'; i2.style.border = '0';
        i2.style.clipPath = 'polygon(6% 34%, 22% 8%, 42% 18%, 60% 2%, 82% 14%, 98% 40%, 80% 58%, 94% 88%, 62% 78%, 40% 98%, 22% 74%, 2% 66%)';
        i2.style.background = 'var(--sdtf-verde, #27aa13)'; i2.style.opacity = '.55';
      }
      fig.appendChild(i2); b.appendChild(fig);
      var et = document.createElement('b'); et.textContent = o[1]; b.appendChild(et);
      b.addEventListener('click', function () {
        st.forma = o[0];
        self.zoom = null; self.panX = 0; self.panY = 0;
        if (o[0] === 'redonda') st.h = st.w;
        else if (o[0] === 'libre') self.ajustarLibreIman();
        self.ajustarCajaIman();
        self.pintarOpcionesIman();
        self.actualizar();
      });
      formas.appendChild(b);
    });
    if (!this.cfg.formaFija) caja.appendChild(formas);

    // 2 · TAMAÑO, el que quiera
    var t2 = document.createElement('p'); t2.className = 'sdtf-op__t';
    t2.textContent = st.forma === 'redonda' ? 'Diámetro' : (st.forma === 'libre' ? 'Tamaño máximo' : 'Tamaño');
    caja.appendChild(t2);
    var tam = document.createElement('div'); tam.className = 'sdtf-iman__tam';
    function campo(clave, etiqueta) {
      var l = document.createElement('label'); l.className = 'sdtf-iman__campo';
      var sp = document.createElement('span'); sp.textContent = etiqueta; l.appendChild(sp);
      var inp = document.createElement('input'); inp.type = 'number'; inp.step = '0.1'; inp.min = '2';
      inp.max = String(self.maxIman() / 10); inp.inputMode = 'decimal';
      inp.value = String(Math.round(st[clave] / 10 * 10) / 10);
      inp.setAttribute('aria-label', etiqueta + ' en centímetros');
      inp.setAttribute('data-clave', clave);
      var u = document.createElement('em'); u.textContent = 'cm';
      inp.addEventListener('input', function () {
        var n = parseFloat(String(inp.value).replace(',', '.'));
        if (!(n > 0)) return;
        st[clave] = n * 10; st.tocado = true;
        self.panX = 0; self.panY = 0;
        if (st.forma === 'redonda') st.h = st.w;
        else if (st.forma === 'libre') { self.ajustarLibreIman(clave); self.valoresIman(); }
        self.ajustarCajaIman();
        self.refrescarIman();
        self.actualizar();
      });
      l.appendChild(inp); l.appendChild(u);
      return l;
    }
    if (st.forma === 'redonda') {
      tam.appendChild(campo('w', 'Diámetro'));
    } else {
      tam.appendChild(campo('w', 'Ancho'));
      var por = document.createElement('span'); por.className = 'sdtf-iman__por'; por.textContent = '×'; tam.appendChild(por);
      tam.appendChild(campo('h', 'Alto'));
      var girar = document.createElement('button'); girar.type = 'button'; girar.className = 'sdtf-iman__girar';
      if (st.forma === 'libre' && self.propIman()) girar.hidden = true;
      girar.textContent = '⇄ Girar'; girar.title = 'Cambiar vertical por horizontal';
      girar.addEventListener('click', function () {
        var t = st.w; st.w = st.h; st.h = t; st.tocado = true;
        self.panX = 0; self.panY = 0;
        self.ajustarCajaIman();
        self.pintarOpcionesIman();
        self.actualizar();
      });
      tam.appendChild(girar);
    }
    caja.appendChild(tam);
    var presets = document.createElement('div'); presets.className = 'sdtf-iman__presets';
    (this.cfg.iman ? [[85, 55, 'Tarjeta 8,5 × 5,5'], [50, 50, '5 × 5'], [70, 70, '7 × 7'], [100, 70, '10 × 7']]
      : (st.forma === 'redonda' ? [[30, 30, '3 cm'], [40, 40, '4 cm'], [50, 50, '5 cm'], [60, 60, '6 cm'], [80, 80, '8 cm'], [100, 100, '10 cm']]
        : [[40, 40, '4 × 4'], [60, 60, '6 × 6'], [60, 40, '6 × 4'], [80, 50, '8 × 5'], [100, 60, '10 × 6'], [100, 100, '10 × 10']])).forEach(function (p) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'sdtf-iman__preset'; b.textContent = p[2];
      b.addEventListener('click', function () {
        self.panX = 0; self.panY = 0; st.tocado = true;
        if (st.forma === 'redonda') { st.w = Math.min(p[0], p[1]); st.h = st.w; } else { st.w = p[0]; st.h = p[1]; self.orientarIman(); }
        self.ajustarCajaIman();
        self.pintarOpcionesIman();
        self.actualizar();
      });
      presets.appendChild(b);
    });
    caja.appendChild(presets);
    var aviso = document.createElement('p'); aviso.className = 'sdtf-muted sdtf-iman__aviso'; aviso.setAttribute('data-iman-aviso', '');
    caja.appendChild(aviso);

    // 3 · CANTIDAD Y RESUMEN: se repintan al teclear el tamaño sin perder el foco
    var din = document.createElement('div'); din.setAttribute('data-iman-din', ''); caja.appendChild(din);
    this.refrescarIman();
  };

  // la parte que cambia con el tamaño: precios por cantidad y resumen
  Subida.prototype.refrescarIman = function () {
    var self = this, caja = $(this.root, '[data-opciones]');
    var din = caja && caja.querySelector('[data-iman-din]');
    if (!din) return;
    din.innerHTML = '';
    var st = this.iman, f = this.formatoIman(), max = this.maxIman();
    var aviso = caja.querySelector('[data-iman-aviso]');
    if (aviso) {
      var pasa = Math.max(st.w, st.forma === 'redonda' ? 0 : st.h) > max, poco = Math.min(st.w, st.forma === 'redonda' ? st.w : st.h) < IMAN_MIN;
      aviso.hidden = !(pasa || poco);
      aviso.textContent = pasa ? 'Hacemos hasta ' + fmt(max / 10, 0) + ' cm de lado. Para más grande, escríbenos y lo presupuestamos.'
        : (poco ? 'Por debajo de 2 cm ' + this.elNombre() + ' no se corta bien: lo dejamos en 2 cm.' : '');
    }

    if (this.libre() && window.Entrega && this.cfg.entrega) {
      this.pintarTablaPlazos(din);
    } else {
    var t3 = document.createElement('p'); t3.className = 'sdtf-op__t'; t3.textContent = 'Cantidad'; din.appendChild(t3);
    var fila = document.createElement('div'); fila.className = 'sdtf-op__fila es-cants';
    var cants = this.valores[this.iCant].slice().sort(function (a, b) { return cantidadDe(a) - cantidadDe(b); });
    cants.forEach(function (val) {
      var uds = cantidadDe(val), v2 = self.varianteCon(self.iCant, val);
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'sdtf-op__b' + (self.sel[self.iCant] === val ? ' is-on' : '');
      b.setAttribute('aria-pressed', self.sel[self.iCant] === val ? 'true' : 'false');
      var n = document.createElement('b'); n.textContent = String(uds); b.appendChild(n);
      if (v2) {
        var u = document.createElement('small'); u.textContent = money(Math.round(v2.precio / Math.max(1, uds))) + '/ud'; b.appendChild(u);
        if (self.cfg.destacada && uds === self.cfg.destacada) {
          var e2 = document.createElement('span'); e2.className = 'sdtf-op__eti'; e2.textContent = 'la que más cunde'; b.appendChild(e2);
        }
      }
      b.addEventListener('click', function () {
        self.sel[self.iCant] = val;
        self.ajustarCajaIman();
        self.refrescarIman();
        self.actualizar();
      });
      fila.appendChild(b);
    });
    din.appendChild(fila);
    }

    var v = this.varianteSel();
    var res = document.createElement('p'); res.className = 'sdtf-op__resumen';
    if (v) {
      var uds2 = unidadesDe(v.opts);
      var nombreForma = f.forma === 'redonda' ? this.gen('Redonda', 'Redondo') + ' de ' + fmt(f.w / 10, 1) + ' cm'
        : (f.forma === 'libre' ? 'A tu forma, hasta ' + fmt(f.w / 10, 1) + ' × ' + fmt(f.h / 10, 1) + ' cm'
          : fmt(f.w / 10, 1) + ' × ' + fmt(f.h / 10, 1) + ' cm');
      res.innerHTML = '<b>' + money(v.precio) + '</b> · ' + uds2 + ' ' + this.nombrePega(true) + ' · ' + esc(nombreForma) +
        (uds2 > 1 ? ' · ' + money(Math.round(v.precio / uds2)) + ' cada ' + this.gen('una', 'uno') : '') + ' · IVA incluido';
    }
    din.appendChild(res);
    this.pintarLlenar(din, v);
    if (!(this.libre() && window.Entrega && this.cfg.entrega)) this.pintarPlazo(din, v);
  };


  /* TABLA DE CANTIDAD × PLAZO (Xavi, 02/10, viendo la de otra imprenta: «me encanta este sistema de mostrar
     precios y plazos»). Cada fila es una cantidad y cada columna un plazo con su precio TOTAL, lo que sale cada
     unidad y la fecha. Pulsar una celda elige a la vez la cantidad y el plazo.
       Económico (6-7 días): el precio de la ficha.      Normal (4-5): ese precio + 5 % (línea «plazo normal»).
       Express (2-3): ese precio + el recargo de siempre por hojas (producto «entrega urgente»).
     LAS FECHAS SON SIEMPRE ESTIMADAS y así se dice (Xavi: «no quiero luego "oye que te he pagado urgencia para tal
     día"»): en la tabla, en el carrito y en la línea del pedido. */
  var RECARGO_NORMAL = 0.05;
  Subida.prototype.recargoNormal = function (baseCent) {
    var t = this.cfg.plazoNormal;
    if (!t || !t.length || !(baseCent > 0)) return null;
    var objetivo = Math.max(100, Math.round(baseCent * RECARGO_NORMAL / 100) * 100), mejor = null;
    t.forEach(function (x) { if (!mejor || Math.abs(x.precio - objetivo) < Math.abs(mejor.precio - objetivo)) mejor = x; });
    return mejor;
  };
  // la línea de «plazo normal» que toca AHORA (o null si no está elegido ese plazo)
  Subida.prototype.normalAhora = function () {
    if (!this.libre() || !this.cfg.entrega || (this.plazo || 'normal') !== 'normal') return null;
    var v = this.varianteSel ? this.varianteSel() : null;
    return v ? this.recargoNormal(v.precio + this.extraRepaso() + this.extraVector()) : null;
  };
  Subida.prototype.pintarTablaPlazos = function (din) {
    var self = this, cfg = this.cfg.entrega, ug = this.cfg.urgente;
    if (!this.plazo) this.plazo = 'normal';
    var t3 = document.createElement('p'); t3.className = 'sdtf-op__t'; t3.textContent = 'Cantidad y plazo de entrega'; din.appendChild(t3);
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    var dias = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    function corto(d) { return dias[d.getDay()] + ' ' + d.getDate() + ' ' + meses[d.getMonth()]; }
    function rangoTxt(r) {
      if (r[0].toDateString() === r[1].toDateString()) return corto(r[0]);
      return r[0].getMonth() === r[1].getMonth()
        ? r[0].getDate() + '–' + r[1].getDate() + ' ' + meses[r[1].getMonth()]
        : r[0].getDate() + ' ' + meses[r[0].getMonth()] + ' – ' + r[1].getDate() + ' ' + meses[r[1].getMonth()];
    }
    var tabla = document.createElement('div'); tabla.className = 'sdtf-tp'; tabla.setAttribute('role', 'group');
    tabla.setAttribute('aria-label', 'Cantidad y plazo de entrega estimado');
    [['Uds.', ''], ['Económico', '6-7 días'], ['Normal', '4-5 días'], ['Express', '2-3 días']].forEach(function (h, i) {
      var c = document.createElement('div'); c.className = 'sdtf-tp__h' + (i === 3 ? ' is-urg' : '');
      c.innerHTML = '<b>' + h[0] + '</b>' + (h[1] ? '<small>' + h[1] + '</small>' : ''); tabla.appendChild(c);
    });
    var cants = this.valores[this.iCant].slice().sort(function (a, b) { return cantidadDe(a) - cantidadDe(b); });
    var extra0 = this.extraRepaso() + this.extraVector();
    var hojasSel = 0;
    cants.forEach(function (val) {
      var uds = cantidadDe(val), v2 = self.varianteCon(self.iCant, val);
      if (!v2) return;
      var hojas = self.hojasDe(v2, uds), base = v2.precio + extra0;
      var uv = ug ? self.urgentePara(hojas) : null;
      var nv = self.recargoNormal(base);
      var totalN = base + (nv ? nv.precio : 0);
      var hayE = !!uv && (base + uv.precio) > totalN;
      var esSel = self.sel[self.iCant] === val;
      if (esSel) { hojasSel = hojas; if (self.plazo === 'express' && !hayE) self.plazo = 'normal'; if (self.plazo === 'normal' && !nv) self.plazo = 'eco'; }

      var q = document.createElement('div'); q.className = 'sdtf-tp__q'; q.innerHTML = '<b>' + uds + '</b>'; tabla.appendChild(q);
      function celda(plazo, total, texto) {
        var on = esSel && self.plazo === plazo;
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'sdtf-tp__c' + (plazo === 'express' ? ' is-urg' : '') + (on ? ' is-on' : '');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.innerHTML = '<b>' + money(total) + '</b><small>' + money(Math.round(total / Math.max(1, uds))) + '/ud</small><span>' + texto + '</span>';
        b.addEventListener('click', function () {
          self.sel[self.iCant] = val; self.plazo = plazo; self.urgente = plazo === 'express';
          self.ajustarCajaIman(); self.refrescarIman(); self.actualizar();
        });
        tabla.appendChild(b);
      }
      celda('eco', base, rangoTxt(Entrega.rangoPlazo(cfg, 'eco', null, hojas)));
      if (nv) celda('normal', totalN, rangoTxt(Entrega.rangoPlazo(cfg, 'normal', null, hojas)));
      else { var v0 = document.createElement('div'); v0.className = 'sdtf-tp__no'; v0.textContent = '—'; tabla.appendChild(v0); }
      if (hayE) celda('express', base + uv.precio, rangoTxt(Entrega.rangoPlazo(cfg, 'express', null, hojas)));
      else { var vacio = document.createElement('div'); vacio.className = 'sdtf-tp__no'; vacio.textContent = '—'; tabla.appendChild(vacio); }
    });
    this.urgente = this.plazo === 'express';
    din.appendChild(tabla);
    var nota = document.createElement('p'); nota.className = 'sdtf-muted sdtf-tp__nota';
    nota.innerHTML = '<b>Fechas de entrega estimadas</b>, en días laborables a península, contando desde que el diseño está listo y ' +
      'con el pedido hecho antes de las 12:00. No son una fecha garantizada: pueden variar por causas ajenas al taller ' +
      '(transportista, incidencias). El Express solo sale donde el taller puede hacerlo. Precios con IVA incluido.';
    din.appendChild(nota);
    this.pintarEntregaArriba(hojasSel);
  };

  /* El campo «¿Otra cantidad?» de las chapas: desde 10, sin tope práctico. Cuenta clara debajo: cuántas, a cuánto cada
     una y el total. Si un pack de más unidades sale más barato que lo que escribe, se le dice (sin cambiarle nada). */
  Subida.prototype.pintarLibre = function (iCant, fila) {
    var self = this, d = document.createElement('div'); d.className = 'sdtf-libre';
    var l = document.createElement('label'); l.className = 'sdtf-libre__l';
    var t = document.createElement('span'); t.textContent = '¿Otra cantidad?';
    var inp = document.createElement('input');
    inp.type = 'text'; inp.inputMode = 'numeric'; inp.pattern = '[0-9]*'; inp.autocomplete = 'off';
    inp.placeholder = 'Ej. 70'; inp.className = 'sdtf-libre__i'; inp.setAttribute('aria-label', 'Otra cantidad de chapas');
    inp.value = this._libreTxt != null ? this._libreTxt : (this.cantLibre ? String(this.cantLibre) : '');
    l.appendChild(t); l.appendChild(inp);
    var msg = document.createElement('p'); msg.className = 'sdtf-libre__m'; msg.setAttribute('aria-live', 'polite');
    d.appendChild(l); d.appendChild(msg);
    var nom = this.nombrePega(true);
    function pintarMsg() {
      msg.innerHTML = '';
      var n = parseInt(inp.value, 10);
      if (!inp.value) { msg.textContent = 'Desde ' + ESCALONES[0] + ' ' + nom + '. Se cobra al precio por unidad de su escalón.'; return; }
      if (!(n >= ESCALONES[0])) { msg.textContent = 'El mínimo son ' + ESCALONES[0] + ' ' + nom + '.'; return; }
      if (n > LIBRE_MAX) { msg.textContent = 'Para más de ' + LIBRE_MAX + ' escríbenos y te hacemos un precio.'; return; }
      var v = self.variante();
      if (!v || !v._libre) return;
      var b = document.createElement('b'); b.textContent = money(v.precio);
      msg.appendChild(b);
      msg.appendChild(document.createTextNode(' · ' + n + ' ' + nom + ' · ' + money(v._unit) + ' cada ' + self.gen('una', 'uno') + ' · IVA incluido'));
      // ¿algún pack de más unidades cuesta menos que esto? Se avisa, sin cambiar nada
      var iU = v.opts.length, base = v._pack;
      base.opts.forEach(function (o, i) { if (/ud/i.test(o)) iU = i; });
      var mejor = null;
      self.cfg.variantes.forEach(function (x) {
        if (!x.opts.every(function (o, i) { return i === iU || o === base.opts[i]; })) return;
        var u = cantidadDe(x.opts[iU]);
        if (u > n && x.precio <= v.precio && (!mejor || u < mejor.u)) mejor = { u: u, v: x };
      });
      if (mejor) {
        var s2 = document.createElement('span'); s2.className = 'sdtf-libre__sug';
        s2.appendChild(document.createTextNode(' El pack de ' + mejor.u + ' sale a ' + money(mejor.v.precio) + ', menos de lo que cuestan ' + n + ' ' + nom + '. '));
        var bt = document.createElement('button'); bt.type = 'button'; bt.className = 'sdtf-libre__bt'; bt.textContent = 'Elegir el de ' + mejor.u;
        bt.addEventListener('click', function () {
          self.sel[iCant] = mejor.v.opts[iU]; self.cantLibre = null; self._libreMala = false; self._libreTxt = null;
          self.pintarOpciones(); self.actualizar();
        });
        s2.appendChild(bt);
        msg.appendChild(document.createElement('br')); msg.appendChild(s2);
      }
    }
    inp.addEventListener('input', function () {
      var limpio = inp.value.replace(/\D/g, '').slice(0, 5);
      var n = parseInt(limpio, 10);
      self._libreTxt = limpio;
      // escrito pero no válido (menos de 10, o demasiado): no se añade nada hasta que lo arregle
      self._libreMala = limpio !== '' && !(n >= ESCALONES[0] && n <= LIBRE_MAX);
      if (n >= ESCALONES[0] && n <= LIBRE_MAX) {
        self.cantLibre = n;
        var piso = ESCALONES[0];
        ESCALONES.forEach(function (e) { if (e <= n) piso = e; });
        self.sel[iCant] = piso + ' uds';
      } else {
        self.cantLibre = null;
      }
      // se repinta todo (precio de plazos incluido) y el cursor vuelve al campo, al final
      self.pintarOpciones();
      self.actualizar();
      var ni = self.root.querySelector('.sdtf-libre__i');
      if (ni) { ni.focus(); try { ni.setSelectionRange(ni.value.length, ni.value.length); } catch (e) { /* sin cursor */ } }
    });
    pintarMsg();
    return d;
  };

  Subida.prototype.pintarOpciones = function () {
    if (this.libre()) return this.pintarOpcionesIman();
    var self = this, r = this.root, caja = $(r, '[data-opciones]');
    if (!caja || !this.valores) return;
    var nombres = this.cfg.opciones || [];
    caja.innerHTML = '';

    // para dibujar los tamaños a escala hace falta saber cuál es el mayor
    var mayor = 0;
    this.valores.forEach(function (vals) {
      vals.forEach(function (v) {
        var f = window.PegatinaCorte && PegatinaCorte.formatoDe(v);
        if (f) mayor = Math.max(mayor, f.w, f.h);
      });
    });

    nombres.forEach(function (nombre, i) {
      var vals = self.valores[i];
      if (!vals || vals.length < 2) return;
      var esCantidad = /cantidad/i.test(nombre);
      var esForma = vals.some(function (v) { return window.PegatinaCorte && PegatinaCorte.formatoDe(v); });

      var tit = document.createElement('p');
      tit.className = 'sdtf-op__t';
      tit.textContent = esForma ? nombre + ' — a escala entre ellos' : nombre;
      caja.appendChild(tit);

      var fila = document.createElement('div');
      fila.className = 'sdtf-op__fila' + (esForma ? ' es-formas' : (esCantidad ? ' es-cants' : ' es-tipos'));
      vals.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        var marcado = self.sel[i] === val && !(esCantidad && (self.cantLibre || self._libreMala));
        b.className = 'sdtf-op__b' + (marcado ? ' is-on' : '');
        b.setAttribute('aria-pressed', marcado ? 'true' : 'false');

        var f = window.PegatinaCorte && PegatinaCorte.formatoDe(val);
        if (esForma && f) {
          var fig = document.createElement('span');
          fig.className = 'sdtf-op__fig';
          var i2 = document.createElement('i');
          /* A escala, pero no lineal: entre 3 y 10 cm hay un factor 3,3 y con
             escala recta la de 3 cm queda en una mota que no dice nada. Con
             una potencia de 0,7 se sigue viendo clarísimo cuál es mayor y la
             pequeña sigue pareciendo una pegatina. */
          var esc3 = function (mm) {
            return Math.max(14, Math.round(46 * Math.pow(mm / (mayor || 100), 0.7)));
          };
          i2.style.width = esc3(f.w) + 'px';
          i2.style.height = esc3(f.h) + 'px';
          if (f.forma === 'redonda') i2.style.borderRadius = '50%';
          else if (f.forma === 'libre') i2.style.borderRadius = '46% 54% 58% 42% / 52% 44% 56% 48%';
          else i2.style.borderRadius = '3px';
          fig.appendChild(i2);
          b.appendChild(fig);
          var et = document.createElement('b');
          /* LAS CHAPAS SE MIDEN EN MM DE VERDAD (25, 31, 38…), no en cm×10
             como las pegatinas: dividir entre 10 aquí las dejaba en «3 cm»,
             «4 cm»… todas mal — Xavi, 28/09: «no salen bien los mm». */
          et.textContent = self.cfg.chapa
            ? (f.w === f.h ? fmt(f.w, 0) + ' mm' : fmt(f.w, 0) + ' × ' + fmt(f.h, 0) + ' mm')
            : (f.w === f.h ? fmt(f.w / 10, 0) + ' cm' : fmt(f.w / 10, 0) + ' × ' + fmt(f.h / 10, 0) + ' cm');
          b.appendChild(et);
        } else if (esCantidad) {
          var uds2 = cantidadDe(val);
          var n = document.createElement('b');
          n.textContent = String(uds2);
          b.appendChild(n);
          var v2 = self.varianteCon(i, val);
          if (v2) {
            // el escalón más pequeño de la lista es la referencia honesta
            var menor = vals.slice().sort(function (a, c) { return cantidadDe(a) - cantidadDe(c); })[0];
            /* SOLO EL PRECIO POR UNIDAD. Aquí iba además el «−17 %» de cada
               escalón. Xavi: «yo esos porcentajes los quitaria no quedan
               esteticos y la gente solo quiere saber el precio». Y es verdad
               que el ahorro ya se ve solo: los euros por unidad van bajando
               fila a fila, que es el mismo dato sin el ruido. El cálculo del
               porcentaje se queda en el código para el aviso de «mismo precio
               que 25», que ese sí dice algo que no se ve. */
            var pct = ahorroUnidad(self.varianteCon(i, menor), cantidadDe(menor), v2, uds2);
            var u = document.createElement('small');
            u.textContent = money(Math.round(v2.precio / Math.max(1, uds2))) + '/ud';
            if (pct) u.title = 'Un ' + pct + ' % menos por unidad que comprando ' + cantidadDe(menor);
            b.appendChild(u);
            /* DOS ETIQUETAS, y ninguna inventada:
               - "mismo precio que 25": sale sola cuando un escalón cuesta lo
                 mismo que uno más pequeño. Pasa con el mínimo de 20 €, y es
                 tontería no llevarse el doble por el mismo dinero.
               - la destacada: la marca Xavi desde la ficha, porque cuál deja
                 más margen depende de su coste, no del precio de venta. */
            var mismo = null;
            vals.forEach(function (otro) {
              var vo = self.varianteCon(i, otro);
              if (!vo || vo.precio !== v2.precio) return;
              var uo = cantidadDe(otro);
              if (uo < uds2 && (mismo == null || uo < mismo)) mismo = uo;
            });
            if (mismo != null) {
              var e1 = document.createElement('span');
              e1.className = 'sdtf-op__eti sdtf-op__eti--gratis';
              e1.textContent = 'mismo precio que ' + mismo;
              b.appendChild(e1);
            } else if (self.cfg.destacada && uds2 === self.cfg.destacada) {
              var e2 = document.createElement('span');
              e2.className = 'sdtf-op__eti';
              e2.textContent = 'la que más cunde';
              b.appendChild(e2);
            }
          }
        } else {
          // "Estándar · interior" -> título y explicación en dos líneas
          var partes = String(val).split(/\s*·\s*/);
          var t1 = document.createElement('b');
          t1.textContent = partes[0];
          b.appendChild(t1);
          if (partes[1]) {
            var t2 = document.createElement('small');
            t2.textContent = partes[1];
            b.appendChild(t2);
          }
        }

        b.addEventListener('click', function () {
          self.sel[i] = val;
          if (esCantidad) { self.cantLibre = null; self._libreMala = false; self._libreTxt = null; }     // eligió un pack: se acaba la cantidad a medida
          self.pintarOpciones();
          self.actualizar();
        });
        fila.appendChild(b);
      });
      caja.appendChild(fila);
      if (esCantidad && self.libreVale()) caja.appendChild(self.pintarLibre(i, fila));
    });

    var v = this.cantLibre ? this.variante() : this.varianteSel();   // con cantidad a medida, el resumen es el suyo
    var res = document.createElement('p');
    res.className = 'sdtf-op__resumen';
    res.hidden = !!this.cantLibre;   // con cantidad a medida, ya lo cuenta el campo de debajo
    if (v) {
      var uds = unidadesDe(v.opts);
      var forma = v.opts.filter(function (o) { return window.PegatinaCorte && PegatinaCorte.formatoDe(o); })[0] || '';
      res.innerHTML = '<b>' + money(v.precio) + '</b> · ' + uds + ' ' + this.nombrePega(true) +
        (forma ? ' · ' + esc(forma) : '') +
        (uds > 1 ? ' · ' + money(Math.round(v.precio / uds)) + ' cada ' + this.gen('una', 'uno') : '') + ' · IVA incluido';
    }
    caja.appendChild(res);
    this.pintarLlenar(caja, v);
    this.pintarPlazo(caja, v);
  };

  /* LLENAR LAS HOJAS QUE YA SE VAN A USAR.
   *
   * Xavi: «¿sería lógico en vez de poner 100 pegatinas poner la cantidad más
   * cercana sin usar hojas a medias?». La idea es buena —él paga por hoja, no
   * por pegatina—, pero con cantidades de 77 o 154 el cliente se lía, y el
   * hueco que deja un pedido lo llena otro en el panel. Así que se hace al
   * revés: la escalera sigue siendo redonda, y cuando el escalón de arriba
   * CABE EN LAS MISMAS HOJAS, se le dice. Para el cliente es un chollo de
   * verdad; para el taller, más ticket con las mismas hojas y el mismo minuto
   * de cargar.
   *
   * Solo sale cuando el escalón siguiente no gasta ni una hoja más. Los
   * precios son los de la propia escalera: aquí no se inventa ningún
   * descuento. */
  Subida.prototype.pintarLlenar = function (caja, v) {
    if (!caja || !v || !this.cfg.pegatina) return;
    var self = this, nombres = this.cfg.opciones || [];
    var iq = -1;
    nombres.forEach(function (n, i) { if (/cantidad/i.test(n)) iq = i; });
    if (iq < 0 || !this.valores || !this.valores[iq]) return;
    var uds = unidadesDe(v.opts);
    var hojas = this.hojasDe(v, uds);
    if (!hojas) return;
    // el escalón inmediatamente superior, con todo lo demás igual
    var sig = null;
    this.valores[iq].forEach(function (val) {
      var w = self.varianteCon(iq, val);
      if (!w) return;
      var u = unidadesDe(w.opts);
      if (u > uds && (!sig || u < unidadesDe(sig.opts))) sig = w;
    });
    if (!sig) return;
    var uds2 = unidadesDe(sig.opts);
    if (this.hojasDe(sig, uds2) > hojas) return;       // gasta más hojas: no
    var dif = sig.precio - v.precio;
    var val2 = sig.opts[iq];
    var p = document.createElement('div');
    p.className = 'sdtf-llenar';
    p.setAttribute('data-llenar', '');
    p.innerHTML = '<p><b>Con ' + uds2 + ' aprovechas mejor el pedido.</b> ' +
      (dif > 0
        ? 'Por ' + money(dif) + ' más te llevas ' + (uds2 - uds) + ' ' + this.nombrePega(true) + ' más (' +
          money(Math.round(sig.precio / uds2)) + ' cada ' + this.gen('una', 'uno') + ' en vez de ' + money(Math.round(v.precio / uds)) + ').'
        : 'Te llevas ' + (uds2 - uds) + ' ' + this.nombrePega(true) + ' más por el mismo precio.') +
      '</p><button type="button" class="sdtf-llenar__b">Pasar a ' + uds2 + '</button>';
    p.querySelector('button').addEventListener('click', function () {
      self.sel[iq] = val2;
      self.pintarOpciones();
      self.actualizar();
    });
    caja.appendChild(p);
  };

  /* ---------- CUÁNDO LO TIENES, al lado de cuánto cuesta ----------
   *
   * La idea es de una imprenta que Xavi vio: enseñan una rejilla de cantidad ×
   * plazo con el precio en cada casilla. El fondo es bueno —el plazo es un
   * producto y se puede cobrar—, pero la rejilla en un móvil es letra de tres
   * columnas y ahí no se lee nada. Aquí va lo mismo partido en dos pasos: la
   * escalera de cantidades que ya estaba, y debajo UN interruptor de plazo con
   * la fecha de verdad en cada opción y el recargo en euros, nunca en %.
   *
   * La fecha la calcula `entrega.js`, que ya la pinta en las fichas de ropa, y
   * promete siempre por lo alto.
   *
   * El botón de urgente se esconde solo cuando no adelanta nada: un sábado a
   * las ocho, urgente y normal caen el mismo día, y cobrar 12 € por la misma
   * fecha es engañar al cliente.
   */
  Subida.prototype.pintarPlazo = function (caja, v) {
    var self = this, cfg = this.cfg.entrega, ug = this.cfg.urgente;
    if (!caja || !cfg || !window.Entrega) return;
    var uds = v ? unidadesDe(v.opts) : 0;
    /* EL PLAZO SE MIDE EN HOJAS, NO EN UNIDADES. Xavi: «plazo haría por
       cantidades también, mejor no liarse con 1000 pegatinas en 24 h». Pero la
       cantidad sola no dice nada: mil de 3 cm son 13 hojas y mil de 10 cm son
       167. Lo que ocupa la mañana es cargar hojas, así que se cuentan hojas y
       el plazo se ajusta solo al tamaño sin tener que escribir una tabla. */
    var hojas = this.hojasDe(v, uds);
    var pronto = Entrega.rango(cfg, false, null, hojas)[0];

    /* LA URGENCIA SE COBRA POR HOJAS. Xavi: «no es lo mismo pasar por el
       plotter 4 hojas que 20». Cada número de hojas es una variante del
       producto «Pegatinas · entrega urgente» con su precio, y la ficha coge la
       que toca. Si el pedido pasa de la última variante (o del tope de
       unidades), no cabe en un hueco del día y no se ofrece. */
    var uv = this.urgentePara(hojas);
    var tope = !!ug && (!uv || (ug.topeUds && uds > ug.topeUds));
    var hay = !!uv && !tope;
    // y tampoco si no adelanta nada: cobrar por la misma fecha es engañar
    if (hay && Entrega.rango(cfg, true, null, hojas)[0] >= pronto) hay = false;
    if (!hay) this.urgente = false;

    this.pintarEntregaArriba(hojas);

    var blk = document.createElement('div');
    blk.className = 'sdtf-plazo';
    blk.setAttribute('data-plazo', '');

    /* Sin opción de pagar por la prisa no hay nada que elegir: la fecha se
       dice y ya. Un botón solo, marcado y sin alternativa, parece roto. */
    if (!hay) {
      var solo = document.createElement('p');
      solo.className = 'sdtf-plazo__fecha';
      solo.innerHTML = Entrega.texto(cfg, false, null, hojas);
      blk.appendChild(solo);
      if (tope && ug) blk.appendChild(this.noUrgente(ug, uds, hojas));
      caja.appendChild(blk);
      return;
    }

    /* EL TOTAL DE CADA OPCIÓN, NO EL RECARGO. Xavi, mirando otras tiendas: «en
       ambos casos el precio total, no ponen el extra». El cliente no quiere
       sumar: quiere ver dos precios y elegir. Y al lado, la FECHA de verdad,
       no un «1-2 días». */
    var base = (v ? v.precio : 0) + this.extraRepaso() + this.extraVector();
    [[false, 'Normal', base], [true, 'Urgente', base + uv.precio]].forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sdtf-plazo__b' + (!!self.urgente === o[0] ? ' is-on' : '');
      b.innerHTML = '<b>' + o[1] + '</b><span>' + Entrega.texto(cfg, o[0], null, hojas) +
        '</span><em>' + money(o[2]) + '</em>';
      b.addEventListener('click', function () {
        self.urgente = o[0];
        self.pintarOpciones();
        self.actualizar();
      });
      blk.appendChild(b);
    });
    caja.appendChild(blk);
  };

  /* La variante de urgencia para ese número de hojas: la primera que llegue.
     null si el pedido tiene más hojas que la última variante. */
  Subida.prototype.urgentePara = function (hojas) {
    var ug = this.cfg.urgente, t = ug && ug.porHojas;
    if (!t || !(hojas > 0)) return null;
    var ns = Object.keys(t).map(Number).filter(function (n) { return n > 0; }).sort(function (a, b) { return a - b; });
    for (var i = 0; i < ns.length; i++) if (ns[i] >= hojas) return t[ns[i]];
    return null;
  };
  Subida.prototype.topeHojas = function () {
    var t = this.cfg.urgente && this.cfg.urgente.porHojas;
    return t ? Math.max.apply(null, Object.keys(t).map(Number)) : 0;
  };

  /* LA FECHA ARRIBA, COMO EN LAS CAMISETAS. Xavi: «si ya pones las fechas
     como en las camisetas ya mucho mejor». Es la primera pregunta de un
     cliente, antes que el precio, así que va en la caja verde de arriba del
     todo y cambia en cuanto marca la urgente. */
  Subida.prototype.pintarEntregaArriba = function (hojas) {
    var el = $(this.root, '[data-entrega-arriba]'), cfg = this.cfg.entrega;
    if (!el || !cfg || !window.Entrega) return;
    el.innerHTML = (this.libre() && Entrega.textoPlazo)
      ? Entrega.textoPlazo(cfg, this.plazo || 'normal', null, hojas)
      : Entrega.texto(cfg, !!this.urgente, null, hojas);
    el.hidden = false;
  };

  /* CUANDO NO CABE, SE DICE POR QUÉ Y HASTA CUÁNTO. Callarse aquí es perder la
     venta: el que necesita 500 para mañana y ve que hasta 250 sí se puede, a lo
     mejor pide 250 y el resto para la semana que viene. Es la misma regla que
     ya sigue la ficha de ropa. */
  Subida.prototype.noUrgente = function (ug, uds, hojas) {
    var maxUds = ug.topeUds || 0, maxHojas = this.topeHojas();
    if (maxHojas && hojas > 0 && uds > 0) {
      var cabenHoja = Math.max(1, Math.round(uds / hojas));
      var porTiempo = maxHojas * cabenHoja;
      maxUds = maxUds ? Math.min(maxUds, porTiempo) : porTiempo;
    }
    var no = document.createElement('p');
    no.className = 'sdtf-plazo__no';
    no.textContent = maxUds
      ? 'La entrega urgente la podemos garantizar hasta ' + maxUds +
        ' ' + this.nombrePega(true) + ' de este tamaño. Por encima necesitamos los días de arriba.'
      : 'Este pedido es demasiado grande para la entrega urgente.';
    return no;
  };

  /* Las hojas de plóter que ocupa el pedido. Si todavía no hay corte calculado
     —el cliente aún no ha subido nada— se tira del formato, que ya se sabe en
     cuanto elige el tamaño. */
  Subida.prototype.hojasDe = function (v, uds) {
    if (!uds || !window.PegatinaCorte || !PegatinaCorte.porHoja) return 0;
    var c = this.calculo();
    var w = c && c.plan ? c.plan.cutW : 0, h = c && c.plan ? c.plan.cutH : 0;
    if (!w && v) {
      var f = this.formatoVar(v);
      if (f) {
        var borde = PegatinaCorte.bordePara(f);
        w = (f.forma === 'redonda' ? Math.min(f.w, f.h) : f.w) + 2 * borde;
        h = (f.forma === 'redonda' ? Math.min(f.w, f.h) : f.h) + 2 * borde;
      }
    }
    var caben = PegatinaCorte.porHoja(w, h);
    return caben ? Math.ceil(uds / caben) : 0;
  };

  /* Variante elegida, por orden de quién manda:
       1. el selector propio de las pegatinas,
       2. el ancho en cm que ha escrito (transfers): la caja más barata donde
          entra, que es lo que el cliente ha pedido de verdad,
       3. y si no, lo que diga el selector del tema. */
  Subida.prototype.variante = function () {
    var propia = this.varianteSel();
    if (propia) return propia;
    var porAncho = this.porAncho();
    if (porAncho) return porAncho;
    return this.baseVariante();
  };

  /* CHAPAS: CANTIDAD A MEDIDA (Xavi, 05/10/2026: «hay precios por escalón pero pueden pedir la cantidad que
     quieran; si necesitan 70, ¿para qué van a pedir 100?»). El cliente escribe cuántas quiere (desde 10) y se
     le cobra N × el precio por chapa del escalón de abajo (70 = 70 × el precio de una chapa del escalón de
     50). Para que el resto de la ficha (precio, botón, resumen) funcione sin tocarlo, `variante()` devuelve
     entonces una variante SINTÉTICA: la del producto oculto «chapas-cantidad-a-medida» (una variante por
     medida × acabado × escalón, a precio de chapa suelta), con el precio ya multiplicado y N en sus opciones. */
  var ESCALONES = [10, 25, 50, 100, 250, 500], LIBRE_MAX = 10000;
  Subida.prototype.libreVale = function () {
    return !!(this.cfg.chapa && this.cfg.cantLibre && this.cfg.cantLibre.length);
  };
  Subida.prototype.sintetica = function (v) {
    var n = this.cantLibre, lista = this.cfg.cantLibre;
    if (!v || !n || !lista) return v;
    var piso = ESCALONES[0];
    ESCALONES.forEach(function (e) { if (e <= n) piso = e; });
    var iU = -1;
    v.opts.forEach(function (o, i) { if (/ud/i.test(o)) iU = i; });
    if (iU < 0) return v;
    var buscar = v.opts.slice(); buscar[iU] = piso + ' uds';
    var u = lista.filter(function (x) { return x.opts.every(function (o, i) { return o === buscar[i]; }); })[0];
    if (!u) return v;
    var nuevo = {};
    for (var k in v) { if (Object.prototype.hasOwnProperty.call(v, k)) nuevo[k] = v[k]; }
    nuevo.id = u.id;
    nuevo.precio = u.precio * n;
    nuevo.opts = v.opts.map(function (o, i) { return i === iU ? n + ' uds' : o; });
    nuevo._libre = n; nuevo._unit = u.precio; nuevo._piso = piso; nuevo._pack = v;
    return nuevo;
  };
  var varianteBase = Subida.prototype.variante;
  Subida.prototype.variante = function () {
    var v = varianteBase.call(this);
    return (v && this.cantLibre) ? this.sintetica(v) : v;
  };

  Subida.prototype.cargar = async function (file, extra) {
    if (!file) return;
    if (file.size > this.cfg.maxFileMb * 1048576) { return this.flash(file.name + ': pesa más de ' + this.cfg.maxFileMb + ' MB. Mándanoslo por WhatsApp.'); }
    /* TODO LO QUE SUBE ARCHIVO AQUÍ (transfers DTF, pegatinas, imanes, chapas): SOLO PNG, JPG Y WEBP, los formatos que la web puede enseñar en la previa (Xavi, 02/10 y 14/10: «acepta PDF pero en cuanto le subo un PDF no va»).
       El PDF y el AI no se pueden previsualizar ni cortar desde la web, así que no se aceptan, tampoco arrastrados. */
    if (!extra && !/^image\/(png|jpe?g|webp)$/i.test(file.type || '') && !/\.(png|jpe?g|webp)$/i.test(file.name)) {
      return this.flash('Sube el diseño en PNG, JPG o WEBP. Los PDF y AI no los podemos previsualizar aquí: expórtalo como PNG o JPG.');
    }
    if (!extra && !this._cargandoTexto) { this._texto = null; }
    var dato = { file: file, name: file.name, px: null, transparente: null };
    if (extra) {
      dato.anterior = extra.anterior; dato.arreglos = extra.arreglos || [];
      dato.comparativa = extra.comparativa || null;
      // afinar amplía el archivo, pero NO añade detalle: la calidad se sigue
      // midiendo con los píxeles de verdad del original. Nada de maquillar.
      if (dato.arreglos[dato.arreglos.length - 1] === 'bordes') {
        dato.pxCalidad = extra.anterior.pxCalidad || extra.anterior.px;
      }
      dato.auto = !!extra.auto;
      // el nivel de tolerancia con el que se recortó, para poder subir o bajar
      if (extra.tolFondo != null) dato.tolFondo = extra.tolFondo;
    } else dato.arreglos = [];
    /* El análisis de píxeles ocupa el hilo principal, así que primero se tapa
       la zona y se deja pintar; si no, el cliente ve la página congelada. */
    var destapar = function () {};
    if (window.Cargando && /png|jpe?g|webp/i.test(file.type)) {
      var zona = this.archivo ? $(this.root, '[data-archivo]') : $(this.root, '[data-drop]');
      destapar = Cargando.velo(zona,
        extra ? 'Aplicando el arreglo…' : 'Leyendo el diseño…',
        extra ? null : 'Comprobamos medidas, resolución y fondo');
      await Cargando.pinta();
    }
    if (/png|jpe?g|webp/i.test(file.type)) {
      try {
        var bmp = await createImageBitmap(file);
        var W = bmp.width, H = bmp.height;
        var escala = Math.min(1, Math.sqrt(4e6 / (W * H)));
        var cw = Math.max(1, Math.round(W * escala)), ch = Math.max(1, Math.round(H * escala));
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(bmp, 0, 0, cw, ch);
        var d = ctx.getImageData(0, 0, cw, ch).data;
        var minX = cw, minY = ch, maxX = -1, maxY = -1, transp = false;
        for (var y0 = 0; y0 < ch && !transp; y0++) for (var x0 = 0; x0 < cw; x0 += 7) { if (d[(y0 * cw + x0) * 4 + 3] < 250) { transp = true; break; } }
        /* SOMBRAS (Xavi, 14/10): en una pegatina con PNG recortado, una sombra difuminada no cuenta para la medida (ni para el precio) */
        var sombraPx = (transp && this.cfg.pegatina && window.PegatinaCorte && PegatinaCorte.sombraAlfa) ? PegatinaCorte.sombraAlfa(d, cw, ch, 3) : null;
        for (var y = 0; y < ch; y++) for (var x = 0; x < cw; x++) {
          var a = d[(y * cw + x) * 4 + 3];
          if (a < 250) transp = true;
          if (sombraPx && sombraPx[y * cw + x]) continue;
          if (a >= 8) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
        }
        if (maxX < 0) { if (bmp.close) bmp.close(); destapar(); return this.flash(file.name + ': la imagen está vacía.'); }
        /* MARGEN LISO FUERA (Xavi, 26/09: «cropar todo el negro o blanco
           automáticamente»). Un JPG sin transparencia no tiene alfa que
           recortar, así que el margen blanco o negro entraba en la medida:
           pedía 25 cm y el dibujo salía de 20. Si el borde entero es de un
           color liso, se mide y se manda solo lo que hay dentro. En
           pegatinas no: ahí un marco puede ser parte del diseño. */
        var pre = { x: minX, y: minY, X: maxX, Y: maxY };   // antes de quitar margen
        if (!transp && !this.cfg.pegatina && window.ImgArreglo && ImgArreglo.margenLiso) {
          var mg = ImgArreglo.margenLiso(d, cw, ch);
          if (mg) { minX = mg.x; minY = mg.y; maxX = mg.X; maxY = mg.Y; dato.margenQuitado = true; }
        }
        var caja = {
          x: Math.floor(minX / escala), y: Math.floor(minY / escala),
          w: Math.ceil((maxX + 1 - minX) / escala), h: Math.ceil((maxY + 1 - minY) / escala)
        };
        var t = Math.min(1, 320 / Math.max(caja.w, caja.h));
        var th = document.createElement('canvas');
        th.width = Math.max(1, Math.round(caja.w * t)); th.height = Math.max(1, Math.round(caja.h * t));
        th.getContext('2d').drawImage(bmp, caja.x, caja.y, caja.w, caja.h, 0, 0, th.width, th.height);
        /* Las sondas del fondo (¿blanco?, ¿recuadro negro?, ¿se separa?) miran
           el archivo CON su margen: es justo el margen lo que tienen que ver. */
        var tp = th;
        if (dato.margenQuitado) {
          var cp = { x: Math.floor(pre.x / escala), y: Math.floor(pre.y / escala),
            w: Math.ceil((pre.X + 1 - pre.x) / escala), h: Math.ceil((pre.Y + 1 - pre.y) / escala) };
          var tt = Math.min(1, 320 / Math.max(cp.w, cp.h));
          tp = document.createElement('canvas');
          tp.width = Math.max(1, Math.round(cp.w * tt)); tp.height = Math.max(1, Math.round(cp.h * tt));
          tp.getContext('2d').drawImage(bmp, cp.x, cp.y, cp.w, cp.h, 0, 0, tp.width, tp.height);
        }
        if (bmp.close) bmp.close();
        dato.px = [caja.w, caja.h]; dato.caja = caja; dato.transparente = transp; dato.thumb = th;
        if (window.ImgArreglo) {
          dato.plano = ImgArreglo.esPlano(th);
          /* ¿VIENE SOBRE UN RECTÁNGULO NEGRO? Entonces el arreglo bueno no es
             recortarlo: ese negro es la tela. Recortar un fondo plano deja un
             borde duro justo donde el dibujo se estaba apagando; fundirlo
             convierte el brillo en opacidad y el dibujo se funde con la
             prenda. La trama de semitonos no se hace aquí: el pedido lleva la
             instrucción y la hace el panel de producción a 300 ppp. */
          dato.sobreNegro = ImgArreglo.pideFundirNegro(tp);
          /* Y aunque no haya recuadro: ¿cuánto del diseño es negro o casi?
             Una portada de disco trae el negro «levantado» (gris 20-50) y
             repartido por todo el dibujo; el detector de recuadro no lo ve,
             pero sobre tela oscura fundirlo es igual de bueno. */
          dato.parteOscura = ImgArreglo.parteOscura ? ImgArreglo.parteOscura(th) : 0;
          // ¿una foto de la prenda con el diseño puesto? Se mira con su margen
          if (!this.cfg.pegatina && ImgArreglo.pareceMockup) {
            try { var mk = ImgArreglo.pareceMockup(tp, file.name); dato.mockup = !!(mk && mk.mockup); } catch (e5) { dato.mockup = false; }
          }
        }
        /* ¿SE PUEDE quitar el fondo de este archivo? Se prueba aquí, sobre la
           miniatura, que cuesta cuatro píxeles. Antes se le ofrecía el botón a
           todo el mundo y al que tenía un archivo imposible le hacíamos perder
           el tiempo: pulsar, esperar y leer que no. Ahora el botón solo sale
           cuando sabemos que funciona. */
        if (transp === false && window.ImgArreglo) {
          var sonda = null;
          try { sonda = ImgArreglo.quitarFondo(tp); } catch (e3) { sonda = null; }
          dato.fondoSeparable = !!(sonda && sonda.ok);
          dato.fondoMotivo = (sonda && !sonda.ok) ? sonda.motivo : null;
          /* ¿El marco es CLARO? Es lo que decide si en transfers se ofrece
             «Eliminar blanco de fondo»: un logo en JPG sobre blanco es la mitad
             de lo que llega, y sin esto se imprimiría el rectángulo blanco. */
          try {
            var cb = ImgArreglo.colorBorde ? ImgArreglo.colorBorde(tp) : null;
            dato.fondoClaro = !!(cb && cb.parte >= 0.3 &&
              Math.min(cb.r, cb.g, cb.b) >= 200);
          } catch (e4) { dato.fondoClaro = false; }
        }
      } catch (e) { /* si no se puede leer, se sube igual */ }
    }

    /* TROQUELADA CON FONDO: ya NO se quita solo (Xavi, 28/09). El archivo se
       deja tal cual —si el cliente quiere quitarlo, está el botón de abajo,
       como en el resto de fichas— y el corte sigue la silueta del dibujo por
       fuera, con su propio fondo dentro si lo tiene, que es lo que haría un
       rotulista. Un cuadrado no, que para eso está la ficha de cuadradas. */
    if (!extra && this.esTroquel() && dato.transparente === false && dato.px) {
      this.siluetaDe(dato);
    }

    /* En redonda y cuadrada no se recorta nada, pero sí hace falta saber dónde
       está el dibujo dentro del archivo para centrarlo bien en el círculo. */
    if (!extra && this.cfg.pegatina && dato.transparente === false && dato.thumb && !dato.mascara) {
      this.centroDe(dato);
    }

    destapar();
    this.archivo = dato;
    this.pintarArchivo();
    this.actualizar();
  };

  // ¿esta ficha corta por la silueta? (el producto de troqueladas: todas sus medidas)
  Subida.prototype.esTroquel = function () {
    if (!this.cfg.pegatina || !window.PegatinaCorte) return false;
    var v = this.variante();
    if (!v) return false;
    var f = this.formatoVar(v);
    return !!f && f.forma === 'libre';
  };

  /* La silueta del conjunto, para cortar por fuera sin tocar el archivo.
     Recorta el dibujo y la máscara a lo que ocupa de verdad: si el emblema
     está centrado en un cuadrado con mucho aire, ese aire no es pegatina. */
  Subida.prototype.siluetaDe = function (dato) {
    if (!window.PegatinaCorte || !PegatinaCorte.silueta || !dato.thumb || !dato.px) return;
    var s = null;
    try { s = PegatinaCorte.silueta(dato.thumb); } catch (e) { return; }
    if (!s || s.lleno) return;          // la silueta es el rectángulo: no hay nada que ganar
    var k = dato.px[0] / dato.thumb.width;
    function recortar(src) {
      var c = document.createElement('canvas');
      c.width = s.w; c.height = s.h;
      c.getContext('2d').drawImage(src, s.x, s.y, s.w, s.h, 0, 0, s.w, s.h);
      return c;
    }
    dato.mascara = recortar(s.lienzo);
    /* El color que el diseñador puso detrás. Se guarda para poder estirarlo
       alrededor del dibujo al cortar (el anillo del §6d) y para saber si ese
       anillo tiene sentido: sobre blanco, no. */
    dato.fondoMascara = s.fondoClaro ? null : s.fondo;
    dato.thumb = recortar(dato.thumb);
    dato.px = [Math.max(1, Math.round(s.w * k)), Math.max(1, Math.round(s.h * k))];
  };

  // dónde está el centro de lo dibujado, en tanto por uno del archivo
  Subida.prototype.centroDe = function (dato) {
    if (!window.PegatinaCorte || !PegatinaCorte.silueta) return;
    var s = null;
    try { s = PegatinaCorte.silueta(dato.thumb, { aire: 0 }); } catch (e) { return; }
    if (!s || s.lleno) return;
    dato.centro = [
      (s.x + s.w / 2) / dato.thumb.width,
      (s.y + s.h / 2) / dato.thumb.height
    ];
    /* La máscara y el color del marco también sirven aquí, no solo en las
       troqueladas: con ellos, una redonda rellena el círculo con el fondo del
       propio diseño en vez de agrandar el dibujo hasta cortarle las letras. */
    dato.mascaraCentro = s.lienzo;
    dato.fondoMascara = s.fondoClaro ? null : s.fondo;
  };

  /* ---------- arreglos: quitar el fondo y afinar los bordes ----------
     Todo se hace aquí, en el navegador. El archivo que se manda al taller
     ya es el arreglado, y siempre se puede deshacer. */
  /* LA TOLERANCIA DEL RECORTE, EN MANOS DEL CLIENTE.
   *
   * Xavi: «otra opción es darle tolerancia al quitar fondo y así el cliente
   * sube o baja hasta que lo quita». Y antes: «tal cual está, de poco sirve».
   *
   * El recorte automático mide el color del marco y borra por inundación desde
   * el borde. Acierta casi siempre, pero con un JPEG sucio o un degradado
   * pegado al filo se deja una orla, y ahí el cliente se queda mirando sin
   * poder hacer nada. Dos botones lo arreglan.
   *
   * No es un deslizador que se arrastra: cada paso vuelve a recortar el
   * archivo ENTERO, que tarda su segundo, y arrastrando sería un infierno.
   * Con −/+ hay un cálculo por clic y la barra de progreso de siempre.
   *
   * Cada paso multiplica la tolerancia por 1,35. Cinco pasos arriba es casi el
   * triple del automático; dos abajo, la mitad. Y SIEMPRE se recorta desde el
   * ORIGINAL, nunca encima de lo ya recortado: si no, cada paso se comería un
   * trozo del anterior y no habría vuelta atrás. */
  var PASO_TOL = 1.35, TOL_MIN = -2, TOL_MAX = 5;

  Subida.prototype.tolerancia = function (nivel) {
    var k = Math.pow(PASO_TOL, nivel || 0);
    /* Subir la tolerancia también relaja lo que se le exige al marco para
       darlo por fondo: un blanco con degradado o viñeta no pasa el filtro
       automático, y es justo el archivo para el que existe este botón. */
    return { t1: 62 * k, t2: 132 * k, minParte: Math.min(0.55, 0.55 / k) };
  };

  /* QUITAR EL FONDO 2.0: ventana con previa, tolerancia, «solo el fondo / todo ese
     color» y varita para elegir qué colores se quitan (quitar-fondo.js). Siempre
     se parte del archivo ORIGINAL, no del ya recortado, para poder rehacerlo. */
  Subida.prototype.quitarFondo2 = async function () {
    var a = this.archivo, self = this;
    if (!a || !a.file || this.ocupado || !window.QuitarFondo) return;
    var origen = ((a.arreglos || []).indexOf('fondo') !== -1 && a.anterior) ? a.anterior : a;
    this.ocupado = true;
    var bmp;
    try {
      bmp = await createImageBitmap(origen.file);
    } catch (e) { this.ocupado = false; return this.flash('No hemos podido abrir la imagen para quitarle el fondo.'); }
    var lz = document.createElement('canvas');
    lz.width = bmp.width; lz.height = bmp.height;
    lz.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0);
    if (bmp.close) bmp.close();
    QuitarFondo.abrir({
      lienzo: lz,
      alCancelar: function () { self.ocupado = false; },
      alAplicar: async function (res) {
        try {
          var nuevo = await ImgArreglo.aFichero(res, origen.name.replace(/\.[^.]+$/, '') + '-sin-fondo.png');
          if (nuevo.size > self.cfg.maxFileMb * 1048576) {
            self.ocupado = false;
            return self.flash('El archivo sin fondo pesa demasiado. Deja este y marca el repaso del diseñador.');
          }
          var comp = null;
          try { comp = ImgArreglo.comparar(lz, res); } catch (e2) { comp = null; }
          self.ocupado = false;
          await self.cargar(nuevo, {
            anterior: origen, arreglos: (origen.arreglos || []).concat(['fondo']), comparativa: comp, tolFondo: 0
          });
        } catch (e3) {
          self.ocupado = false;
          self.flash('No hemos podido quitar el fondo. Marca el repaso del diseñador y lo dejamos listo nosotros.');
        }
      }
    });
  };

  Subida.prototype.ajustarFondo = function (delta) {
    var a = this.archivo;
    if (!a || this.ocupado) return;
    var nivel = Math.max(TOL_MIN, Math.min(TOL_MAX, (a.tolFondo || 0) + delta));
    if (nivel === (a.tolFondo || 0)) return;
    /* Se vuelve al archivo de antes del recorte y se recorta otra vez desde
       él. `deshacer` ya sabe volver ahí, así que el cliente no pierde nada. */
    var original = a.anterior || a;
    this.archivo = original;
    this.arreglar('fondo', nivel);
  };

  Subida.prototype.arreglar = async function (tipo, nivel) {
    var a = this.archivo;
    if (!a || !a.px || !window.ImgArreglo || this.ocupado) return;
    var btn = $(this.root, '[data-fix="' + tipo + '"]');
    var texto = btn ? btn.textContent : '';
    this.ocupado = true;
    var soltar = function () { if (btn) { btn.disabled = false; btn.textContent = texto; } };
    if (window.Cargando) {
      Cargando.ocupar(btn, tipo === 'fondo' ? 'Quitando el fondo…'
        : tipo === 'negro' ? 'Fundiendo el negro…' : 'Afinando…');
      soltar = function () { Cargando.libre(btn, texto); };
      await Cargando.pinta();
    } else if (btn) { btn.disabled = true; btn.textContent = 'Un momento…'; }
    try {
      var bmp = await createImageBitmap(a.file);
      // copia en lienzo: hace falta después para el antes/después
      var bmp2 = document.createElement('canvas');
      bmp2.width = bmp.width; bmp2.height = bmp.height;
      bmp2.getContext('2d', { willReadFrequently: true }).drawImage(bmp, 0, 0);
      if (bmp.close) bmp.close();
      var res = tipo === 'fondo' ? ImgArreglo.quitarFondo(bmp2, this.tolerancia(nivel))
        : tipo === 'negro' ? ImgArreglo.fundirNegro(bmp2)
        : ImgArreglo.afinarBordes(bmp2, 3);
      if (!res.ok) {
        this.ocupado = false; soltar();
        /* Si el automático no ve fondo, se le deja el «quitar más» a mano: el
           caso típico es un blanco con degradado o viñeta, que para el filtro
           es «una foto» y para el cliente es, obviamente, un fondo blanco. */
        if (tipo === 'fondo' && res.motivo === 'sin-fondo') {
          a.fondoFallido = true;
          a.tolFondo = nivel || 0;
          this.pintarArreglos();
          return this.flash(nivel
            ? 'Con esa tolerancia tampoco lo vemos como fondo. Sube otro punto o marca el repaso del diseñador.'
            : 'No hemos encontrado un fondo liso que quitar. Si tu archivo sí lleva fondo (blanco con sombra, degradado…), dale a «Quitar más» aquí abajo.');
        }
        return this.flash(tipo === 'negro'
          ? 'En este archivo el negro no es un fondo: forma parte del dibujo. Si lo fundiéramos se iría también lo que sí hay que imprimir.'
          : tipo !== 'fondo'
          ? 'Este archivo ya tiene tamaño de sobra, no hace falta afinarlo.'
          : (res.motivo === 'mezclado'
            ? 'En este archivo el fondo no es un fondo: ese mismo color está también dentro del diseño, así que al quitarlo se agujerea entero. Mándanos el dibujo suelto en PNG, o marca el repaso del diseñador y lo recortamos a mano.'
            : 'No hemos encontrado un fondo liso que quitar. Si aun así lo quieres recortado, marca el repaso del diseñador.'));
      }
      var base = a.name.replace(/\.[^.]+$/, '');
      var sufijo = tipo === 'fondo' ? '-sin-fondo'
        : tipo === 'negro' ? '-sin-negro' : '-afinado';
      var nuevo = await ImgArreglo.aFichero(res.lienzo, base + sufijo + '.png');
      if (nuevo.size > this.cfg.maxFileMb * 1048576) {
        this.ocupado = false; soltar();
        return this.flash('El archivo arreglado pesa demasiado. Deja este y marca el repaso del diseñador.');
      }
      var comp = null;
      try {
        if (tipo === 'negro' && ImgArreglo.vistaSemitono) {
          comp = ImgArreglo.vistaSemitono(bmp2, res.lienzo, (this.medidaPedida() || [100])[0],
            420, 294, this.cfg.tramaMm);
        } else {
          comp = ImgArreglo.comparar(bmp2, res.lienzo);
        }
      } catch (e2) { comp = null; }
      await this.cargar(nuevo, {
        anterior: a, arreglos: (a.arreglos || []).concat([tipo]), comparativa: comp,
        tolFondo: tipo === 'fondo' ? (nivel || 0) : undefined
      });
    } catch (e) {
      this.flash('No hemos podido arreglar la imagen. Marca el repaso del diseñador y lo dejamos listo nosotros.');
    }
    this.ocupado = false; soltar();
  };

  Subida.prototype.deshacer = function () {
    var a = this.archivo;
    if (!a || !a.anterior) return;
    this.archivo = a.anterior;
    this.pintarArchivo();
    this.actualizar();
  };

  /* ---------- vectorizado (de pago) ----------
     Redibujar el logo en curvas es lo ÚNICO que sube la calidad de verdad:
     afinar amplía, vectorizar reconstruye. Por eso se cobra, y por eso solo
     se ofrece donde funciona: logos de color plano que se quedan cortos.
     Una foto vectorizada queda peor que el original, así que ahí ni aparece. */
  /* ¿Esto es un logo de tintas planas, o un dibujo con sombras y degradados?
     Se mide contando cuántos colores mandan de verdad (cubos de 5 bits con más
     del 0,2 % de los píxeles) y cuánto del dibujo se lleva el puñado principal.

     Los números salen de medir logos de clientes de verdad, no de suponer:
       Casiña 3 cubos · tolemy 1 · el cartel entero 11   -> son planos
       American pool 29 · Billar Lucena 53               -> llevan sombreado
     y contra fotos de prueba: atardecer 15, retrato 16-20, paisaje 40-50.
     El hueco entre 11 y 29 es enorme, así que el corte en 14 va sobrado por
     los dos lados. No se usa esPlano() aquí: midiéndolo da resultados
     distintos según el tamaño del archivo (ruido 6/12, retrato 4/12), y para
     algo que se cobra hace falta un criterio que no baile. */
  function rasgosColor(lienzo) {
    var n = 200;
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.min(n, lienzo.width));
    c.height = Math.max(1, Math.round(lienzo.height * c.width / lienzo.width));
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(lienzo, 0, 0, c.width, c.height);
    var d = x.getImageData(0, 0, c.width, c.height).data;
    var cubos = {}, vistos = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 24) continue;
      var k = (d[i] >> 5) + '_' + (d[i + 1] >> 5) + '_' + (d[i + 2] >> 5);
      cubos[k] = (cubos[k] || 0) + 1; vistos++;
    }
    if (!vistos) return { conc: 0, cubos: 999 };
    var lista = Object.keys(cubos).map(function (k) { return cubos[k]; });
    lista.sort(function (a, b) { return b - a; });
    var top = 0;
    for (var j = 0; j < Math.min(8, lista.length); j++) top += lista[j];
    return {
      conc: top / vistos,
      cubos: lista.filter(function (n2) { return n2 / vistos > 0.002; }).length
    };
  }

  Subida.prototype.vectorPosible = function () {
    var a = this.archivo, cfg = this.cfg.vector;
    if (!a || !a.px || !cfg || !cfg.url || !cfg.id) return false;
    if (a.vectorizado || !a.thumb) return false;
    // vectorizar una foto o un dibujo con sombras lo deja peor que estaba
    if (!a.rasgos) a.rasgos = rasgosColor(a.thumb);
    if (a.rasgos.cubos > 14 || a.rasgos.conc < 0.82) return false;
    return this.calidadBaja();
  };

  Subida.prototype.pintarVector = function () {
    var r = this.root, a = this.archivo, cfg = this.cfg.vector;
    var caja = $(r, '[data-vector]');
    if (!caja) return;
    var sale = this.vectorPosible();
    caja.hidden = !sale;
    if (!sale) return;

    var precio = $(r, '[data-vector-precio]');
    if (precio && cfg) precio.textContent = '· ' + money(cfg.precio);
    var t = $(r, '[data-vector-t]');
    if (t) {
      t.innerHTML = a.vectorPrevia
        ? '<b>Así queda.</b> Los bordes se redibujan en curvas, así que se imprime nítido al tamaño que quieras. Si no te convence, no lo marques.'
        : '<b>Podemos redibujarlo en vectores.</b> Es lo único que sube la calidad de verdad: no amplía el archivo, lo vuelve a dibujar. Míralo antes de decidir, no cuesta nada.';
    }
    var ver = $(r, '[data-vector-ver]');
    if (ver && !ver.hasAttribute('data-crg')) ver.textContent = a.vectorPrevia ? 'Volver a verlo' : 'Ver cómo quedaría';
    var comp = $(r, '[data-vector-compara]');
    if (comp) {
      comp.hidden = !a.vectorComparativa;
      if (a.vectorComparativa) {
        var ca = $(comp, '[data-vector-antes]'), cd = $(comp, '[data-vector-despues]');
        ca.innerHTML = ''; ca.appendChild(a.vectorComparativa[0]);
        cd.innerHTML = ''; cd.appendChild(a.vectorComparativa[1]);
      }
    }
    var wrap = $(r, '[data-vector-wrap]');
    if (wrap) wrap.hidden = !a.vectorPrevia;
  };

  // el trozo donde más se va a notar: el de más detalle, ampliado
  function zonaDetalle(A, B, w, h) {
    var n = 240, celdas = 8;
    var c = document.createElement('canvas'); c.width = n; c.height = n;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(A, 0, 0, n, n);
    var d = x.getImageData(0, 0, n, n).data;
    var mejor = -1, bx = 0, by = 0, paso = n / celdas;
    for (var gy = 0; gy < celdas; gy++) for (var gx = 0; gx < celdas; gx++) {
      var e = 0;
      for (var y = Math.floor(gy * paso); y < Math.floor((gy + 1) * paso) - 1; y++) {
        for (var xx = Math.floor(gx * paso); xx < Math.floor((gx + 1) * paso) - 1; xx++) {
          var i = (y * n + xx) * 4, j = (y * n + xx + 1) * 4;
          e += Math.abs(d[i + 3] - d[j + 3]) + Math.abs(d[i] - d[j]);
        }
      }
      if (e > mejor) { mejor = e; bx = gx; by = gy; }
    }
    var lado = 2 / celdas;
    var ox = Math.min(Math.max((bx + 0.5) / celdas - lado / 2, 0), 1 - lado);
    var oy = Math.min(Math.max((by + 0.5) / celdas - lado / 2, 0), 1 - lado);
    return [A, B].map(function (src) {
      var o = document.createElement('canvas'); o.width = w; o.height = h;
      var g = o.getContext('2d');
      g.drawImage(src, ox * src.width, oy * src.height, lado * src.width, lado * src.height, 0, 0, w, h);
      return o;
    });
  }

  function aLienzo(origen) {
    return createImageBitmap(origen).then(function (bmp) {
      var c = document.createElement('canvas');
      c.width = bmp.width; c.height = bmp.height;
      c.getContext('2d').drawImage(bmp, 0, 0);
      if (bmp.close) bmp.close();
      return c;
    });
  }

  Subida.prototype.servidorVector = function (ruta) {
    return String(this.cfg.vector.url).replace(/\/+$/, '') + '/' + ruta;
  };

  /* Previsualización: 0,2 créditos. El cliente ve el resultado ANTES de pagar,
     así que nadie compra a ciegas y no gastamos el crédito bueno con curiosos. */
  Subida.prototype.verVector = async function () {
    var a = this.archivo;
    if (!a || !this.vectorPosible() || this.ocupado) return;
    var btn = $(this.root, '[data-vector-ver]'), texto = btn ? btn.textContent : '';
    this.ocupado = true;
    if (window.Cargando) Cargando.ocupar(btn, 'Redibujando el logo…');
    else if (btn) { btn.disabled = true; btn.textContent = 'Redibujando…'; }
    try {
      var fd = new FormData();
      fd.append('imagen', a.file, a.name);
      var r = await fetch(this.servidorVector('previsualizar'), { method: 'POST', body: fd });
      if (!r.ok) {
        var msg = 'No hemos podido vectorizarlo ahora mismo. Inténtalo en un rato.';
        try { var j = await r.json(); if (j && j.error) msg = j.error; } catch (e) {}
        throw new Error(msg);
      }
      a.vectorToken = r.headers.get('X-Image-Token') || '';
      var blob = await r.blob();
      var nuevo = await aLienzo(blob);
      var viejo = await aLienzo(a.file);
      a.vectorComparativa = zonaDetalle(viejo, nuevo, 200, 140);
      a.vectorPrevia = true;
    } catch (e) {
      this.flash((e && e.message) || 'No hemos podido vectorizarlo.');
    }
    this.ocupado = false;
    if (window.Cargando) Cargando.libre(btn, texto);
    else if (btn) { btn.disabled = false; btn.textContent = texto; }
    this.actualizar();
  };

  Subida.prototype.quiereVector = function () {
    var chk = $(this.root, '[data-vector-check]'), a = this.archivo;
    return !!(chk && chk.checked && a && a.vectorPrevia && a.vectorToken && this.cfg.vector);
  };

  Subida.prototype.extraVector = function () {
    return this.quiereVector() ? this.cfg.vector.precio : 0;
  };

  /* ---------- EL COLOR DE LA TELA ----------
   *
   * Un transfer no sabe dónde va. De los pedidos que han entrado, uno era un
   * escudo para camiseta de fútbol y otro para unas bolsas, así que preguntar
   * por la PRENDA no lleva a ningún sitio y además deja fuera a media
   * clientela. Lo que hace falta saber es el COLOR, y eso vale igual para una
   * bolsa, un delantal, una gorra o una sudadera.
   *
   * Con el color se resuelven tres cosas de golpe: si tiene sentido fundir el
   * fondo negro con la tela, si el dibujo se va a camuflar contra ella, y
   * sobre qué fondo pintar la vista previa. */
  var TELAS = [
    { id: 'blanco', nombre: 'Blanco', hex: '#ffffff' },
    { id: 'crudo', nombre: 'Crudo', hex: '#e2d8c3' },
    { id: 'gris', nombre: 'Gris jaspeado', hex: '#c4c5c2' },
    { id: 'gris-oscuro', nombre: 'Gris oscuro', hex: '#4b4b4d' },
    { id: 'negro', nombre: 'Negro', hex: '#121212' },
    { id: 'marino', nombre: 'Azul marino', hex: '#1d2b4a' },
    { id: 'azul', nombre: 'Azul', hex: '#2559a8' },
    { id: 'rojo', nombre: 'Rojo', hex: '#b32a2a' },
    { id: 'verde', nombre: 'Verde botella', hex: '#1f4835' },
    { id: 'amarillo', nombre: 'Amarillo', hex: '#f0c53c' }
  ];

  // claridad 0..1, para decidir si la tela es oscura y si el texto va en negro
  function luz(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (isNaN(n)) return 1;
    return ((n >> 16 & 255) * 0.299 + (n >> 8 & 255) * 0.587 + (n & 255) * 0.114) / 255;
  }

  Subida.prototype.montarTelas = function () {
    var self = this, caja = $(this.root, '[data-telas]');
    if (!caja) return;
    // en pegatinas no hay tela: el vinilo es blanco y punto
    if (this.cfg.pegatina) { var pad = caja.closest('[data-tela-bloque]'); if (pad) pad.hidden = true; return; }
    caja.innerHTML = TELAS.map(function (t) {
      return '<button type="button" class="sdtf-tela" data-tela="' + t.id + '" ' +
        'style="--tela:' + t.hex + '" aria-pressed="false" title="' + esc(t.nombre) + '">' +
        '<span class="sdtf-tela__bola"></span><span class="sdtf-tela__n">' + esc(t.nombre) + '</span></button>';
    }).join('');
    Array.prototype.forEach.call(caja.querySelectorAll('[data-tela]'), function (b) {
      b.addEventListener('click', function () {
        self.telaSel = self.telaSel === b.dataset.tela ? null : b.dataset.tela;
        self.otroHex = null;
        self.pintarTelas();
        self.pintarArreglos();
        self.actualizar();
      });
    });
    var otro = $(this.root, '[data-tela-otro]');
    if (otro) otro.addEventListener('input', function () {
      self.telaSel = 'otro'; self.otroHex = otro.value;
      self.pintarTelas(); self.pintarArreglos(); self.actualizar();
    });
    // lo que venga del enlace en pausa
    if (this.pausa && this.pausa.t) {
      this.telaSel = this.pausa.t;
      if (this.pausa.h) { this.otroHex = this.pausa.h; if (otro) otro.value = this.pausa.h; }
      this.pintarTelas();
    }
  };

  /* ---------- EL PRECIO DE ARRIBA, QUE TAMBIÉN ES UN PRECIO ----------
   *
   * El tema pinta el precio de la variante que venía marcada de serie y ahí se
   * queda clavado. Como aquí la variante la elegimos nosotros a partir del
   * ancho, el cliente movía la barra de 5 a 22 cm, el botón subía a 14,50 € y
   * arriba del todo seguía poniendo 1,55 €. Dos precios distintos en la misma
   * pantalla: o se cree el bueno y se lleva un susto en la pasarela, o se cree
   * el malo y se va.
   *
   * No se toca el <select> del tema aposta. Dawn, al cambiarlo, se va a buscar
   * la sección otra vez y la repinta entera —con el archivo ya subido dentro—,
   * así que aquí solo se reescribe el número. El molde (el símbolo, si va
   * delante o detrás, si lleva espacio) se saca de lo que ya ha pintado el
   * propio tema, que para eso conoce el formato de la tienda.
   *
   * Y mientras no hay archivo no se enseña un precio a secas: se enseña DESDE
   * cuánto, que es lo único cierto antes de saber el tamaño. */
  Subida.prototype.montarPrecioTema = function () {
    var zona = document.querySelector('.product__info-container, .product__info-wrapper');
    if (!zona) return;
    var nodos = [].slice.call(zona.querySelectorAll('.price__regular .price-item--regular'));
    if (!nodos.length) nodos = [].slice.call(zona.querySelectorAll('.price-item--regular'))
      .filter(function (e) { return !(e.closest && e.closest('s, del, .price__sale')); });
    var self = this;
    this.precios = [];
    nodos.forEach(function (n) {
      var txt = n.textContent || '', m = txt.match(/\d[\d.,\s]*/);
      if (!m) return;
      var desde = document.createElement('span');
      desde.className = 'sdtf-desde';
      desde.textContent = 'Desde ';
      n.parentNode.insertBefore(desde, n);
      self.precios.push({ n: n, pre: txt.slice(0, m.index), post: txt.slice(m.index + m[0].length), desde: desde });
    });
  };

  Subida.prototype.precioMinimo = function () {
    var v = this.cfg.variantes || [], min = 0;
    for (var i = 0; i < v.length; i++) if (!min || v[i].precio < min) min = v[i].precio;
    return min;
  };

  Subida.prototype.pintarPrecioTema = function (c, extra) {
    if (!this.precios || !this.precios.length) return;
    /* El «desde» es solo de transfers. En pegatinas el cliente elige el
       escalón con la mano, así que el precio es exacto desde el primer
       segundo; en transfers no hay precio hasta que hay tamaño, y el tamaño
       lo pone el archivo. */
    var desde = !this.cfg.pegatina && !this.archivo;
    var cts = desde || !c ? this.precioMinimo() : c.variante.precio + (extra || 0);
    if (!(cts > 0)) return;
    var num = (cts / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    this.precios.forEach(function (p) {
      p.n.textContent = p.pre + num + p.post;
      p.desde.hidden = !desde;
    });
  };

  Subida.prototype.tela = function () {
    if (!this.telaSel) return null;
    if (this.telaSel === 'otro') return { id: 'otro', nombre: 'Otro (' + (this.otroHex || '#ffffff') + ')', hex: this.otroHex || '#ffffff' };
    for (var i = 0; i < TELAS.length; i++) if (TELAS[i].id === this.telaSel) return TELAS[i];
    return null;
  };

  Subida.prototype.telaOscura = function () {
    var t = this.tela();
    return !!t && luz(t.hex) < 0.45;
  };

  Subida.prototype.pintarTelas = function () {
    var r = this.root, sel = this.telaSel;
    /* Y LA PREVIA SE VE SOBRE ESE COLOR. Un PNG transparente sobre el ajedrez
       gris no dice nada: lo que el cliente quiere saber es cómo va a quedar su
       diseño sobre SU tela, y sobre todo si se va a camuflar. En cuanto elige
       el color, la miniatura y el antes/después se pintan encima de él. */
    var t = this.tela();
    r.style.setProperty('--sdtf-tela', t ? t.hex : 'transparent');
    r.classList.toggle('con-tela', !!t);
    r.classList.toggle('tela-oscura', this.telaOscura());
    Array.prototype.forEach.call(r.querySelectorAll('[data-tela]'), function (b) {
      var on = b.dataset.tela === sel;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var otro = $(r, '[data-tela-otro]');
    if (otro) otro.classList.toggle('is-on', sel === 'otro');
  };

  /* ---------- EL ANCHO EN CENTÍMETROS ----------
   *
   * Las variantes se quedan EXACTAMENTE como están —ni una tocada, ni un
   * precio movido—, pero el cliente deja de verlas. Nadie que quiera un logo
   * de 14 cm sabe si eso es «Frontal horizontal» o «Frontal»: son cajas de
   * nuestra lista de precios, no de su cabeza.
   *
   * Así que escribe el ancho, el alto lo pone la proporción de su archivo, y
   * nosotros buscamos la caja MÁS BARATA donde eso entra. Si al subir el ancho
   * salta de caja, el precio cambia a la vista mientras mueve la barra, no al
   * llegar al carrito.
   */
  Subida.prototype.ubicaciones = function () {
    if (this._ubis) return this._ubis;
    var cfg = this.cfg, idx = -1;
    (cfg.opciones || []).forEach(function (n, i) {
      if (idx === -1 && cfg.variantes.some(function (v) { return medidaDe(v.opts[i]); })) idx = i;
    });
    var out = [], vistos = {};
    if (idx !== -1) {
      cfg.variantes.forEach(function (v) {
        var val = v.opts[idx], m = medidaDe(val);
        if (m && !vistos[val]) { vistos[val] = 1; out.push({ valor: val, w: m.w, h: m.h }); }
      });
    }
    this._ubiIdx = idx;
    this._ubis = out;
    return out;
  };

  // la variante que cree el tema, para quedarnos con SU cantidad
  Subida.prototype.varianteTema = function () {
    var v = this.cfg.variantes;
    var campo = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (campo && campo.value) {
      var enc = v.filter(function (x) { return String(x.id) === String(campo.value); })[0];
      if (enc) return enc;
    }
    var elegidas = [];
    document.querySelectorAll('variant-selects select, variant-radios input:checked, .product-form__input select, .product-form__input input:checked').forEach(function (el) {
      if (el.value) elegidas.push(el.value.trim());
    });
    if (elegidas.length) {
      var m = v.filter(function (x) {
        return x.opts.every(function (o, i) { return elegidas[i] == null || o === elegidas[i]; });
      })[0];
      if (m) return m;
    }
    return v[0] || null;
  };

  // el ancho y el alto que ha pedido, en mm
  Subida.prototype.medidaPedida = function () {
    var a = this.archivo;
    if (!a || !a.px || !this.anchoCm) return null;
    var w = this.anchoCm * 10;
    return [w, w * a.px[1] / a.px[0]];
  };

  // el ancho mayor al que su diseño entra en alguna caja
  Subida.prototype.anchoTope = function () {
    var a = this.archivo, ubis = this.ubicaciones();
    if (!a || !a.px || !ubis.length) return 0;
    var prop = a.px[1] / a.px[0], max = 0;
    ubis.forEach(function (u) {
      var w = Math.max(Math.min(u.w, u.h / prop), Math.min(u.h, u.w / prop));      // también girado
      if (w > max) max = w;
    });
    return Math.floor(max / 5) / 2;              // en cm, a medio centímetro
  };

  /* La caja más barata donde entra. Se cambia SOLO la ubicación: la cantidad y
     lo demás se quedan como los haya puesto en el selector del tema. */
  Subida.prototype.porAncho = function () {
    if (this.cfg.pegatina) return null;
    var ubis = this.ubicaciones(), idx = this._ubiIdx;
    if (!ubis.length || idx < 0) return null;
    var mm = this.medidaPedida();
    if (!mm) return null;
    var base = this.baseVariante();
    if (!base) return null;
    var area = mm[0] * mm[1] / 100;                                                  // cm²
    var caben = this.cfg.variantes.filter(function (v) {
      if (!v.opts.every(function (o, i) { return i === idx || o === base.opts[i]; })) return false;
      var m = medidaDe(v.opts[idx]);
      if (m) return (mm[0] <= m.w + 0.05 && mm[1] <= m.h + 0.05) || (mm[0] <= m.h + 0.05 && mm[1] <= m.w + 0.05);   // una caja de medidas, el diseño también puede ir girado
      var a = areaDe(v.opts[idx]);
      return a != null && area <= a + 0.05;                                         // una banda de superficie
    });
    if (!caben.length) return null;
    caben.sort(function (a, b) { return a.precio - b.precio; });
    return caben[0];
  };

  /* EL ANCHO DE PARTIDA: EL MAYOR QUE TODAVÍA CUESTA LO MÍNIMO.
   *
   * La primera versión arrancaba en el ancho más grande que su archivo aguanta
   * nítido. Con un logo de 4.000 píxeles eso son 25 cm, o sea que la ficha se
   * abría sola en la caja más cara del producto. Eso es venderle de tapadillo:
   * él no ha pedido 25 cm, se los hemos puesto nosotros.
   *
   * Así que se hace al revés. Se recorre el metro de medio en medio
   * centímetro, se mira cuánto costaría cada medida, y se arranca en la MÁS
   * GRANDE de las que cuestan el mínimo. El cliente empieza en lo que más le
   * cunde y sube si quiere, sabiendo lo que sube. Y si su archivo no da para
   * tanto, manda el archivo: nunca se arranca en un tamaño en el que se va a
   * ver mal. */
  Subida.prototype.anchoPorDefecto = function () {
    var a = this.archivo, tope = this.anchoTope();
    if (!a || !a.px || !tope) return null;
    /* Tamaño real: el que dice el propio archivo (su resolución guardada). */
    if (a.dpiArchivo) {
      var real = Math.round(a.px[0] / a.dpiArchivo * 2.54 * 2) / 2;
      if (real >= 1) return Math.min(real, tope);
    }
    var nitidoCm = (a.pxCalidad || a.px)[0] / (this.cfg.dpiGood / 2.54);
    var limite = Math.max(1, Math.min(tope, Math.round(nitidoCm * 2) / 2));
    var guardado = this.anchoCm, barato = null, mejor = null;
    for (var cm = 1; cm <= limite + 0.001; cm += 0.5) {
      this.anchoCm = cm;
      var v = this.porAncho();
      if (!v) continue;
      if (barato === null || v.precio < barato) { barato = v.precio; mejor = cm; }
      else if (v.precio === barato) mejor = cm;
    }
    this.anchoCm = guardado;
    return mejor == null ? limite : mejor;
  };

  /* LOS SELECTORES DEL TEMA SE APAGAN, LOS DOS.
   *
   * El de ubicación porque sus valores son cajas de nuestra tarifa, no medidas
   * que nadie sepa elegir. Y el de cantidad porque estaba ARRIBA del todo, o
   * sea que la ficha le pedía decidir cuántos quiere antes de haber enseñado
   * nada: ni el tamaño, ni cómo va a quedar, ni el precio por unidad.
   *
   * Apagándolos, lo primero que ve es «sube tu diseño», que es por donde
   * empieza de verdad. La cantidad se vuelve a pedir más abajo, ya dentro del
   * bloque y con el precio por unidad al lado, que es lo que decide la compra.
   * No se toca el tema: solo se esconden, y las variantes siguen intactas. */
  Subida.prototype.ocultarSelectores = function () {
    if (this.cfg.pegatina) return;
    this.ubicaciones();
    var nombres = (this.cfg.opciones || []).map(function (n) { return String(n).toLowerCase(); });
    document.querySelectorAll('.product-form__input').forEach(function (el) {
      var lab = el.querySelector('label, legend');
      if (!lab) return;
      var t = lab.textContent.trim().toLowerCase();
      if (nombres.some(function (n) { return n && t.indexOf(n) === 0; })) el.style.display = 'none';
    });
  };

  // el índice de la opción de cantidad ("20 uds")
  Subida.prototype.cantIdx = function () {
    if (this._cantIdx != null) return this._cantIdx;
    var cfg = this.cfg, idx = -1;
    (cfg.opciones || []).forEach(function (n, i) {
      if (idx === -1 && (/cantidad/i.test(n) || cfg.variantes.some(function (v) { return /ud/i.test(v.opts[i] || ''); }))) idx = i;
    });
    this._cantIdx = idx;
    return idx;
  };

  /* La variante de partida: lo que diga el tema, pero con LA CANTIDAD que haya
     pulsado el cliente en nuestro propio selector. */
  Subida.prototype.baseVariante = function () {
    var base = this.varianteTema(), i = this.cantIdx();
    if (!base || this.cantSel == null || i < 0) return base;
    var opts = base.opts.slice();
    opts[i] = this.cantSel;
    return this.cfg.variantes.filter(function (v) {
      return v.opts.every(function (o, j) { return o === opts[j]; });
    })[0] || base;
  };

  Subida.prototype.montarCantidad = function () {
    var self = this, caja = $(this.root, '[data-cants]');
    if (!caja || this.cfg.pegatina) { if (caja) caja.hidden = true; return; }
    var i = this.cantIdx();
    if (i < 0) { caja.hidden = true; return; }
    var vals = [];
    this.cfg.variantes.forEach(function (v) {
      if (vals.indexOf(v.opts[i]) === -1) vals.push(v.opts[i]);
    });
    vals.sort(function (a, b) { return cantidadDe(a) - cantidadDe(b); });
    this._cantVals = vals;
    var base = this.varianteTema();
    if (this.cantSel == null && base) this.cantSel = base.opts[i];
    if (this.pausa && this.pausa.c && vals.indexOf(this.pausa.c) !== -1) this.cantSel = this.pausa.c;
    caja.hidden = false;
  };

  Subida.prototype.pintarCantidad = function () {
    var self = this, caja = $(this.root, '[data-cants]');
    if (!caja || caja.hidden || !this._cantVals) return;
    var i = this.cantIdx(), ubiIdx = this._ubiIdx;
    /* SIN LOGO NI TAMAÑO NO HAY PRECIO (Xavi, 23/10, una clienta de 200 transfers vio «200 · 0,30 €/ud» —lo que cuesta el más pequeño— y le pedíamos
       2,16 € por unidad por el suyo, de 25 × 12 cm): el precio por unidad depende de la caja que sale del ancho, y sin diseño solo hay una
       caja de partida, la primera de la tarifa. Hasta que haya diseño y medida, los botones llevan solo la cantidad y una nota; el precio
       de arriba de la ficha se esconde (clase en <body>, que se quita sola en cuanto hay medida). */
    var conMedida = !this.ubicaciones().length || !!(this.archivo && this.archivo.px);   // sin ubicaciones (metros…) el precio no depende de una medida
    try { document.body.classList.toggle('sdtf-sin-medida', !conMedida); } catch (e1) {}
    // la caja que ha salido del ancho: el precio por unidad depende de ella
    var actual = this.variante();
    caja.innerHTML = '';
    var notaAnt = caja.parentNode && caja.parentNode.querySelector('[data-cants-nota]');
    if (notaAnt) notaAnt.parentNode.removeChild(notaAnt);
    if (!conMedida && caja.parentNode) {
      var nota = document.createElement('p');
      nota.className = 'sdtf-op__nota';
      nota.setAttribute('data-cants-nota', '');
      nota.textContent = 'El precio por unidad depende del tamaño de tu diseño: sube tu logo o tu imagen y verás aquí el precio exacto de cada cantidad.';
      caja.parentNode.appendChild(nota);
    }
    this._cantVals.forEach(function (val) {
      var uds = cantidadDe(val);
      var opts = (actual || self.cfg.variantes[0]).opts.slice();
      opts[i] = val;
      var v = self.cfg.variantes.filter(function (x) {
        return x.opts.every(function (o, j) { return j === ubiIdx || o === opts[j]; }) && x.opts[ubiIdx] === opts[ubiIdx];
      })[0];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sdtf-op__b' + (self.cantSel === val ? ' is-on' : '');
      b.setAttribute('aria-pressed', self.cantSel === val ? 'true' : 'false');
      var n = document.createElement('b');
      n.textContent = String(uds);
      b.appendChild(n);
      if (v && conMedida) {
        var menor = self._cantVals[0];               // ya vienen ordenados de menos a más
        var optsB = opts.slice(); optsB[i] = menor;
        var vBase = self.cfg.variantes.filter(function (x) {
          return x.opts.every(function (o, j) { return o === optsB[j]; });
        })[0];
        var pct = ahorroUnidad(vBase, cantidadDe(menor), v, uds);
        var u = document.createElement('small');
        u.textContent = money(Math.round(v.precio / Math.max(1, uds))) + '/ud';
        // el porcentaje queda solo en el título, no en la cara del botón
        if (pct) u.title = 'Un ' + pct + ' % menos por unidad que comprando ' + cantidadDe(menor);
        b.appendChild(u);
      }
      b.addEventListener('click', function () {
        self.cantSel = val;
        self.actualizar();
      });
      caja.appendChild(b);
    });
  };

  Subida.prototype.montarMedida = function () {
    var self = this, bloque = $(this.root, '[data-medida-bloque]');
    if (!bloque || this.cfg.pegatina) { if (bloque) bloque.hidden = true; return; }
    /* OJO: esta caja se muda a la columna de la foto, así que se guarda la
       referencia y a partir de aquí NADA se busca desde `this.root`. Es la
       misma trampa que costó dos capturas con la previa de pegatinas. */
    this.cajaMedida = bloque;
    this.ocultarSelectores();
    this.montarCantidad();
    ['[data-ancho]', '[data-ancho-r]'].forEach(function (sel) {
      var el = $(bloque, sel);
      if (!el) return;
      /* CON COMA (Xavi, 26/09: «cuando cambio el tamaño no cambia el precio…
         a veces sí y a veces no»). Era un <input type="number">: en el móvil
         con teclado español se teclea «12,5», el campo numérico se come la
         coma y lee 125 (o nada, según el móvil), así que se iba al tope o no
         cambiaba. Ahora es un campo de texto con teclado decimal que acepta
         coma y punto, y al salir se escribe bien, con coma. */
      el.addEventListener('input', function () {
        var v = parseFloat(String(el.value).replace(',', '.').replace(/[^\d.]/g, ''));
        if (!isFinite(v) || v <= 0) return;
        self.anchoCm = Math.max(1, Math.min(self.anchoTope() || 99, Math.round(v * 2) / 2));
        self.actualizar();
      });
      if (el.type === 'text') el.addEventListener('blur', function () {
        if (self.anchoCm) el.value = fmt(self.anchoCm, self.anchoCm % 1 ? 1 : 0);
      });
    });
  };

  Subida.prototype.asegurarAncho = function () {
    if (this.cfg.pegatina) return;
    var a = this.archivo;
    if (!a || !a.px || !this.ubicaciones().length) return;
    var tope = this.anchoTope();
    if (!this.anchoCm && this.pausa && this.pausa.a) {
      var a0 = parseFloat(String(this.pausa.a).replace(',', '.'));
      if (isFinite(a0) && a0 > 0) this.anchoCm = Math.round(a0 * 2) / 2;
    }
    if (!this.anchoCm) this.anchoCm = this.anchoPorDefecto();
    if (tope && this.anchoCm > tope) this.anchoCm = tope;
  };

  Subida.prototype.pintarMedida = function () {
    var self = this, a = this.archivo;
    var bloque = this.cajaMedida || $(this.root, '[data-medida-bloque]');
    if (!bloque) return;
    var r = bloque;
    if (this.cfg.pegatina || !a || !a.px || !this.ubicaciones().length) { bloque.hidden = true; return; }
    bloque.hidden = false;

    var tope = this.anchoTope();

    ['[data-ancho]', '[data-ancho-r]'].forEach(function (sel) {
      var el = $(r, sel);
      if (!el) return;
      if (el.type === 'range') { el.min = 1; el.max = tope || 25; el.step = 0.5; }
      if (document.activeElement !== el) {
        el.value = el.type === 'range' ? self.anchoCm : fmt(self.anchoCm, self.anchoCm % 1 ? 1 : 0);
      }
    });
    /* El verde de la barra, hasta donde va el pomo. Chrome y Safari no pintan
       la parte recorrida —eso solo lo tiene Firefox—, así que se le pasa por
       una variable y lo hace el degradado. */
    var barra = $(r, '[data-ancho-r]');
    if (barra) {
      var mn = parseFloat(barra.min) || 0, mx = parseFloat(barra.max) || 1;
      var pc = mx > mn ? ((parseFloat(barra.value) || mn) - mn) / (mx - mn) : 0;
      barra.style.setProperty('--sdtf-llena', Math.round(pc * 100) + '%');
    }

    var mm = this.medidaPedida();
    var t = $(r, '[data-medida-t]');
    if (t && mm) {
      t.innerHTML = '<b>Saldrá a ' + fmt(mm[0] / 10, 1) + ' × ' + fmt(mm[1] / 10, 1) + ' cm.</b> ' +
        'El alto lo pone la proporción de tu diseño, que no se deforma. ' +
        'Lo más grande que hacemos con esta forma son ' + fmt(tope, 1) + ' cm de ancho.';
    }
    this.pintarRegla();
  };

  /* LA REGLA. No digo "a tamaño real" porque el navegador no sabe cuántos
     centímetros mide la pantalla de nadie: sería mentira en cuanto lo abra en
     el móvil. Lo que sí es verdad es la ESCALA — el diseño y la regla están
     dibujados con el mismo metro, así que se ve de un vistazo si 6 cm son
     mucho o poco para lo que tiene en la cabeza. Y va sobre el color de tela
     que haya elegido, que es donde lo va a pegar. */
  Subida.prototype.pintarRegla = function () {
    var a = this.archivo, mm = this.medidaPedida();
    var r = this.cajaMedida || this.root;
    var lienzo = $(r, '[data-regla]');
    if (!lienzo) return;
    if (!a || !a.thumb || !mm) { lienzo.hidden = true; return; }
    lienzo.hidden = false;

    /* El mundo dibujado va en MILÍMETROS y abarca siempre lo máximo que
       hacemos, no solo su diseño: así, al mover la barra, el dibujo crece
       dentro de un marco que no se mueve y se ve de verdad que está pidiendo
       más grande. Si el marco se ajustara a su medida, todo se vería igual
       siempre y la previa no diría nada. */
    var tope = this.anchoTope() * 10 || 250;
    var margen = 9, cotaH = 13, reglaH = 15, cotaW = 20;
    var totalW = tope + margen * 2 + cotaW;
    var totalH = mm[1] + margen * 2 + cotaH + reglaH;

    var hueco = (r.clientWidth || this.root.clientWidth || 520) - 30;
    var anchoCss = Math.max(200, Math.min(560, hueco));
    var escala = anchoCss / totalW;
    var dpr = window.devicePixelRatio || 1;

    lienzo.style.width = Math.round(anchoCss) + 'px';
    lienzo.style.maxWidth = '100%';
    lienzo.style.height = 'auto';
    lienzo.width = Math.round(anchoCss * dpr);
    lienzo.height = Math.round(totalH * escala * dpr);
    var c = lienzo.getContext('2d');
    c.setTransform(dpr * escala, 0, 0, dpr * escala, 0, 0);   // ahora se trabaja en mm
    c.clearRect(0, 0, totalW, totalH);

    var tela = this.tela();
    var oscura = !!tela && luz(tela.hex) < 0.5;
    c.fillStyle = tela ? tela.hex : '#f3f3f6';
    c.fillRect(0, 0, totalW, totalH);

    var x0 = margen, y0 = margen;
    c.drawImage(a.thumb, x0, y0, mm[0], mm[1]);

    var tinta = oscura ? 'rgba(255,255,255,.9)' : 'rgba(0,0,0,.78)';
    var suave = oscura ? 'rgba(255,255,255,.45)' : 'rgba(0,0,0,.32)';
    c.strokeStyle = tinta; c.fillStyle = tinta;
    c.lineJoin = 'round';

    /* LAS COTAS, como en un plano: la medida final escrita al lado de la flecha
       que la mide. Es la pregunta que se hace todo el mundo mirando la previa
       —«¿y esto cuánto es?»— y contestarla con un número al lado del dibujo
       ahorra la mitad de los whatsapps. */
    function flecha(ax, ay, bx, by) {
      c.lineWidth = 0.35;
      c.beginPath(); c.moveTo(ax, ay); c.lineTo(bx, by); c.stroke();
      var d = Math.atan2(by - ay, bx - ax), p = 1.9;
      [[ax, ay, d], [bx, by, d + Math.PI]].forEach(function (f) {
        c.beginPath();
        c.moveTo(f[0], f[1]);
        c.lineTo(f[0] + Math.cos(f[2] - 0.45) * p, f[1] + Math.sin(f[2] - 0.45) * p);
        c.moveTo(f[0], f[1]);
        c.lineTo(f[0] + Math.cos(f[2] + 0.45) * p, f[1] + Math.sin(f[2] + 0.45) * p);
        c.stroke();
      });
    }
    // línea de referencia desde las esquinas del diseño hasta sus cotas
    c.strokeStyle = suave; c.lineWidth = 0.22;
    c.beginPath();
    c.moveTo(x0, y0 + mm[1]); c.lineTo(x0, y0 + mm[1] + cotaH - 3);
    c.moveTo(x0 + mm[0], y0 + mm[1]); c.lineTo(x0 + mm[0], y0 + mm[1] + cotaH - 3);
    c.moveTo(x0 + mm[0], y0); c.lineTo(x0 + mm[0] + cotaW - 3, y0);
    c.moveTo(x0 + mm[0], y0 + mm[1]); c.lineTo(x0 + mm[0] + cotaW - 3, y0 + mm[1]);
    c.stroke();
    c.strokeStyle = tinta;

    var yCota = y0 + mm[1] + 6;
    flecha(x0, yCota, x0 + mm[0], yCota);
    var xCota = x0 + mm[0] + 7;
    flecha(xCota, y0, xCota, y0 + mm[1]);

    c.font = 'bold 4.6px sans-serif';
    c.textAlign = 'center'; c.textBaseline = 'alphabetic';
    var anchoTxt = fmt(mm[0] / 10, 1) + ' cm';
    var altoTxt = fmt(mm[1] / 10, 1) + ' cm';
    // el número se escribe sobre un recuadro del color de la tela para que se
    // lea aunque le caiga encima la flecha o una zona oscura del diseño
    function etiqueta(txt, cx, cy) {
      var w = c.measureText(txt).width + 2.4;
      c.fillStyle = tela ? tela.hex : '#f3f3f6';
      c.fillRect(cx - w / 2, cy - 4.2, w, 5.6);
      c.fillStyle = tinta;
      c.fillText(txt, cx, cy);
    }
    etiqueta(anchoTxt, x0 + mm[0] / 2, yCota + 1.6);
    c.save();
    c.translate(xCota + 5.5, y0 + mm[1] / 2);
    c.rotate(-Math.PI / 2);
    etiqueta(altoTxt, 0, 1.6);
    c.restore();

    // y abajo la regla, en centímetros, hasta lo más grande que hacemos
    var y = totalH - reglaH + 3;
    c.strokeStyle = suave; c.fillStyle = tinta; c.lineWidth = 0.3;
    c.beginPath(); c.moveTo(x0, y); c.lineTo(x0 + tope, y); c.stroke();
    c.font = '3.6px sans-serif'; c.textAlign = 'center';
    for (var cm = 0; cm * 10 <= tope + 0.01; cm++) {
      var x = x0 + cm * 10;
      c.strokeStyle = cm % 5 === 0 ? tinta : suave;
      c.beginPath(); c.moveTo(x, y); c.lineTo(x, y + (cm % 5 === 0 ? 4 : 2)); c.stroke();
      if (cm % 5 === 0 && cm > 0) c.fillText(String(cm), x, y + 9);
    }
  };

  Subida.prototype.pintarArreglos = function () {
    var r = this.root, a = this.archivo;
    var caja = $(r, '[data-arreglos]');
    if (!caja) return;
    if (!a || !a.px || !window.ImgArreglo) { caja.hidden = true; return; }
    caja.hidden = false;

    var hechos = a.arreglos || [];
    var bFondo = $(r, '[data-fix="fondo"]'), bBordes = $(r, '[data-fix="bordes"]');
    var bNegro = $(r, '[data-fix="negro"]');

    /* EL FONDO NEGRO NO SE RECORTA: SE FUNDE.
     *
     * Si el arte viene sobre un rectángulo negro y el transfer va a ir sobre
     * tela oscura, quitar el fondo es la versión mala de lo mismo — deja un
     * borde duro justo donde el dibujo se estaba apagando. Fundirlo convierte
     * el brillo en opacidad y el negro pasa a ser la tela: se imprime la mitad
     * de tinta y el dibujo no acaba en un parche.
     *
     * Depende del color de la tela y por eso no se ofrece a ciegas: sobre una
     * bolsa blanca, fundir ese negro se lleva por delante medio diseño. Hasta
     * que no diga sobre qué va, no se ofrece ninguno de los dos. */
    /* NEGRO REPARTIDO, SIN RECUADRO. Xavi subió una portada de disco para
       «eliminar negro + semitono» y no le dejaba: el negro no hacía marco,
       estaba por todo el dibujo y además levantado (gris muy oscuro, no
       negro puro). Sobre tela oscura se ofrece igual en cuanto una parte
       apreciable del diseño es oscura; sobre clara no, porque ahí fundir
       ese negro se lleva medio dibujo. */
    /* Y Xavi, 26/09: «lo de los semitonos lo quiero vender como una ventaja…
       poder aplicarlo siempre sobre el negro y así el cliente ve si queda
       bien». Así que se ofrece en cuanto hay negro de verdad en el diseño,
       sea cual sea la tela: lo que decide es lo que ve en la vista ampliada
       con los puntos sobre su color, y siempre puede deshacerlo. */
    var negroDentro = !a.sobreNegro && (a.parteOscura || 0) >= 0.05;
    var puedeNegro = !this.cfg.pegatina && (a.sobreNegro || negroDentro) && hechos.indexOf('negro') === -1;
    /* El color de la tela ya no decide nada: solo hace falta para ENSEÑÁRSELO
       puesto, así que se le pide, pero sin retener el botón. */
    var faltaTela = puedeNegro && !this.tela();
    /* QUITAR EL RECUADRO Y PLANCHAR EN OSCURO SON DOS COSAS DISTINTAS.
     *
     * Estaba atado a la prenda oscura: solo se ofrecía quitar el negro si el
     * cliente elegía una tela oscura. Y el 26/09 llegó por WhatsApp el caso
     * que lo rompe — un logo de línea naranja sobre negro **para pañuelos
     * blancos**. El cliente hacía lo correcto (quitar el recuadro) y la ficha
     * no se lo ofrecía porque no marcaba prenda negra, así que se fue a pelear
     * con un quitafondos de internet sobre un JPEG.
     *
     * Ahora se ofrece en cuanto dice el color, sea el que sea. En oscura sigue
     * siendo la recomendación —es media tinta menos y la prenda transpira—; en
     * clara es una decisión suya, y lo que se hace es avisarla de lo que pierde
     * y enseñárselo en la previa sobre su color. */
    /* Sobre prenda blanca no hay botón de semitono (Xavi 10/10), y entonces tampoco su explicación. */
    var sugNegro = puedeNegro && this.telaSel !== 'blanco';
    var negroOscura = sugNegro && this.telaOscura();
    /* FUERA EL QUITAFONDOS GENÉRICO EN TRANSFERS.
     *
     * Xavi, después de ver al cliente pelearse con uno: «yo quitaría la opción
     * de quitar fondo, que casi siempre se deja algún trozo sin quitar, y
     * activaría lo de recuadro negro siempre que se detecte mucho negro
     * alrededor». Tiene razón y el motivo es de fondo: recortar un dibujo
     * cualquiera es adivinar dónde acaba, y cuando falla deja pegotes; fundir
     * el negro no adivina nada —el negro no se imprime y punto—, así que
     * siempre sale bien.
     *
     * En PEGATINAS sí se queda: ahí quitar el fondo no es cosmética, es lo que
     * hace que el plóter corte por la silueta, y además casi siempre lo hace
     * solo al pedir troquelada. */
    /* Se sigue escondiendo cuando el color del fondo está también dentro del
       dibujo («mezclado»): ahí más tolerancia solo agujerea más. Pero cuando
       el automático simplemente no ha VISTO fondo —blanco con degradado,
       viñeta de cámara— el botón sale, porque el siguiente paso es el
       «quitar más» y ése sí lo saca. */
    /* EN TRANSFERS VUELVE, PERO SOLO PARA EL BLANCO.
       Xavi quitó el quitafondos genérico porque se dejaba trozos, y pidió
       adaptarlo «para cuando el diseño viene en fondo blanco». Así que en
       transfers sale como «Eliminar blanco de fondo», solo cuando el marco
       es claro, y siempre con el −/+ de la tolerancia debajo: si se deja
       algún trozo, el cliente aprieta hasta que sale. */
    var blanco = !this.cfg.pegatina && !!a.fondoClaro;
    var sugFondo = (!!this.cfg.pegatina || blanco) && !(sugNegro && a.sobreNegro) &&
      a.transparente === false && hechos.indexOf('fondo') === -1 &&
      (a.fondoSeparable !== false || a.fondoMotivo === 'sin-fondo');
    if (bFondo) bFondo.textContent = blanco ? 'Eliminar blanco de fondo' : 'Quitar el fondo';
    /* Afinar se ofrece a cualquier archivo pequeño que se quede corto, tenga
       degradados o no: ampliar y suavizar el contorno siempre ayuda algo, y
       si no le convence lo deshace. */
    var baja = this.calidadBaja();
    /* NO SE AFINA LO QUE YA LLEVA SEMITONO (Xavi, 26/09). Afinar endurece la
       transparencia con una curva en S: en un logo limpia el contorno, pero
       tras fundir el negro la transparencia ES el degradado que el taller
       trama, y la curva se lo come — sombras fuera, grises macizos. */
    var sugBordes = hechos.indexOf('bordes') === -1 && hechos.indexOf('negro') === -1 &&
      a.px[0] <= 1500 && baja;
    /* Si lo único que falta para poder arreglarlo es que diga el color, se
       señala la pregunta: el bloque de telas está entre el archivo y esto, y
       con la ficha larga se lee como un paso más de los opcionales. */
    var telaB = $(r, '[data-tela-bloque]');
    if (telaB) telaB.classList.toggle('sdtf-pide', !!faltaTela);
    if (bFondo) bFondo.hidden = !sugFondo;
    if (bNegro) bNegro.hidden = !sugNegro;
    if (bBordes) bBordes.hidden = !sugBordes;
    var bDeshacer = $(r, '[data-deshacer]');
    if (bDeshacer) bDeshacer.hidden = !a.anterior;

    var t = $(r, '[data-arreglos-t]');
    if (t) {
      var ultimo = hechos[hechos.length - 1];
      if (ultimo === 'negro') {
        t.innerHTML = '<b>Listo, con semitono.</b> Más ligero, más suave y transpira mejor. ' +
          'Aquí abajo ves cómo queda de cerca. Si no te convence, deshazlo.';
      } else if (hechos.length) {
        t.innerHTML = ultimo !== 'fondo'
          ? '<b>Listo.</b> Hemos ampliado el archivo y limpiado los bordes dentados.'
          : (a.auto
            ? '<b>Le hemos quitado el fondo.</b> Has pedido troquelada, así que el corte tiene que seguir tu dibujo y no el rectángulo del archivo. Míralo aquí abajo; si lo querías con el fondo, deshaz el cambio.'
            : '<b>Listo.</b> Fondo quitado. Míralo en la vista previa y, si no te convence, deshaz el cambio.');
      } else if (a.mockup) {
        /* FOTO DE LA PRENDA, NO EL DISEÑO. Con lo que se hace hoy con ChatGPT
           es de lo más normal que llegue: dos camisetas con el dibujo puesto.
           Imprimir eso es imprimir una foto de una camiseta encima de la
           camiseta. No se bloquea (puede ser justo lo que quiere), se avisa y
           se le dice cómo sacar el bueno, que le cuesta un minuto. */
        t.innerHTML = '<b>Parece una foto de la prenda con el diseño puesto.</b> Así se imprimiría ' +
          'la foto entera, con la tela y el fondo. Para planchar necesitamos solo el dibujo. Si lo has ' +
          'hecho con ChatGPT, pídele: «dame solo el diseño, sin la camiseta, en PNG con fondo ' +
          'transparente», y súbelo aquí.';
      } else if (sugNegro && negroDentro) {
        /* El semitono como VENTAJA: qué gana, y que lo puede ver antes. */
        t.innerHTML = '<b>El semitono es solo si va sobre prenda negra</b> (u oscura): tu diseño queda más ligero, más suave al tacto, ' +
          'transpira mejor y no hace parche. ' +
          (!this.tela() ? 'Dinos arriba el color de la tela y te lo enseñamos puesto.'
            : this.telaOscura() ? 'Sobre tela oscura es lo que te recomendamos.'
            : 'Sobre tela clara no lo uses: lo negro quedaría del color de la tela.');
      } else if (faltaTela) {
        /* El botón ya está ahí: esto solo pide el color para poder enseñárselo
           puesto sobre su prenda, que es distinto de retenerle el arreglo. */
        t.innerHTML = '<b>Tu diseño trae un recuadro negro alrededor.</b> Si lo quieres fuera, dale a ' +
          '«Eliminar negro + semitono» y se imprimirá solo el dibujo. Dinos también arriba sobre qué ' +
          'color lo vas a planchar y te lo enseñamos puesto.';
      } else if (negroOscura) {
        t.innerHTML = '<b>Se verá solo tu dibujo, sin recuadro.</b> Ese negro de alrededor pasa a ser ' +
          'la tela oscura sobre la que lo planchas, así que no se imprime: la mitad de tinta y la prenda ' +
          'transpira.';
      } else if (sugNegro) {
        /* Sobre tela clara las dos opciones son buenas de verdad y la elige
           él. Lo único que hay que decirle es qué pierde en cada una, que es
           lo que no sabe: que sin recuadro lo blanco de dentro del dibujo se
           confunde con la tela. */
        t.innerHTML = '<b>¿Con recuadro o sin él?</b> Sobre tela clara valen los dos: tal cual se ' +
          'imprime el recuadro negro y queda como lo ves; quitándolo se imprime solo el dibujo y el ' +
          'hueco es la propia tela. Ojo a una cosa, y míralo en la previa: lo que dentro del dibujo sea ' +
          'blanco o muy claro se confundirá con la tela.';
      } else if (this.cfg.pegatina && sugFondo && !this.esTroquel()) {
        /* EN REDONDA/CUADRADA QUITAR EL FONDO YA NO ES UN ARREGLO, ES UN
           GUSTO — Xavi, 28/09: «da la sensación de que hacen pensar que el
           diseño está mal». Con fondo se imprime igual de bien, entero y
           llenando la pegatina (ver PegatinaCorte): no hay nada que corregir,
           así que no se le puede decir «lo arreglamos», que suena a que algo
           falla. Se le dice que va bien y se le deja elegir. En troquelada sí
           sigue siendo un arreglo de verdad, porque ahí decide por dónde
           corta el plóter. En chapas no hay vinilo, así que el «alrededor»
           es blanco liso, no vinilo. */
        t.innerHTML = 'Tu diseño lleva fondo: <b>se imprime igual de bien</b>, entero y hasta el filo. ' +
          'Si prefieres que se vea solo el dibujo, con ' + (this.cfg.chapa ? 'blanco' : (this.cfg.iman ? 'el blanco del imán' : 'el vinilo')) +
          ' alrededor, dale a «Quitar el fondo».';
      } else if (sugFondo || sugBordes) {
        t.innerHTML = 'No hace falta que seas diseñador: <b>lo arreglamos aquí mismo</b>.';
      } else if (a.fondoSeparable === false && a.fondoMotivo === 'sin-fondo' && sugFondo) {
        t.innerHTML = '<b>No vemos un fondo liso en este archivo.</b> Si sí lo tiene —un blanco con ' +
          'sombra o degradado, por ejemplo—, dale a «' + (blanco ? 'Eliminar blanco de fondo' : 'Quitar el fondo') +
          '» y sube la tolerancia hasta que salga limpio.';
      } else if (a.fondoSeparable === false) {
        // no se puede recortar, pero tampoco hace falta: ya está resuelto
        t.innerHTML = a.mascara
          ? '<b>El fondo de este archivo no se puede separar</b> —ese mismo color está también dentro del diseño—, así que cortamos por fuera del conjunto y el fondo se imprime dentro. Es lo que haría un rotulista.'
          : '<b>Este archivo lleva el fondo pegado al diseño</b> y no se puede separar, así que ' + this.elNombre() + ' sale ' + this.gen('entera', 'entero') + ' con él. Si lo quieres recortado de verdad, mándanos el dibujo suelto en PNG o marca el repaso del diseñador.';
      } else if (baja) {
        // se queda corto: se dice sin rodeos, y se dice qué salidas hay
        t.innerHTML = '<b>Este archivo se queda corto para ese tamaño.</b> ' + (this.vectorPosible() && !(this.cfg.pegatina || this.cfg.chapa)
          ? 'Si tienes el diseño en mayor resolución, súbelo en PNG o JPG. Y si no, aquí abajo podemos redibujarlo.'
          : 'Si tienes el diseño en mayor resolución, súbelo en PNG o JPG; y si no, marca el repaso de abajo y te lo redibujamos nosotros.');
      } else {
        t.innerHTML = '<b>Este archivo no necesita arreglos.</b> Fondo transparente y resolución de sobra: entra directo a producción.';
      }
    }
    // antes y después, solo un trozo ampliado del centro
    var comp = $(r, '[data-compara]');
    if (comp) {
      var c = a.comparativa;
      /* Si ha cambiado el tamaño, el punto ya no se ve a escala: se rehace,
         con un respiro para no rehacerlo veinte veces mientras arrastra. */
      var mmAhora = (this.medidaPedida() || [0])[0];
      if (c && c.semitono && mmAhora && Math.abs(mmAhora - c.mm) > 0.5) {
        var self = this, aa = a;
        clearTimeout(this._tSemi);
        this._tSemi = setTimeout(function () {
          if (self.archivo !== aa || !aa.comparativa) return;
          var v = aa.comparativa;
          try {
            aa.comparativa = ImgArreglo.vistaSemitono(v.origen, v.resultado,
              (self.medidaPedida() || [v.mm])[0], v.w, v.h, v.tramaMm);
          } catch (e) { return; }
          self.pintarArreglos();
        }, 180);
      }
      comp.hidden = !c;
      if (c) {
        var ca = $(comp, '[data-antes]'), cd = $(comp, '[data-ahora]');
        ca.innerHTML = ''; ca.appendChild(c.antes);
        cd.innerHTML = ''; cd.appendChild(c.despues);
        /* Con semitono, lo de «ahora» va sobre SU tela: entre punto y punto
           lo que se ve es la prenda, y es justo lo que tiene que juzgar. */
        var tl = this.tela();
        cd.style.background = c.semitono ? (tl ? tl.hex : '#111') : '';
        var caps = comp.querySelectorAll('figcaption');
        if (caps.length > 1) {
          caps[0].textContent = c.semitono ? 'Tal cual' : 'Antes';
          caps[1].textContent = c.semitono ? 'Con semitono' : 'Ahora';
        }
        var nt = $(comp, '.sdtf-compara__nota');
        if (nt) nt.textContent = c.semitono
          ? 'Así se verá de cerca sobre tu tela.'
          : 'Es una zona ampliada de lo que ha cambiado. Lo que se imprime es el archivo entero.';
      }
    }
    /* Los −/+ salen SOLO después de recortar, y solo si el recorte es lo
       último que se ha hecho: ofrecer «quitar más» a quien todavía no ha
       quitado nada no significa nada. */
    var tol = $(r, '[data-tol]');
    if (tol) {
      var recortado = hechos[hechos.length - 1] === 'fondo' || !!a.fondoFallido;
      tol.hidden = !recortado;
      if (recortado) {
        var n = a.tolFondo || 0;
        var nv = $(tol, '[data-tol-nivel]');
        if (nv) nv.textContent = n === 0 ? 'automático' : 'nivel ' + (n > 0 ? '+' + n : String(n));
        var bm = $(tol, '[data-tol-mas]'), bn = $(tol, '[data-tol-menos]');
        if (bm) bm.disabled = n >= TOL_MAX;
        if (bn) bn.disabled = n <= TOL_MIN;
      }
    }
    // el recuadro se ve siempre que haya imagen, aunque no haya nada que tocar:
    // si se escondiera, nadie sabría que la web sabe arreglar archivos
    caja.classList.toggle('is-limpio', !sugFondo && !sugNegro && !sugBordes && !faltaTela && !hechos.length && !a.mockup);
  };

  Subida.prototype.calidadBaja = function () {
    var c = this.calculo();
    if (c && c.dpi) return c.dpi < this.cfg.dpiMin;
    var a = this.archivo;
    return !!(a && a.px && this.anchoNitido((a.pxCalidad || a.px)[0]) < 20);
  };

  Subida.prototype.pintarArchivo = function () {
    var r = this.root, a = this.archivo;
    $(r, '[data-archivo]').hidden = !a;
    $(r, '[data-drop]').hidden = !!a;
    /* La foto del producto manda hasta que hay algo mejor que enseñar: es lo
       que vende en los tres primeros segundos. Con el diseño subido, se aparta
       ella y sus miniaturas —si se quedaran, el cliente las pulsa y no pasa
       nada—. Si quita el archivo, vuelve. */
    if (this.galeria) this.galeria.classList.toggle('sdtf-galeria-oculta', !!a);
    if (!a) return;
    $(r, '[data-nombre]').textContent = a.name;
    var thumb = $(r, '[data-thumb]');
    thumb.innerHTML = '';
    if (a.thumb) thumb.appendChild(a.thumb);
    else thumb.textContent = (a.name.split('.').pop() || '?').toUpperCase();
  };

  /* Medida final y resolución: el diseño se encaja dentro del tamaño de la ubicación */
  Subida.prototype.calculo = function () {
    if (this._libreMala) return null;      // cantidad a medida escrita pero no válida
    var v = this.variante(); if (!v) return null;
    var caja = null, uds = 1;
    v.opts.forEach(function (o) {
      var m = medidaDe(o); if (m) caja = m;
      if (/ud/i.test(o)) uds = cantidadDe(o);
    });
    var out = { variante: v, uds: uds, caja: caja };
    var a = this.archivo;

    /* Pegatinas: la medida no sale de encajar el dibujo en una caja, sino de
       dónde va a cortar el plóter. Lo calcula pegatinas-corte.js, que copia
       las reglas del panel (borde de 3 mm y la forma del formato elegido). */
    if (this.cfg.pegatina && window.PegatinaCorte) {
      var fmt2 = this.formatoVar(v);
      out.formato = fmt2;
      if (fmt2 && a && a.px) {
        out.plan = PegatinaCorte.plan(fmt2, a.pxCalidad || a.px, {
          transparente: a.transparente, arte: a.thumb, silueta: !!a.mascara,
        mascara: a.mascara || a.mascaraCentro || null,
        fondoColor: a.fondoMascara || null,
          filete: !!this.filete, centro: a.centro, pppMin: this.cfg.pppPegatina || 200,
          // el cliente puede elegir grosor y color del filete; sin elegir, sale el de siempre
          borde: this.borde || null, colorVinilo: this.colorVinilo || null,
          // chapas: no hay vinilo ni borde que elegir, siempre a sangre;
          // el cliente ajusta el tamaño y la posición del dibujo dentro
          chapa: !!this.cfg.chapa, iman: !!this.cfg.iman, libre: !!this.cfg.libre, zoom: this.zoom || null,
          panX: this.panX || 0, panY: this.panY || 0
        });
        out.mm = [out.plan.arteW, out.plan.arteH];
        out.dpi = out.plan.ppp;
      }
      return out;
    }

    /* LA MEDIDA ES LA QUE HA PEDIDO, no la de la caja. La caja solo decide el
       precio: si escribe 12 cm y cae en la de «hasta 20×25», se imprime a 12,
       no a 20. Encajarlo en la caja era lo de antes, cuando la caja ERA la
       elección; ahora la elección son los centímetros. */
    var pedida = this.medidaPedida();
    if (pedida) {
      out.mm = pedida;
      out.dpi = (a.pxCalidad || a.px)[0] / (out.mm[0] / 25.4);
      return out;
    }
    if (caja && a && a.px) {
      var esc2 = Math.min(caja.w / a.px[0], caja.h / a.px[1]);
      out.mm = [a.px[0] * esc2, a.px[1] * esc2];
      out.dpi = (a.pxCalidad || a.px)[0] / (out.mm[0] / 25.4);
    }
    return out;
  };

  /* Traducción de los ppp a algo entendible: nota de 1 a 10 y frase corta.
     A partir de 250 ppp es nítido; por debajo de 150 se nota al imprimir. */
  Subida.prototype.calidad = function (dpi) {
    var esc = [[300, 10], [250, 9], [220, 8.5], [180, 8], [150, 7], [120, 6], [100, 5], [80, 4], [60, 3], [0, 2]];
    var nota = 2;
    for (var i = 0; i < esc.length; i++) {
      if (dpi >= esc[i][0]) {
        var sup = i === 0 ? null : esc[i - 1];
        nota = sup ? esc[i][1] + (sup[1] - esc[i][1]) * (dpi - esc[i][0]) / (sup[0] - esc[i][0]) : 10;
        break;
      }
    }
    nota = Math.max(1, Math.min(10, Math.round(nota * 10) / 10));
    if (dpi >= this.cfg.dpiGood) return { n: nota, k: 'ok', t: 'Se verá nítido' };
    if (dpi >= this.cfg.dpiMin) return { n: nota, k: 'mid', t: 'Se verá bien a este tamaño' };
    return { n: nota, k: 'low', t: 'A este tamaño perderá definición' };
  };

  // ancho máximo (cm) al que ese archivo se ve nítido
  Subida.prototype.anchoNitido = function (px) {
    return px / (this.cfg.dpiGood / 2.54) ;
  };

  Subida.prototype.flash = function (msg) {
    if (window.Cargando) Cargando.aviso(msg, 7000);
  };


  /* INSERTAR UN TEXTO (Xavi, 02/10): «Sube tu diseño» o «Inserta un texto», una cosa o la otra, para quien quiere
     pegatinas con nombres. Un texto no es una cosa nueva: es otra forma de fabricar un diseño. Se escribe, se dibuja
     con texto.js (las mismas fuentes que la ropa) en un PNG transparente a 300 ppp y se carga como si el cliente
     lo hubiera subido: previa, corte, precio y pedido son los de siempre. */
  Subida.prototype.abrirTexto = async function (btn) {
    var self = this;
    if (!window.Texto || !window.ImgArreglo) return this.flash('El editor de texto no ha cargado. Recarga la página.');
    var panel = this._panelTexto;
    if (!panel) {
      panel = this._panelTexto = document.createElement('div');
      panel.className = 'sdtf-texto';
      panel.innerHTML =
        '<label class="sdtf-texto__l">Tu texto <textarea rows="2" maxlength="60" placeholder="Escribe aquí (hasta 3 líneas)" data-texto-valor></textarea></label>' +
        '<p class="sdtf-texto__t">Letra</p><div class="sdtf-texto__fuentes" data-texto-fuentes></div>' +
        '<p class="sdtf-texto__t">Color</p><div class="sdtf-texto__colores" data-texto-colores></div>' +
        '<p class="sdtf-muted sdtf-texto__nota" data-texto-nota hidden>El blanco solo se ve si pones un borde de color: sobre el vinilo blanco no se vería.</p>' +
        '<div class="sdtf-texto__acc"><button type="button" class="sdtf-texto__ok" data-texto-ok>Añadir texto</button>' +
        '<button type="button" class="sdtf-texto__no" data-texto-no>Cancelar</button></div>';
      this._textoSel = { fuente: Texto.FUENTES[0].id, color: '#111111' };
      var fb = panel.querySelector('[data-texto-fuentes]'), cb = panel.querySelector('[data-texto-colores]');
      Texto.FUENTES.forEach(function (f) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sdtf-texto__f'; b.textContent = f.nombre;
        b.style.fontFamily = f.css; b.setAttribute('data-id', f.id);
        b.addEventListener('click', function () { self._textoSel.fuente = f.id; self.marcarTexto(); });
        fb.appendChild(b);
      });
      ['#111111', '#ffffff', '#e31b23', '#0057d9', '#1b8a0b', '#ff7a00', '#7a2be0'].forEach(function (c) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sdtf-pega__color'; b.style.background = c;
        b.setAttribute('data-color', c);
        b.addEventListener('click', function () { self._textoSel.color = c; self.marcarTexto(); });
        cb.appendChild(b);
      });
      panel.querySelector('[data-texto-no]').addEventListener('click', function () { panel.hidden = true; });
      panel.querySelector('[data-texto-ok]').addEventListener('click', async function () {
        var ta = panel.querySelector('[data-texto-valor]'), txt = ta.value;
        if (!Texto.lineas(txt, 3).length) { ta.focus(); return; }
        var ok = panel.querySelector('[data-texto-ok]'); ok.disabled = true; ok.textContent = 'Preparando…';
        try {
          await Texto.cargar();
          var r = Texto.pinta(txt, { fuente: self._textoSel.fuente, color: self._textoSel.color, cajaCm: [10, 10], maxLineas: 3 });
          if (!r) throw new Error('vacío');
          var slug = r.lineas.join(' ').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 30) || 'texto';
          var file = await ImgArreglo.aFichero(r.lienzo, 'texto-' + slug + '.png');
          self._cargandoTexto = true;
          await self.cargar(file);
          self._cargandoTexto = false;
          var f = Texto.fuenteDe(self._textoSel.fuente);
          self._texto = { texto: r.lineas.join('\n'), fuente: f.id, nombreFuente: f.nombre, color: self._textoSel.color };
          panel.hidden = true;
          self.actualizar();
        } catch (e) { self._cargandoTexto = false; self.flash('No se ha podido crear el texto. Prueba otra vez.'); }
        ok.disabled = false; ok.textContent = 'Cambiar texto';
      });
    }
    var sitio = btn.closest('[data-texto-o], .sdtf-archivo') || btn;
    sitio.insertAdjacentElement('afterend', panel);
    panel.hidden = false;
    if (this._texto) {
      panel.querySelector('[data-texto-valor]').value = this._texto.texto;
      this._textoSel.fuente = this._texto.fuente; this._textoSel.color = this._texto.color;
    }
    panel.querySelector('[data-texto-ok]').textContent = this._texto ? 'Cambiar texto' : 'Añadir texto';
    this.marcarTexto();
    Texto.cargar();   // las fuentes se bajan la primera vez que se abre
    panel.querySelector('[data-texto-valor]').focus();
    if (panel.scrollIntoView) panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  };
  Subida.prototype.marcarTexto = function () {
    var panel = this._panelTexto, sel = this._textoSel;
    if (!panel) return;
    Array.prototype.forEach.call(panel.querySelectorAll('.sdtf-texto__f'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-id') === sel.fuente); });
    Array.prototype.forEach.call(panel.querySelectorAll('[data-color]'), function (b) { b.classList.toggle('is-on', b.getAttribute('data-color') === sel.color); });
    var nota = panel.querySelector('[data-texto-nota]'); if (nota) nota.hidden = sel.color !== '#ffffff';
  };

  Subida.prototype.actualizar = function () {
    if (this.libre() && this.archivo && this.archivo.px && this.iman) {
      if (this._imanArch !== this.archivo.name) {
        this._imanArch = this.archivo.name;
        this.panX = 0; this.panY = 0; this.zoom = null;
        if (this.orientarIman()) { this.ajustarCajaIman(); this.pintarOpcionesIman(); }
      }
    }
    /* El ancho se fija ANTES de calcular nada. Si se dejaba para el momento de
       pintarlo, la primera pasada tras subir el archivo calculaba la medida y
       el precio con el ancho todavía sin poner, y el botón enseñaba un importe
       que cambiaba solo medio segundo después. */
    this.asegurarAncho();
    var r = this.root, c = this.calculo(), a = this.archivo;
    var tO = $(r, '[data-texto-o]'); if (tO) tO.hidden = !!a;
    var self0 = this.cajaPega, hayTexto0 = !!this._texto;
    var tE = $(r, '[data-texto-ed]'); if (tE) tE.hidden = !(a && this._texto);
    Array.prototype.forEach.call(document.querySelectorAll('[data-pega-lienzo], [data-thumb]'), function (z) {
      if (!(r.contains(z) || (self0 && self0.contains(z)))) return;
      if (hayTexto0) z.setAttribute('title', 'Doble clic para editar el texto'); else z.removeAttribute('title');
      z.style.cursor = hayTexto0 ? 'pointer' : '';
    });
    var info = $(r, '[data-info]'), partes = [];
    if (a && c) {
      if (c.mm) {
        var q = this.calidad(c.dpi);
        partes.push('Se imprimirá a ' + fmt(c.mm[0] / 10, 1) + ' × ' + fmt(c.mm[1] / 10, 1) + ' cm');
        partes.push('<span class="sdtf-calidad sdtf-calidad--' + q.k + '">' +
          '<span class="sdtf-calidad__barra"><i style="width:' + (q.n * 10) + '%"></i></span>' +
          '<b>Calidad ' + fmt(q.n, q.n % 1 ? 1 : 0) + '/10</b> · ' + q.t + '</span>');
        if (q.k === 'low') {
          var maxCm = this.anchoNitido((a.pxCalidad || a.px)[0]);
          var hecho = (a.arreglos || []).indexOf('bordes') !== -1;
          partes.push('<span class="sdtf-consejo">' + (hecho
            ? 'Con esta resolución ya no se puede sacar más: los bordes están limpios, pero el detalle que no está no se inventa. Se ve fino hasta unos ' + fmt(maxCm, 1) + ' cm de ancho. Si en algún cajón tienes el logo en PDF, AI o EPS, mándanoslo y lo cambiamos.'
            : 'Se imprime igual, pero si puedes mándanos el archivo más grande. Con este se ve nítido hasta unos ' + fmt(maxCm, 1) + ' cm de ancho.') + '</span>');
        }
      } else if (a.px) {
        var ancho = this.anchoNitido((a.pxCalidad || a.px)[0]);
        var kk = ancho >= 50 ? 'ok' : (ancho >= 20 ? 'mid' : 'low');
        partes.push('<span class="sdtf-badge sdtf-badge--' + kk + '">' +
          (kk === 'ok' ? 'Resolución de sobra' : kk === 'mid' ? 'Resolución correcta' : 'Resolución justa') + '</span>');
        var pxq = a.pxCalidad || a.px;
        partes.push('Son ' + pxq[0] + ' × ' + pxq[1] + ' px: se ve nítido hasta ' + fmt(ancho, 1) + ' cm de ancho.');
      } else {
        partes.push('Comprobaremos el archivo antes de imprimir y te avisamos si hay algo raro.');
      }
      if (a.transparente === false) {
        /* UN FONDO NEGRO NO ES «UN FONDO» CUALQUIERA.
           Decirle «tal cual se imprimiría el fondo también» a quien sube un
           escudo sobre negro es darle por cerrado lo que justo le estamos a
           punto de arreglar dos bloques más abajo: se queda con que va a
           recibir un parche negro y ni sigue leyendo. */
        var negroPend = !this.cfg.pegatina && a.sobreNegro && (a.arreglos || []).indexOf('negro') === -1;
        partes.push(a.mascara
          ? '<span class="sdtf-badge sdtf-badge--ok">Troquel por la silueta</span> Cortamos por fuera de tu dibujo y el fondo que queda dentro se imprime.'
          : (c.plan && c.plan.sangra
            ? '<span class="sdtf-badge sdtf-badge--ok">A sangre</span> El fondo se imprime: ' + this.elNombre() + ' sale ' + this.gen('entera', 'entero') + ' de color, sin blanco alrededor.'
            : negroPend
              ? '<span class="sdtf-badge sdtf-badge--mid">Recuadro negro</span> ' + (!this.tela()
                ? 'Si lo quieres sin recuadro, justo aquí abajo te lo quitamos y se verá solo el dibujo.'
                : this.telaOscura()
                  ? 'Aquí abajo te lo quitamos: se imprime solo tu dibujo, sin recuadro.'
                  /* También sobre tela clara: el que estampa un dibujo de línea
                     en un pañuelo blanco quiere el recuadro fuera igual. */
                  : 'Si lo quieres sin recuadro, aquí abajo te lo quitamos.')
              : '<span class="sdtf-badge sdtf-badge--mid">Tiene fondo</span> Tal cual se imprimiría el fondo también.'));
      }
      if (info) info.innerHTML = partes.join(' ');
    }
    this.pintarMedida();
    this.pintarCantidad();
    this.pintarPausa();
    this.pintarArreglos();
    this.pintarVector();
    this.pintarPegatina(c);

    /* El repaso es un servicio de pago, así que nunca se marca solo: lo elige
       el cliente viendo el precio. Si el archivo viene regular se lo
       recomendamos, pero no se le cuela nada en el carrito. */
    /* Tener fondo solo es un problema cuando hay que quitarlo. En una redonda o
       una cuadrada que va a sangre el fondo ES la pegatina, así que ahí no se
       le recomienda pagar un repaso por eso. */
    var fondoEstorba = !!(a && a.transparente === false) &&
      !(c && c.plan && c.plan.sangra) && !(a && a.mascara);
    var baja = !!(c && c.dpi && c.dpi < this.cfg.dpiMin) || fondoEstorba;
    var repaso = $(r, '[data-repaso]'), wrap = $(r, '[data-repaso-wrap]');
    var serv = this.cfg.repaso;
    if (repaso && wrap) {
      wrap.hidden = !a || !serv;
      var precio = $(r, '[data-repaso-precio]');
      if (precio && serv) precio.textContent = '· ' + money(serv.precio);
      wrap.classList.toggle('is-marcado', repaso.checked);
      wrap.classList.toggle('is-avisando', baja && !repaso.checked);
      var aviso = $(r, '[data-repaso-aviso]');
      if (aviso) {
        aviso.hidden = !baja || repaso.checked;
        aviso.textContent = fondoEstorba
          ? 'Con este archivo te lo recomendamos: tiene fondo y hay que recortarlo bien.'
          : 'Con este archivo te lo recomendamos: va justo de resolución.';
      }
      var nota = $(r, '[data-repaso-nota]');
      if (nota) {
        nota.hidden = !(a && !repaso.checked);
        // si el archivo está bien, se dice: así nadie paga un repaso que no necesita
        nota.textContent = baja
          ? 'Si no lo marcas lo imprimimos tal cual, sin tocarlo. Aun así, si al abrirlo vemos algo grave te escribimos antes de producir: eso no se cobra.'
          : 'Este archivo entra directo a producción tal cual: no necesita repaso.';
      }
    }
    var viejo = $(r, '[data-acepta-wrap]');
    if (viejo) viejo.hidden = true;

    var extra = this.extras();
    var btn = $(r, '[data-add]');
    if (!this.busy && window.Cargando) Cargando.libre(btn);
    btn.disabled = !a || this.busy || !c;
    var bpres = $(r, '[data-presupuesto]');
    if (bpres && !this._presBusy) bpres.disabled = !a || this.busy || !c;
    if (!this.busy) btn.textContent = c ? 'Añadir al carrito · ' + money(c.variante.precio + extra) : 'Añadir al carrito';
    /* el de arriba, con el mismo número: si discrepan, el cliente no sabe cuál creer */
    this.pintarPrecioTema(c, extra);
  };

  /* ---------- pegatinas: cómo va a quedar cortada ---------- */
  /* El color que hay DETRÁS del lienzo, subiendo por los padres hasta
     encontrar uno que pinte. Igual que en cargando.js, y por lo mismo: el
     lienzo es transparente y lo que se ve es la página. */
  function fondoDe(el) {
    while (el && el.nodeType === 1) {
      var col = getComputedStyle(el).backgroundColor || '';
      var m = col.match(/^rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?/);
      if (m && (m[4] === undefined || parseFloat(m[4]) > 0.5)) {
        return 'rgb(' + m[1] + ',' + m[2] + ',' + m[3] + ')';
      }
      el = el.parentElement;
    }
    return '#ffffff';
  }

  Subida.prototype.pintarPegatina = function (c) {
    var a = this.archivo;
    /* OJO: la caja puede estar fuera de root, mudada a la columna de la foto,
       así que todo lo de dentro se busca desde la caja y no desde la ficha. */
    var caja = this.cajaPega || $(this.root, '[data-pega]');
    if (!caja) return;
    var r = caja;
    var hay = !!(this.cfg.pegatina && window.PegatinaCorte && a && a.thumb && c && c.plan);
    /* PDF, AI o EPS: para cortar son LOS archivos buenos, pero el navegador no
       los sabe dibujar, así que no hay previa. Antes esto dejaba la zona en
       blanco y el cliente se quedaba sin saber a qué medida sale ni cuánto le
       cuesta cada una. Ahora se le dice con palabras lo que no se puede
       enseñar con un dibujo. */
    var vectorial = !!(this.cfg.pegatina && window.PegatinaCorte && a && !a.thumb && c && c.formato);
    caja.hidden = !hay && !vectorial;
    if (caja.hidden) return;

    var lienzo = $(caja, '[data-pega-lienzo]');
    var envoltorio = lienzo ? lienzo.parentElement : null;
    var titulo = caja.querySelector('.sdtf-pega__t');
    var leyenda = caja.querySelector('.sdtf-pega__leyenda');

    if (vectorial) {
      if (envoltorio) envoltorio.hidden = true;
      if (leyenda) leyenda.hidden = true;
      if (titulo) titulo.textContent = this.cfg.chapa ? 'Qué vamos a imprimir' : 'Qué vamos a cortar';
      var f = c.formato;
      var med0 = $(r, '[data-pega-medida]');
      if (med0) {
        med0.innerHTML = this.cfg.chapa
          ? '<b>Chapa de ' + fmt(f.w, 0) + ' mm.</b> ' +
            'Tu archivo es vectorial, que para imprimir es el mejor que nos puedes mandar. Aquí no te lo podemos dibujar, ' +
            'pero se imprime a sangre, llenando la chapa entera.'
          : f.forma === 'libre'
          ? '<b>Troquelada a tu forma, hasta ' + fmt(f.w / 10, 1) + ' × ' + fmt(f.h / 10, 1) + ' cm.</b> ' +
            'Tu archivo es vectorial, que para cortar es el mejor que nos puedes mandar. Aquí no te lo podemos dibujar, ' +
            (this.cfg.iman ? 'pero lo montamos a ese tamaño y lo cortamos por el contorno, sin borde.'
              : 'pero lo montamos a ese tamaño con ' + fmt(PegatinaCorte.bordePara(f), 1) + ' mm de borde blanco siguiendo el contorno.')
          : '<b>' + (f.forma === 'redonda' ? 'Redonda' : 'Rectangular') + ' de ' +
            fmt(f.w / 10, 1) + ' × ' + fmt(f.h / 10, 1) + ' cm.</b> ' +
            'Tu archivo es vectorial, que para imprimir es el mejor que nos puedes mandar. Aquí no te lo podemos dibujar, ' +
            'pero lo centramos dentro de esa medida, sin deformarlo y con ' +
            fmt(PegatinaCorte.bordePara(f), 1) + ' mm libres hasta el filo.';
      }
      var lis0 = $(r, '[data-pega-avisos]');
      if (lis0) { lis0.innerHTML = ''; lis0.hidden = true; }
      var uds0 = $(r, '[data-pega-unidad]');
      if (uds0) {
        var t0 = c.variante.precio + this.extras();
        uds0.textContent = c.uds > 1
          ? c.uds + ' ' + this.nombrePega(true) + ', a ' + money(Math.round(t0 / c.uds)) + ' cada ' + this.gen('una', 'uno') + '.' : '';
      }
      return;
    }

    if (envoltorio) envoltorio.hidden = false;
    if (leyenda) leyenda.hidden = false;
    if (titulo) titulo.textContent = this.cfg.chapa ? 'Así se va a prensar' : 'Así se va a cortar';

    var p = c.plan;
    /* Con un archivo que tapa la pegatina entera hay dos acabados buenos, y
       el que manda es el cliente: a sangre (el dibujo llega al filo) o con el
       filete blanco del vinilo alrededor, que es la pegatina clásica. Ese
       interruptor solo sale cuando hay elección entre las dos: en troquelada
       y en un PNG recortado (logo o foto sin fondo) el blanco va siempre —
       ahí no hay «a sangre» posible—, pero el grosor y el color de ese
       blanco los sigue eligiendo el cliente igual, solo que sin el
       interruptor. Antes se excluía troquelada de esto (Xavi, 28/09: «no me
       deja cambiar el tamaño de borde y por defecto es muy grueso»): en un
       diseño estrecho —un tirante, una silueta alargada— el borde de
       siempre se nota mucho más que en uno ancho, y no había manera de
       bajarlo. */
    /* LAS CHAPAS NO TIENEN NADA DE ESTO: siempre van a sangre, sin vinilo ni
       borde que elegir (Xavi, 28/09, al migrarlas de Qstomizer), así que ni
       el interruptor ni el mando de grosor/color tienen sentido aquí. Lo que
       sí tienen es el zoom: el dibujo entra entero por defecto, y el mando
       deja al cliente hacerlo más grande (aunque se recorte) o más pequeño. */
    if (this.cfg.chapa) {
      this.pintarFilete(false, 0, null);
      this.pintarZoom(caja);
    } else if (this.cfg.iman) {
      /* IMANES: ni margen blanco, ni borde, ni color de borde, en ninguna forma
         (Xavi, 01/10: «viene heredado de las pegatinas»). El diseño llena la
         forma y el cliente solo decide tamaño y posición de la imagen; en
         «a tu forma» el corte va pegado a la silueta, sin mandos. */
      // (14/10, Xavi) el color del imán SÍ se elige: ya no se borra aquí en cada repintado, por eso no cambiaba nada
      this.pintarFilete(true, p.filete || (window.PegatinaCorte.bordePara ? PegatinaCorte.bordePara(c.formato || {}) : 3), null);
      if (p.forma !== 'libre') this.pintarZoom(caja);
      else { var zz0 = caja.querySelector('[data-pega-zoom]'); if (zz0) zz0.hidden = true; }
    } else {
      var esLogo = !p.sangra;
      this.pintarFilete(!!p.sangra || !!this.filete,
        p.filete || (window.PegatinaCorte.bordePara ? PegatinaCorte.bordePara(c.formato || {}) : 3),
        esLogo ? p.borde : null);
      // pegatinas a tu medida: si el diseño va a sangre, zoom y posición como en los imanes
      if (this.cfg.libre) {
        if ((p.sangra || a.transparente === false) && p.forma !== 'libre') this.pintarZoom(caja);
        else { var zz1 = caja.querySelector('[data-pega-zoom]'); if (zz1) zz1.hidden = true; }
      }
      /* IMANES: si el dibujo llena la forma (a sangre) el cliente decide qué ve
         — tamaño de la imagen y posición—, igual que en las chapas. Un póster
         en un imán redondo pierde arriba y abajo, y el título suele estar ahí. */

    }
    /* Se mide la caja ya destapada; si aun así da 0 (pasa cuando el bloque
       entra en una pestaña cerrada) se pregunta hacia arriba antes de tirar de
       un número inventado. El suelo es 180 para que quepa en un móvil de 320.
       El tope subía a 340 fijos y en un móvil ancho (o el escritorio) dejaba
       medio bloque en gris sin usar — Xavi, 28/09: «el previo no aprovecha la
       pantalla». Ahora usa lo que haya, con un tope solo para que en una
       pantalla enorme no se vea gigante. */
    var hueco = caja.clientWidth || this.root.clientWidth ||
      (caja.parentElement ? caja.parentElement.clientWidth : 0) || 340;
    var ancho = Math.max(180, Math.min(520, hueco - 28));
    /* LAS COTAS SE PINTAN CON LA TINTA DEL TEMA, no en negro fijo. El lienzo
       es transparente y detrás está la página: en el tema oscuro un número
       negro no se lee. La etiqueta lleva debajo el color de fondo de verdad
       para que el número no se coma la flecha ni el ajedrez. */
    var oscuro = !!(window.Cargando && Cargando.oscuro && Cargando.oscuro(caja));
    try {
      var dib = PegatinaCorte.dibujar(lienzo, a.thumb, p, {
        ancho: ancho, mascara: a.mascara, fondoColor: a.fondoMascara || null,
        colorVinilo: this.colorVinilo || null,
        chapa: !!this.cfg.chapa, iman: !!this.cfg.iman,
        sombra: this.libre() && p.forma !== 'libre',
        cotas: true,
        tinta: oscuro ? 'rgba(255,255,255,.92)' : 'rgba(0,0,0,.8)',
        suave: oscuro ? 'rgba(255,255,255,.4)' : 'rgba(0,0,0,.3)',
        fondoEtiqueta: fondoDe(caja)
      });
      // fondo liso (sin ajedrez) cuando la pieza lleva sombra
      if (lienzo.parentNode && lienzo.parentNode.classList) lienzo.parentNode.classList.toggle('is-plano', this.libre() && p.forma !== 'libre');
      // en chapas, el cliente puede arrastrar el dibujo dentro del lienzo
      if ((this.cfg.chapa || (this.cfg.iman && p.forma !== 'libre') || (this.cfg.libre && (p.sangra || a.transparente === false) && p.forma !== 'libre')) && dib) {
        this.arrastrarChapa(lienzo, dib.escala, p.cutW);
      }
    } catch (e) { caja.hidden = true; return; }

    var medida = $(r, '[data-pega-medida]');
    if (medida) {
      /* LAS CHAPAS SE PIDEN POR EL DIÁMETRO EN MM (31, 38, 50, 59…), NO POR
         ANCHO × ALTO EN CM: es como venían ya en Qstomizer y como las conoce
         el cliente («una chapa de 38»), así que aquí se respeta esa forma de
         nombrarlas en vez de la de las pegatinas. */
      var nombre = this.cfg.chapa
        ? '<b>Chapa de ' + fmt(p.cutW, 0) + ' mm.</b> '
        : '<b>' + (p.forma === 'redonda' ? 'Redonda' : (p.forma === 'cuadrada' ? 'Rectangular' : 'Troquelada a tu forma')) +
          ' de ' + fmt(p.cutW / 10, 1) + ' × ' + fmt(p.cutH / 10, 1) + ' cm.</b> ';
      medida.innerHTML = nombre +
        /* CON FONDO DE COLOR NO SE RECORTA NADA, y decir que sí sería asustar
           al cliente con un problema que no tiene: el que llena la pegatina es
           el fondo de su diseño, y el dibujo va dentro entero. */
        (p.relleno
          ? (p.filete
            ? 'Tu diseño se ve entero, y su propio fondo llena ' + this.elNombre() + ' hasta ' + fmt(p.filete, 1) +
              ' mm del filo, con el borde blanco' + (this.cfg.iman ? '' : ' del vinilo') + ' alrededor.'
            : 'Tu diseño se ve entero y su propio fondo llena ' + this.elNombre() + ' hasta el filo' +
              (p.forma === 'redonda' ? ', sin cortar las esquinas' : '') + '. No se recorta nada.')
          : p.sangra
          ? (this.cfg.chapa
            /* En chapas «a sangre» no significa que se recorte: por defecto
               el diseño entra entero (el zoom empieza en el que cabe justo)
               y solo se pierde algo si el cliente sube el zoom él mismo —
               p.recorte ya lo sabe, así que el texto no dice de más. */
            ? (p.recorte >= 0.06
              ? 'Con este zoom se recorta alrededor del ' + Math.round(p.recorte * 100) + ' % de los bordes de tu diseño.'
              : 'Tu diseño se ajusta entero dentro de la chapa.')
            : p.filete
            ? 'Tu diseño llena ' + this.elNombre() + ' hasta ' + fmt(p.filete, 1) + ' mm del filo, con el borde blanco ' +
              (this.cfg.iman ? 'alrededor' : 'del vinilo alrededor') + '. Lo que se sale de esa forma se recorta.'
            : 'Tu diseño va a sangre: tapa ' + this.elNombre() + ' ' + this.gen('entera', 'entero') + ' y se corta lo que se sale' +
              (p.forma === 'redonda' ? ' del círculo' : '') + '. Sin blanco alrededor.')
          : (this.cfg.iman
            ? (p.forma === 'libre'
              ? 'Tu diseño irá a ' + fmt(p.arteW / 10, 1) + ' × ' + fmt(p.arteH / 10, 1) + ' cm, ' +
                (this.filete ? 'con ' + fmt(p.borde, 1) + ' mm de borde blanco siguiendo el contorno.' : 'cortado justo por el contorno, sin borde.')
              : 'Tu diseño irá a ' + fmt(p.arteW / 10, 1) + ' × ' + fmt(p.arteH / 10, 1) + ' cm, dentro de la zona de seguridad (' + fmt(p.seguridad, 0) + ' mm del filo).')
            : 'Tu diseño irá a ' + fmt(p.arteW / 10, 1) + ' × ' + fmt(p.arteH / 10, 1) + ' cm, ' +
              'con ' + fmt(p.borde, 1) + ' mm de borde ' +
              (this.colorVinilo ? 'de color alrededor.' : 'blanco alrededor.')));
    }
    var lista = $(r, '[data-pega-avisos]');
    if (lista) {
      lista.innerHTML = p.avisos.map(function (av) {
        return '<li class="sdtf-pega__aviso sdtf-pega__aviso--' + av.tipo + '">' + esc(av.texto) + '</li>';
      }).join('');
      lista.hidden = !p.avisos.length;
    }
    var uds = $(r, '[data-pega-unidad]');
    if (uds) {
      var extra = this.extras();
      var total = c.variante.precio + extra;
      uds.textContent = c.uds > 1
        ? c.uds + ' ' + this.nombrePega(true) + ', a ' + money(Math.round(total / c.uds)) + ' cada ' + this.gen('una', 'uno') + '.'
        : '';
    }
  };

  /* El interruptor de acabado. Se inyecta desde aquí en vez de vivir en el
     snippet porque solo existe en un caso, y así no hay markup muerto en las
     fichas que no lo usan. */
  Subida.prototype.pintarFilete = function (sale, mm, logoMM) {
    var self = this, caja = this.cajaPega || $(this.root, '[data-pega]');
    if (!caja) return;
    var barra = caja.querySelector('[data-pega-filete]');
    caja.classList.toggle('is-iman', !!this.cfg.iman);
    caja.classList.toggle('is-libre', !!this.cfg.libre);   // la previa vive fuera de .sdtf: la marca va en su propia caja
    /* SIN FONDO NO HAY «A SANGRE»: en una foto recortada (o un logo) siempre
       hay margen alrededor, así que no se ofrece el interruptor —no hay nada
       entre lo que elegir—, pero el grosor y el color de ese margen sí son
       cosa del cliente igual que en las que sangran. */
    if (logoMM != null) {
      if (barra) barra.hidden = true;
      this.filete = true;
      this.pintarFileteExtra(caja, logoMM);
      return;
    }
    if (!sale) {
      if (barra) barra.hidden = true;
      var extra0 = caja.querySelector('[data-pega-filete-extra]');
      if (extra0) extra0.hidden = true;
      return;
    }
    if (!barra) {
      // por defecto, la pegatina clásica: con borde blanco puesto
      if (this.filete == null) this.filete = !this.cfg.iman;
      barra = document.createElement('div');
      barra.className = 'sdtf-pega__filete';
      barra.setAttribute('data-pega-filete', '');
      [['0', self.cfg.iman ? 'Sin borde' : 'Sin borde, a sangre'], ['1', 'Con borde blanco']].forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sdtf-pega__fb';
        b.textContent = o[1];
        b.addEventListener('click', function () {
          self.filete = o[0] === '1';
          self.actualizar();
        });
        barra.appendChild(b);
      });
      var leyenda = caja.querySelector('.sdtf-pega__leyenda');
      caja.insertBefore(barra, leyenda || null);
    }
    barra.hidden = false;
    var btns = barra.querySelectorAll('.sdtf-pega__fb');
    btns[0].classList.toggle('is-on', !this.filete);
    btns[1].classList.toggle('is-on', !!this.filete);
    if (mm) btns[1].textContent = 'Con borde blanco de ' + fmt(mm, 1) + ' mm';
    this.pintarFileteExtra(caja, mm);
  };

  /* Grosor y color del filete: solo tienen sentido con «Con borde» puesto,
     así que viven aparte y se esconden con lo otro. El grosor por defecto
     es el que calcula el panel (bordePara); tocar el mando fija uno propio.
     El color por defecto es el vinilo de fábrica, blanco; si el cliente
     elige otro, se avisa de que hay que imprimirlo (no es el plástico en
     crudo) — Xavi, 28/09. */
  Subida.prototype.PEGA_COLORES = [
    ['#ffffff', 'Blanco (vinilo)'], ['#17171a', 'Negro'], ['#27aa13', 'Verde'],
    ['#F61F1F', 'Rojo'], ['#005BD3', 'Azul'], ['#FFE500', 'Amarillo']
  ];
  Subida.prototype.pintarFileteExtra = function (caja, mmAuto) {
    var self = this;
    var extra = caja.querySelector('[data-pega-filete-extra]');
    if (!extra) {
      extra = document.createElement('div');
      extra.className = 'sdtf-pega__filete-extra';
      extra.setAttribute('data-pega-filete-extra', '');
      extra.innerHTML =
        '<label class="sdtf-pega__grosor">Grosor <span data-pega-grosor-mm></span>' +
        '<input type="range" min="' + PegatinaCorte.BORDE_MIN + '" max="' + PegatinaCorte.BORDE +
        '" step="0.1" data-pega-grosor></label>' +
        '<div class="sdtf-pega__colores-t" data-pega-colores-t></div>' +
        '<div class="sdtf-pega__colores" data-pega-colores></div>';
      var colores = extra.querySelector('[data-pega-colores]');
      this.PEGA_COLORES.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sdtf-pega__color';
        b.style.background = c[0];
        b.title = c[1];
        b.setAttribute('data-color', c[0]);
        b.addEventListener('click', function () {
          self.colorVinilo = c[0] === '#ffffff' ? null : c[0];
          self.actualizar();
        });
        colores.appendChild(b);
      });
      /* REDIBUJAR VA CON RETARDO, NO A CADA PASO DEL MANDO — Xavi, 28/09: «va
         lento al hacer cambios». En troquelada, actualizar() vuelve a calcular
         todo el contorno pixel a pixel (el campo de distancia de la silueta),
         y el mando de rango dispara «input» decenas de veces por segundo
         mientras se arrastra: cada tic intentaba ese cálculo entero, y con el
         lienzo más ancho de ahora (para aprovechar la pantalla) pesa más
         todavía. La etiqueta del mm sí se actualiza al instante —eso es
         gratis—, y el redibujado de verdad espera a que el dedo se pare un
         momento. */
      extra.querySelector('[data-pega-grosor]').addEventListener('input', function (e) {
        self.borde = parseFloat(e.target.value);
        e.target.style.setProperty('--sdtf-llena', ((e.target.value - e.target.min) / (e.target.max - e.target.min) * 100) + '%');
        var lbl = extra.querySelector('[data-pega-grosor-mm]');
        if (lbl) lbl.textContent = fmt(self.borde, 1) + ' mm';
        clearTimeout(self._tGrosor);
        self._tGrosor = setTimeout(function () { self.actualizar(); }, 90);
      });
      var leyenda2 = caja.querySelector('.sdtf-pega__leyenda');
      caja.insertBefore(extra, leyenda2 || null);
    }
    var esIman = !!this.cfg.iman;   // imanes: el color se elige también «Sin borde» (es el color del imán detrás del dibujo)
    extra.hidden = !this.filete && !esIman;
    var gro = extra.querySelector('.sdtf-pega__grosor'); if (gro) gro.hidden = !this.filete;
    var tc = extra.querySelector('[data-pega-colores-t]');
    if (tc) { tc.textContent = esIman ? (this.filete ? 'Color del borde y del fondo del imán' : 'Color del fondo del imán') : ''; tc.hidden = !esIman; }
    if (!this.filete && !esIman) return;
    var input = extra.querySelector('[data-pega-grosor]');
    var valor = this.borde || mmAuto || PegatinaCorte.BORDE_MIN;
    if (document.activeElement !== input) input.value = valor;
    input.style.setProperty('--sdtf-llena', ((input.value - input.min) / (input.max - input.min) * 100) + '%');
    var lbl2 = extra.querySelector('[data-pega-grosor-mm]');
    if (lbl2) lbl2.textContent = fmt(valor, 1) + ' mm';
    extra.querySelectorAll('.sdtf-pega__color').forEach(function (b) {
      var on = (self.colorVinilo || '#ffffff') === b.getAttribute('data-color');
      b.classList.toggle('is-on', on);
    });
  };

  /* EL ZOOM DE LAS CHAPAS. El dibujo entra entero por defecto (100 %); el
     cliente puede subirlo para que se vea más grande —aunque entonces se
     recorte, y para eso está el aviso de «recorte» de PegatinaCorte— o
     bajarlo para dejar más aire alrededor. Igual que el grosor de las
     pegatinas, redibuja con un pequeño retardo y no en cada tic del
     arrastre, que si no se nota lento. */
  Subida.prototype.ZOOM_MIN = 40; Subida.prototype.ZOOM_MAX = 250;
  Subida.prototype.pintarZoom = function (caja) {
    var self = this;
    var z = caja.querySelector('[data-pega-zoom]');
    if (!z) {
      z = document.createElement('div');
      z.className = 'sdtf-pega__zoom';
      z.setAttribute('data-pega-zoom', '');
      z.innerHTML =
        '<label>Tamaño de la imagen <span data-pega-zoom-pct></span>' +
        '<input type="range" min="' + this.ZOOM_MIN + '" max="' + this.ZOOM_MAX +
        '" step="1" data-pega-zoom-r></label>';
      z.querySelector('[data-pega-zoom-r]').addEventListener('input', function (e) {
        self.zoom = parseFloat(e.target.value) / 100;
        e.target.style.setProperty('--sdtf-llena', ((e.target.value - e.target.min) / (e.target.max - e.target.min) * 100) + '%');
        var lbl = z.querySelector('[data-pega-zoom-pct]');
        if (lbl) lbl.textContent = e.target.value + ' %';
        clearTimeout(self._tZoom);
        self._tZoom = setTimeout(function () { self.actualizar(); }, 90);
      });
      var leyenda3 = caja.querySelector('.sdtf-pega__leyenda');
      caja.insertBefore(z, leyenda3 || null);
    }
    z.hidden = false;
    var input2 = z.querySelector('[data-pega-zoom-r]');
    var llenaZ = function (el) { el.style.setProperty('--sdtf-llena', ((el.value - el.min) / (el.max - el.min) * 100) + '%'); };
    var valor2 = Math.round((this.zoom || 1) * 100);
    if (document.activeElement !== input2) input2.value = valor2;
    var lbl3 = z.querySelector('[data-pega-zoom-pct]');
    if (lbl3) lbl3.textContent = valor2 + ' %';
    llenaZ(input2);
  };

  /* MOVER EL DISEÑO ARRASTRÁNDOLO EN LA PROPIA PREVIA — Xavi, 28/09: «otra
     mejora sería poder mover el diseño dentro de la chapa». Se engancha UNA
     vez por lienzo (el canvas es el mismo nodo en cada redibujado, no se
     crea de nuevo), y la escala mm↔px de pantalla la da dibujar() en su
     resultado: no hace falta recalcularla a mano ni adivinarla.
     No hace falta retardo como en el grosor de las pegatinas: una chapa
     siempre es redonda, y esa previa se pinta con un relleno y un recorte
     simples, sin el campo de distancias pixel a pixel de la troquelada —
     así que va fina redibujando en cada movimiento, no solo al soltar. */
  Subida.prototype.arrastrarChapa = function (lienzo, escala, cutW) {
    this._pegaEscala = escala;
    if (lienzo._pegaDragListo) return;
    lienzo._pegaDragListo = true;
    var self = this, activo = false, x0 = 0, y0 = 0, panX0 = 0, panY0 = 0, lim = 100, espera = null, tocando = false;
    /* En táctil, el lienzo NO puede quitarle el deslizamiento a la página (Xavi, 02/10: con el dedo encima de la
       previa no bajaba la web). touch-action: pan-y deja que la página baje; para mover el diseño se mantiene el dedo
       quieto un instante y, ya agarrado, un touchmove no pasivo anula el scroll. Con ratón se arrastra directamente. */
    lienzo.style.touchAction = 'pan-y';
    lienzo.style.cursor = 'grab';
    function agarrar(e) {
      var c0 = self.calculo();
      activo = true;
      x0 = e.clientX; y0 = e.clientY;
      panX0 = self.panX || 0; panY0 = self.panY || 0;
      lim = (c0 && c0.plan && c0.plan.cutW) || cutW || 100;
      lienzo.style.cursor = 'grabbing';
      lienzo.classList.add('is-agarrado');
      try { lienzo.setPointerCapture(e.pointerId); } catch (err) {}
    }
    lienzo.addEventListener('pointerdown', function (e) {
      var c1 = self.calculo(), p1 = c1 && c1.plan;
      if (self.cfg.iman && !(p1 && p1.forma !== 'libre')) return;
      if (e.pointerType === 'touch' || e.pointerType === 'pen') {
        tocando = true; x0 = e.clientX; y0 = e.clientY;
        var ev0 = { clientX: e.clientX, clientY: e.clientY, pointerId: e.pointerId };
        clearTimeout(espera);
        espera = setTimeout(function () { if (tocando) { agarrar(ev0); if (navigator.vibrate) { try { navigator.vibrate(12); } catch (err) {} } } }, 260);
        return;
      }
      agarrar(e);
      e.preventDefault();
    });
    lienzo.addEventListener('touchmove', function (e) { if (activo && e.cancelable) e.preventDefault(); }, { passive: false });
    lienzo.addEventListener('pointermove', function (e) {
      if (!activo) {
        // si el dedo se mueve antes de agarrar, es un deslizamiento de página: no se espera más
        if (tocando && (Math.abs(e.clientX - x0) > 8 || Math.abs(e.clientY - y0) > 8)) { clearTimeout(espera); tocando = false; }
        return;
      }
      var esc = self._pegaEscala || 1;
      self.panX = Math.max(-lim, Math.min(lim, panX0 + (e.clientX - x0) / esc));
      self.panY = Math.max(-lim, Math.min(lim, panY0 + (e.clientY - y0) / esc));
      self.actualizar();
    });
    function soltar(e) {
      clearTimeout(espera); tocando = false;
      if (!activo) return;
      activo = false;
      lienzo.style.cursor = 'grab';
      lienzo.classList.remove('is-agarrado');
      try { lienzo.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    lienzo.addEventListener('pointerup', soltar);
    lienzo.addEventListener('pointercancel', soltar);
  };

  // 0 o el precio del repaso, según lo que haya marcado el cliente
  Subida.prototype.extraRepaso = function () {
    var repaso = $(this.root, '[data-repaso]');
    return (repaso && repaso.checked && this.cfg.repaso) ? this.cfg.repaso.precio : 0;
  };

  // 0 o el recargo por producirlo antes (ver pintarPlazo)
  Subida.prototype.extraUrgente = function () {
    var u = this.urgenteAhora();
    return u ? u.precio : 0;
  };

  // la variante de urgencia que toca AHORA, o null si no está marcada o no cabe
  Subida.prototype.urgenteAhora = function () {
    if (!this.urgente || !this.cfg.urgente) return null;
    var v = this.varianteSel ? this.varianteSel() : null;
    if (!v) return null;
    return this.urgentePara(this.hojasDe(v, unidadesDe(v.opts)));
  };

  /* Todo lo que se suma al precio de la variante. Sale aquí y no repetido por
     la ficha porque si un sitio suma un extra y otro no, el cliente ve dos
     precios distintos en la misma pantalla y no sabe cuál es el suyo. */
  Subida.prototype.extras = function () {
    var nrm = this.normalAhora();
    return this.extraRepaso() + this.extraVector() + this.extraUrgente() + (nrm ? nrm.precio : 0);
  };

  Subida.prototype.alCarrito = async function (opt) {
    var c = this.calculo(), a = this.archivo;
    if (!c || !a || this.busy) return;
    var r = this.root, btn = (opt && opt.presupuesto) ? $(r, '[data-presupuesto]') : $(r, '[data-add]');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var libreN = c.variante._libre || 0;
    var campos = [['id', c.variante.id], ['quantity', libreN || 1]];
    if (libreN) {
      // chapas a medida: la línea es N × chapa suelta; la cantidad se ve en claro y el carrito la bloquea (_libre)
      campos.push(['properties[Cantidad]', libreN + ' ' + this.nombrePega(true)]);
      campos.push(['properties[_libre]', String(libreN)]);
    }
    if (c.mm) {
      campos.push(['properties[Medida final]', fmt(c.mm[0] / 10, 1) + ' × ' + fmt(c.mm[1] / 10, 1) + ' cm']);
      // los ppp no los ve el cliente: van con guion bajo, solo para el taller
      campos.push(['properties[_resolucion]', Math.round(c.dpi) + ' ppp · calidad ' + fmt(this.calidad(c.dpi).n, 1) + '/10']);
    }
    if (!c.mm && a.px) {
      var pq = a.pxCalidad || a.px;
      campos.push(['properties[_resolucion]', pq[0] + '×' + pq[1] + ' px · nítido hasta ' + fmt(this.anchoNitido(pq[0]), 1) + ' cm']);
    }
    var notas = $(r, '[data-notas]').value.trim();
    if (notas) campos.push(['properties[Notas]', notas]);
    /* LO QUE LEE EL TALLER. El catálogo de nombres está en archivo.js, en un
       solo sitio, porque alguno NO es una descripción sino una INSTRUCCIÓN de
       producción: el fondo negro fundido lleva pegado el «TRAMAR puntos45»
       que hace el panel a 300 ppp. Aquí estaba escrito a mano y con solo dos
       casos, así que un arreglo nuevo salía en el pedido con el nombre de
       otro. El respaldo de abajo repite la instrucción tal cual por si
       archivo.js no llegara a cargar: perderla sería mandar a imprimir un
       parche negro sobre tela negra. */
    if (a.arreglos && a.arreglos.length) {
      campos.push(['properties[_arreglos]', a.arreglos.map(function (x) {
        if (window.Archivo) return Archivo.pedido(x);
        return x === 'fondo' ? 'fondo quitado en la web'
          : x === 'negro' ? 'va el ORIGINAL con su fondo — FUNDIR negro + TRAMAR puntos45'
          : 'bordes afinados en la web';
      }).join(' · ')]);
    }
    var tela = this.tela();
    if (tela) campos.push(['properties[Color de la tela]', tela.nombre]);
    var repaso = $(r, '[data-repaso]');
    var conRepaso = !!(repaso && repaso.checked && this.cfg.repaso);
    if (conRepaso) {
      campos.push(['properties[Repaso del diseñador]', 'Sí, revisadlo y mandadme la prueba antes de imprimir']);
    }
    /* EL PLAZO VIAJA CON EL PEDIDO. La fecha que ha visto el cliente al pagar
       tiene que llegar al taller escrita: si solo va la línea de «producción
       urgente», el pedido entra en la cola como otro cualquiera y la prisa se
       pierde por el camino. */
    var urgV = this.urgenteAhora();
    var conUrgente = !!urgV;
    var nrmV = this.normalAhora();
    if (this.libre() && window.Entrega && this.cfg.entrega && Entrega.textoPlazo) {
      var plz = this.plazo || 'normal';
      campos.push(['properties[Plazo]', (plz === 'express' ? 'EXPRESS' : plz === 'eco' ? 'Económico' : 'Normal') +
        ' · ' + Entrega.textoPlazo(this.cfg.entrega, plz, null, this.hojasDe(c.variante, c.uds || 0)).replace(/<[^>]+>/g, '') +
        ' (fecha estimada, no garantizada)']);
    } else if (conUrgente && window.Entrega && this.cfg.entrega) {
      campos.push(['properties[Entrega]', 'URGENTE · ' +
        Entrega.texto(this.cfg.entrega, true, null, c.uds || 0).replace(/<[^>]+>/g, '')]);
    }
    if (this._texto && window.Texto) campos.push(['properties[Texto]', Texto.pedido(this._texto)]);
    if (this.cfg.iman) {
      campos.push(['properties[Borde]', this.filete ? 'Borde ' + (this.colorVinilo ? 'de color' : 'blanco') + ' de ' + fmt((c.plan && c.plan.filete) || (c.plan && c.plan.borde) || 3, 1) + ' mm' : 'SIN borde']);
      /* el color del imán (fondo detrás del dibujo y borde) viaja visible en el pedido: la hoja de producción lo enseña y el taller sabe que HAY QUE IMPRIMIRLO */
      var cv = this.colorVinilo, nomC = null;
      if (cv) this.PEGA_COLORES.forEach(function (x) { if (x[0].toLowerCase() === String(cv).toLowerCase()) nomC = x[1]; });
      campos.push(['properties[Color del imán]', cv ? (nomC || cv) + ' (' + cv + ') · SE IMPRIME' : 'Blanco (el del imán, sin imprimir color)']);
    }
    if (c.plan) {
      campos.push(['properties[Formato]', (c.plan.forma === 'redonda' ? 'Redonda'
        : c.plan.forma === 'cuadrada' ? 'Rectangular' : 'Troquelada') +
        ' ' + fmt(c.plan.cutW / 10, 1) + ' × ' + fmt(c.plan.cutH / 10, 1) + ' cm']);
      campos.push(['properties[_corte]', 'forma ' + c.plan.forma + ' · corte ' +
        fmt(c.plan.cutW, 1) + '×' + fmt(c.plan.cutH, 1) + ' mm · arte ' +
        fmt(c.plan.arteW, 1) + '×' + fmt(c.plan.arteH, 1) + ' mm · borde ' + c.plan.borde + ' mm' +
        (a.mascara ? ' · TROQUEL POR LA SILUETA del conjunto (cierre 4 %), el fondo del archivo se imprime dentro' : '') +
        (c.plan.sangra ? (c.plan.filete
          ? ' · con FILETE de ' + c.plan.filete + ' mm' +
            (this.colorVinilo ? ' color ' + this.colorVinilo + ' (SE IMPRIME, no es el vinilo en crudo)' : ' BLANCO') +
            ', el dibujo se recorta por dentro'
          : ' · A SANGRE, se recorta lo que sale de la forma') : '') +
        /* CHAPAS: el archivo que se manda ya viene recompuesto al tamaño de
           corte (ver alCarrito), pero esta línea queda de respaldo por si
           ese recompuesto falla y viaja el original — así el taller sabe
           igualmente la lámina y la zona segura reales de esta medida. */
        (this.cfg.chapa && c.plan.corteChapa
          ? ' · CHAPA diámetro ' + fmt(c.plan.cutW, 0) + ' mm, imprimir a ' + fmt(c.plan.corteChapa, 0) +
            ' mm (lámina de la ficha del proveedor), texto dentro de ' + fmt(c.plan.limiteChapa, 0) + ' mm' +
            ' · centro del diseño al ' + fmt((c.plan.offX || 0), 1) + ',' + fmt((c.plan.offY || 0), 1) + ' mm del medio'
          : '')]);
    } else if (c.formato) {
      /* Sin previa (PDF, AI) no hay plan, pero el formato elegido sí se sabe, y
         en la hoja de taller tiene que constar: el título de la variante se
         lee mal y en la troquelada solo dice "hasta 5×5". */
      var fx = c.formato;
      campos.push(['properties[Formato]', (fx.forma === 'redonda' ? 'Redonda '
        : fx.forma === 'cuadrada' ? 'Rectangular ' : 'Troquelada, hasta ') +
        fmt(fx.w / 10, 1) + ' × ' + fmt(fx.h / 10, 1) + ' cm']);
      campos.push(['properties[_corte]', 'forma ' + fx.forma + ' · formato ' +
        fmt(fx.w, 1) + '×' + fmt(fx.h, 1) + ' mm · archivo vectorial, montar en taller']);
    }
    var conVector = this.quiereVector();
    if (conVector) {
      campos.push(['properties[Vectorizado]', 'Sí, redibujado en vectores e impreso a 300 ppp']);
    }
    if (c.dpi && c.dpi < this.cfg.dpiMin && !conVector) campos.push(['properties[_aviso]', 'Calidad ' + fmt(this.calidad(c.dpi).n, 1) + '/10 al tamaño pedido']);

    this.busy = true;
    if (window.Cargando) Cargando.ocupar(btn, 'Subiendo el diseño…', true);
    else { btn.disabled = true; btn.textContent = 'Subiendo el diseño…'; }
    try {
      /* Si ha comprado el vectorizado, el archivo que va al taller ya no es el
         suyo: es el redibujado, generado a 300 ppp al tamaño exacto del pedido.
         Se pide aquí, cuando ya ha decidido comprar: 0,9 créditos bien gastados. */
      var archivo = a.file, nombre = a.name, svg = null;
      if (conVector) {
        if (window.Cargando) Cargando.ocupar(btn, 'Preparando el vectorizado…');
        archivo = await this.bajarVector('png', c);
        nombre = archivo.name;
        // el SVG es un extra prometido en la ficha; si falla, no se para la compra
        try { svg = await this.bajarVector('svg', c); } catch (e2) { svg = null; }
      }
      /* CON SEMITONO, AL TALLER VA EL ORIGINAL (Xavi, 26/09: «mejor que en el
         pedido esté el diseño original con su fondo, con la mayor calidad
         posible y a tamaño de impresión. Transparente no me sirve para
         nada»). El fundido y la trama los hace su panel; lo de la web es
         solo para que el cliente vea cómo queda. Se manda el archivo de
         ANTES de fundir, recortado a lo mismo que se ha medido, sin
         remuestrear (los píxeles son los suyos) y con la medida del pedido
         escrita dentro del PNG. Si algo falla, va el original entero. */
      var conNegro = (a.arreglos || []).indexOf('negro') !== -1;
      if (!conVector && c.mm && a.caja && (conNegro || a.margenQuitado)) {
        var ori = a;
        while (ori.anterior && (ori.arreglos || []).indexOf('negro') !== -1) ori = ori.anterior;
        if (ori.file) {
          archivo = ori.file; nombre = ori.name;
          try {
            if (window.Cargando) Cargando.ocupar(btn, 'Preparando el diseño…');
            var bo = await createImageBitmap(ori.file);
            var cj = a.caja || { x: 0, y: 0, w: bo.width, h: bo.height };
            var lz = document.createElement('canvas');
            lz.width = cj.w; lz.height = cj.h;
            lz.getContext('2d').drawImage(bo, cj.x, cj.y, cj.w, cj.h, 0, 0, cj.w, cj.h);
            if (bo.close) bo.close();
            var nom = ori.name.replace(/\.[^.]+$/, '') + (conNegro ? '-original-' : '-') +
              fmt(c.mm[0] / 10, 1).replace(',', '_') + 'x' + fmt(c.mm[1] / 10, 1).replace(',', '_') + 'cm.png';
            var fo = await ImgArreglo.pngConMedida(lz, c.mm[0], nom);
            if (fo.size <= this.cfg.maxFileMb * 1048576) { archivo = fo; nombre = nom; }
          } catch (e3) { /* se queda el original entero */ }
        }
      }
      /* EN CHAPAS, LO QUE VE EL CLIENTE ES LO QUE SE MANDA — Xavi, 28/09:
         «¿en el pedido me llegará justo el recorte que ve el cliente?». Antes
         no: se mandaba el archivo entero tal cual, y el taller tenía que
         adivinar a partir de una frase en `_corte` dónde iba el centro y
         cuánto zoom llevaba. Con zoom y arrastre eso ya no es fiable, así que
         aquí se recompone la MISMA imagen final que ve el cliente —recortada
         a `a.caja`, escalada y colocada exactamente como en la previa— y esa
         es la que viaja al pedido, a 300 ppp de verdad. Si algo falla, se
         queda el original entero y al menos la medida sigue escrita en
         `_corte` (mejor eso que nada). */
      if (!conVector && this.cfg.chapa && c.plan && a.caja && a.file) {
        try {
          if (window.Cargando) Cargando.ocupar(btn, 'Preparando el diseño…');
          var bmpCh = await createImageBitmap(a.file);
          var pxMm = 300 / 25.4;
          /* EL ARCHIVO SE PREPARA AL TAMAÑO DE CORTE (la lámina real que se
             imprime), no al diámetro visible: el sobrante se pliega por
             detrás de la chapa y tiene que llevar algo, aunque sea blanco.
             El encaje/zoom del dibujo sigue midiéndose sobre el diámetro
             (es lo que ve el cliente); aquí solo se centra ese mismo
             resultado dentro de un lienzo más grande. */
          var corteCh = c.plan.corteChapa || c.plan.cutW;
          var outW = Math.max(1, Math.round(corteCh * pxMm));
          var outH = Math.max(1, Math.round(corteCh * pxMm));
          var lienzoCh = document.createElement('canvas');
          lienzoCh.width = outW; lienzoCh.height = outH;
          var ctxCh = lienzoCh.getContext('2d');
          /* La lámina es un DISCO, no un cuadrado: fuera del círculo queda transparente. Así la pestaña «Pegatinas» del panel lo
             lee como una pieza redonda (forma por la silueta) y el Graphtec corta el disco, igual que una pegatina redonda. */
          ctxCh.save();
          ctxCh.beginPath(); ctxCh.arc(outW / 2, outH / 2, Math.min(outW, outH) / 2, 0, Math.PI * 2); ctxCh.clip();
          ctxCh.fillStyle = '#ffffff'; ctxCh.fillRect(0, 0, outW, outH);
          var centroCh = a.centro || [0.5, 0.5];
          var axMm = corteCh / 2 - c.plan.arteW * centroCh[0] + (c.plan.offX || 0);
          var ayMm = corteCh / 2 - c.plan.arteH * centroCh[1] + (c.plan.offY || 0);
          var cajaCh = a.caja;
          ctxCh.drawImage(bmpCh, cajaCh.x, cajaCh.y, cajaCh.w, cajaCh.h,
            axMm * pxMm, ayMm * pxMm, c.plan.arteW * pxMm, c.plan.arteH * pxMm);
          ctxCh.restore();
          if (bmpCh.close) bmpCh.close();
          /* EL NOMBRE LO LEE EL PANEL (pegatinas.py, del_nombre): primero el tamaño a imprimir y cortar («51mm», la primera medida en
             mm que encuentra), luego la forma y las copias («x25»); el nombre del cliente va al final, donde no estorba. */
          var nCh = libreN || c.uds || 1, discoCh = String(Math.round(corteCh * 10) / 10);
          var baseCh = a.name.replace(/\.[^.]+$/, '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40) || 'diseno';
          var nomCh = 'chapa-' + discoCh + 'mm-redonda-x' + nCh + '-de-' + fmt(c.plan.cutW, 0) + 'mm-' + baseCh + '.png';
          var fCh = await ImgArreglo.pngConMedida(lienzoCh, corteCh, nomCh);
          if (fCh.size <= this.cfg.maxFileMb * 1048576) {
            archivo = fCh; nombre = nomCh;
            campos.push(['properties[_taller]', 'Fichero listo para la pestaña Pegatinas del panel: disco redondo de ' + discoCh +
              ' mm (chapa de ' + fmt(c.plan.cutW, 0) + ' mm), ' + nCh + ' uds, sin borde blanco. Cortar por el disco.']);
          }
        } catch (e4) { /* se queda el original entero, con la medida en _corte */ }
      }
      /* IMANES A SANGRE: lo que ve el cliente es lo que se manda. Con el tamaño de
         imagen y la posición que ha elegido, el archivo de producción se recompone
         a tamaño de corte y a 300 ppp, recortado a la forma (menos el filete de
         borde blanco, si lo ha pedido). Si algo falla, viaja el original. */
      if (!conVector && this.cfg.iman && c.plan && c.plan.forma !== 'libre' && a.caja && a.file) {
        try {
          if (window.Cargando) Cargando.ocupar(btn, 'Preparando el diseño…');
          var bmpIm = await createImageBitmap(a.file);
          var pxMi = 300 / 25.4, pl = c.plan;
          var oW = Math.max(1, Math.round(pl.cutW * pxMi)), oH = Math.max(1, Math.round(pl.cutH * pxMi));
          var lienzoIm = document.createElement('canvas');
          lienzoIm.width = oW; lienzoIm.height = oH;
          var ctxIm = lienzoIm.getContext('2d');
          ctxIm.fillStyle = '#ffffff'; ctxIm.fillRect(0, 0, oW, oH);
          var fil = pl.filete || 0;
          ctxIm.save();
          ctxIm.beginPath();
          if (pl.forma === 'redonda') ctxIm.arc(oW / 2, oH / 2, Math.max(1, (pl.cutW / 2 - fil) * pxMi), 0, Math.PI * 2);
          else ctxIm.rect(fil * pxMi, fil * pxMi, oW - 2 * fil * pxMi, oH - 2 * fil * pxMi);
          ctxIm.clip();
          // el color liso del fondo del diseño llena el imán hasta el borde (sin margen blanco), dentro del recorte
          if (pl.relleno) { ctxIm.fillStyle = pl.relleno; ctxIm.fillRect(0, 0, oW, oH); }
          var cenIm = a.centro || [0.5, 0.5];
          var axIm = pl.cutW / 2 - pl.arteW * cenIm[0] + (pl.offX || 0);
          var ayIm = pl.cutH / 2 - pl.arteH * cenIm[1] + (pl.offY || 0);
          ctxIm.drawImage(bmpIm, a.caja.x, a.caja.y, a.caja.w, a.caja.h,
            axIm * pxMi, ayIm * pxMi, pl.arteW * pxMi, pl.arteH * pxMi);
          ctxIm.restore();
          if (bmpIm.close) bmpIm.close();
          var nomIm = a.name.replace(/\.[^.]+$/, '') + '-iman-' + fmt(pl.cutW, 0) + 'x' + fmt(pl.cutH, 0) + 'mm.png';
          var fIm = await ImgArreglo.pngConMedida(lienzoIm, Math.max(pl.cutW, pl.cutH), nomIm);
          if (fIm.size <= this.cfg.maxFileMb * 1048576) {
            archivo = fIm; nombre = nomIm;
            campos.push(['properties[_compuesto]', 'Diseño recompuesto por la web tal como lo vio el cliente: ' +
              fmt(pl.cutW, 1) + '×' + fmt(pl.cutH, 1) + ' mm, forma ' + pl.forma + ', imprimir tal cual y cortar por la forma']);
          }
        } catch (e5) { /* se queda el original entero, con la medida en _corte */ }
      }
      /* PRESUPUESTO LISTO PARA PAGAR: las mismas líneas y archivos que irían al carrito, pero a un pedido borrador
         (Worker de presupuestos) en vez de al carrito de quien lo prepara. */
      if (opt && opt.presupuesto) {
        var props = {}, lineaId = null, cantidad = 1;
        campos.forEach(function (f) {
          if (f[0] === 'id') lineaId = f[1];
          else if (f[0] === 'quantity') cantidad = f[1];
          else { var mp = /^properties\[(.*)\]$/.exec(f[0]); if (mp) props[mp[1]] = f[1]; }
        });
        var archivosP = { 'Diseño': 'f0' }, ficheros = { f0: [archivo, nombre] };
        if (svg) { archivosP['Tu archivo vectorial'] = 'f1'; ficheros.f1 = [svg, svg.name]; }
        var lineasP = [{ id: lineaId, quantity: cantidad, properties: props, archivos: archivosP }];
        if (conRepaso) lineasP.push({ id: this.cfg.repaso.id, quantity: 1 });
        if (conVector) lineasP.push({ id: this.cfg.vector.id, quantity: 1 });
        if (conUrgente) lineasP.push({ id: urgV.id, quantity: 1 });
        if (nrmV) lineasP.push({ id: nrmV.id, quantity: 1 });
        if (window.Cargando) Cargando.ocupar(btn, 'Preparando el presupuesto…');
        /* LA PRUEBA DEL PRESUPUESTO con la forma real (Xavi, 30/10: «la pegatina redonda sale rectangular en el presupuesto»): sin ella el Worker
           enseña el archivo del cliente tal cual (un rectángulo). Se dibuja el diseño recortado a la forma del corte (redonda, rectangular…). */
        var pruebaP = null;
        try { pruebaP = await this.pruebaForma(c, a); } catch (eP) { pruebaP = null; }
        if (pruebaP) { archivosP['_Mockup'] = 'fm'; ficheros.fm = [pruebaP, 'prueba-' + (c.plan.forma || 'forma') + '.png']; }
        var pres = await Presupuesto.crear(this.cfg.presupuestoUrl, {
          titulo: opt.titulo, nota: notas || '', lineas: lineasP, ficheros: ficheros
        });
        if (pruebaP && pres) { try { pres.imagenPdf = URL.createObjectURL(pruebaP); } catch (eU) { /* sin imagen en el PDF */ } }
        /* Imanes y chapas: el archivo que viaja ya es el diseño recompuesto con su forma (recortado al corte, a 300 ppp): es el montaje del PDF. */
        else if (!pruebaP && pres && archivo && /^image\/(png|jpe?g)$/i.test(archivo.type || '')) { try { pres.imagenPdf = URL.createObjectURL(archivo); } catch (eU2) { /* sin imagen en el PDF */ } }
        this.busy = false;
        return pres;
      }
      var fd = new FormData();
      campos.forEach(function (f) { fd.append(f[0], f[1]); });
      fd.append('properties[Diseño]', archivo, nombre);
      if (svg) fd.append('properties[Tu archivo vectorial]', svg, svg.name);
      var res;
      if (window.Cargando) {
        res = await Cargando.subir(root + 'cart/add.js', fd, function (p) {
          // el 100 % es "enviado"; después queda el guardado en Shopify
          if (p >= 100) Cargando.ocupar(btn, 'Guardando el diseño…');
          else Cargando.pct(btn, p, 'Subiendo el diseño');
        });
      } else {
        res = await fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      }
      if (!res.ok) throw new Error('multipart');
      if (window.Cargando) Cargando.ocupar(btn, 'Vamos al carrito…');
      // los servicios van como líneas aparte, a la vista y con su precio
      var servicios = [];
      if (conRepaso) servicios.push({ id: this.cfg.repaso.id, quantity: 1 });
      if (conVector) servicios.push({ id: this.cfg.vector.id, quantity: 1 });
      if (conUrgente) servicios.push({ id: urgV.id, quantity: 1 });
      if (nrmV) servicios.push({ id: nrmV.id, quantity: 1 });
      if (servicios.length) {
        await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: servicios })
        });
      }
      window.location.href = root + 'cart';
    } catch (err) {
      if (opt && opt.presupuesto) { this.busy = false; this.actualizar(); throw err; }
      if (err && err.message === 'multipart') return this.enviarFormulario(campos, a);
      this.busy = false; this.flash('No se ha podido añadir al carrito. Inténtalo de nuevo o escríbenos por WhatsApp.');
      this.actualizar();
    }
  };

  /* Presupuesto listo para pagar: pedido borrador con todo dentro y su enlace de pago, que se comparte por WhatsApp o se copia. */
  // el título del producto, en una línea y sin repetir (el tema lo pinta dos veces: visible y para lectores)
  function tituloLimpio() {
    var h = document.querySelector('h1') || document.querySelector('.product__title');
    var t = String(h ? h.textContent : document.title).replace(/\s+/g, ' ').trim();
    var m = Math.floor(t.length / 2);
    if (t.length % 2 === 1 && t.charAt(m) === ' ' && t.slice(0, m) === t.slice(m + 1)) t = t.slice(0, m);
    return t;
  }

  Subida.prototype.presupuestoListo = async function (soloWhatsapp) {
    var c = this.calculo(), a = this.archivo, r = this.root;
    var btn = $(r, '[data-presupuesto]'), nota = $(r, '[data-presupuesto-nota]');
    if (!c || !a || this.busy || this._presBusy) return;
    /* SIN WORKER DE PRESUPUESTOS (aún no está en marcha) el botón NO desaparece: manda por WhatsApp un presupuesto
       con todo lo elegido, el precio, el plazo y un enlace que abre la ficha tal cual la dejó, diseño incluido en
       este aparato. Con el Worker activo, sigue siendo el pedido borrador listo para pagar. */
    if (!window.Presupuesto || !this.cfg.presupuestoUrl || soloWhatsapp === true) {
      this._presBusy = true; btn.disabled = true;
      try {
        await this.guardarPausa();
        var tit0 = tituloLimpio();
        var det = [], self0 = this;
        var f0 = this.libre() ? this.formatoIman() : null;
        if (f0) det.push((f0.forma === 'redonda' ? this.gen('Redonda', 'Redondo') + ' de ' + fmt(f0.w / 10, 1) + ' cm'
          : f0.forma === 'libre' ? 'A su forma, hasta ' + fmt(f0.w / 10, 1) + ' × ' + fmt(f0.h / 10, 1) + ' cm'
          : fmt(f0.w / 10, 1) + ' × ' + fmt(f0.h / 10, 1) + ' cm'));
        if (f0 && !this.cfg.iman) (c.variante.opts || []).forEach(function (o, j) { if (j !== self0.iTam && j !== self0.iCant) det.push(o); });
        var u0 = unidadesDe(c.variante.opts || []);
        if (u0 > 1 || f0) det.push(u0 + ' ' + (this.cfg.pegatina ? this.nombrePega(true) : 'uds'));
        if (!f0) (c.variante.opts || []).forEach(function (o) { if (!/\bud/i.test(o)) det.push(o); });
        var plazo0 = '';
        try { plazo0 = Entrega.texto(this.cfg.entrega, false, null, this.hojasDe(c.variante, c.uds || 0)).replace(/<[^>]+>/g, ''); } catch (e0) { plazo0 = ''; }
        var texto0 = 'Presupuesto de Imprimirlo · ' + tit0 + '\n' + det.join(' · ') +
          '\nPrecio: ' + money(c.variante.precio + this.extras()) + ' (IVA incluido)' + (plazo0 ? '\n' + plazo0 : '') +
          '\nPídelo aquí, con todo lo elegido: ' + this.enlacePausa();
        window.open('https://wa.me/?text=' + encodeURIComponent(texto0), '_blank', 'noopener');
      } catch (e1) { this.flash('No se ha podido preparar el presupuesto.'); }
      this._presBusy = false; this.actualizar();
      return;
    }
    this._presBusy = true; btn.disabled = true;
    var antes = btn.textContent;
    try {
      var titulo = tituloLimpio();
      var pres = await this.alCarrito({ presupuesto: true, titulo: titulo });
      if (!pres) throw new Error('sin presupuesto');
      var cant = (c.variante.opts || []).join(' · ');
      var plazo = '';
      try {
        var hojas = this.hojasDe(c.variante, c.uds || 0);
        plazo = Entrega.texto(this.cfg.entrega, false, null, hojas).replace(/<[^>]+>/g, '');
      } catch (e) { plazo = ''; }
      var total = pres.total ? money(Math.round(parseFloat(pres.total) * 100)) : money(c.variante.precio);
      var texto = 'Presupuesto de Imprimirlo · ' + titulo + '\n' + (cant ? cant + '\n' : '') +
        'Precio: ' + total + ' IVA incl.' + (plazo ? '\n' + plazo : '') + (pres.landing ? '\nMira el montaje y págalo aquí: ' + pres.landing : '\nPágalo aquí: ' + pres.url);
      /* Flujo de Xavi (11/10): el botón pasa de «Crear presupuesto» a «Enviar presupuesto» y es ése el que manda el mensaje;
         debajo ya no se enseña nada (ver Presupuesto.mostrar). */
      pres.totalTexto = total + ' IVA incl.';
      if (window.Cargando) Cargando.libre(btn);
      Presupuesto.mostrar(nota, pres, texto, false);
    } catch (e) {
      /* Si el Worker falla (caído, sin permisos…), el cliente no se queda sin presupuesto: se manda el de siempre por WhatsApp, con el enlace a la ficha. */
      if (window.Cargando) Cargando.libre(btn);
      btn.textContent = antes;
      try { console.warn('Presupuesto con enlace de pago: ' + ((e && e.message) || e)); } catch (e3) { /* sin consola */ }
      this._presBusy = false; this.actualizar();
      this.flash('El enlace de pago no está disponible ahora (' + ((e && e.message) || 'sin detalle') + '). Te preparo el presupuesto de siempre.');
      return this.presupuestoListo(true);   // solo esta vez: la próxima pulsación vuelve a probar el Worker
    }
    this._presBusy = false; this.actualizar();
  };

  /* Prueba del presupuesto: el diseño dentro de la FORMA de la pegatina (un PNG de unos 900 px). Redonda → círculo, rectangular → rectángulo,
     troquelada → el dibujo tal cual. Con una línea fina gris que marca el corte, sobre blanco (el vinilo). null si no hay datos para dibujarla. */
  Subida.prototype.pruebaForma = async function (c, a) {
    if (!this.cfg.pegatina || this.cfg.chapa || this.cfg.iman || !c || !c.plan || !a || !a.file || !a.caja) return null;
    var pl = c.plan, k = Math.min(8, 900 / Math.max(pl.cutW, pl.cutH)), W = Math.max(1, Math.round(pl.cutW * k)), H = Math.max(1, Math.round(pl.cutH * k));
    var bmp = await createImageBitmap(a.file), cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    var x = cv.getContext('2d'), cen = a.centro || [0.5, 0.5];
    var forma = function () { x.beginPath(); if (pl.forma === 'redonda') x.ellipse(W / 2, H / 2, W / 2 - 1, H / 2 - 1, 0, 0, Math.PI * 2); else x.rect(1, 1, W - 2, H - 2); };
    x.save();
    if (pl.forma !== 'libre') { forma(); x.clip(); x.fillStyle = '#ffffff'; x.fillRect(0, 0, W, H); }
    x.drawImage(bmp, a.caja.x, a.caja.y, a.caja.w, a.caja.h, (pl.cutW / 2 - pl.arteW * cen[0] + (pl.offX || 0)) * k, (pl.cutH / 2 - pl.arteH * cen[1] + (pl.offY || 0)) * k, pl.arteW * k, pl.arteH * k);
    x.restore();
    if (bmp.close) bmp.close();
    if (pl.forma !== 'libre') { forma(); x.lineWidth = 2; x.strokeStyle = 'rgba(0,0,0,.28)'; x.stroke(); }
    return new Promise(function (ok) { cv.toBlob(function (b) { ok(b); }, 'image/png'); });
  };

  /* Archivo de producción del vectorizado. El PNG se pide al tamaño exacto del
     pedido y a 300 ppp: aquí los ppp SÍ son reales, porque el vector se vuelve
     a dibujar a ese tamaño. No es ampliar, es redibujar. */
  Subida.prototype.bajarVector = async function (formato, c) {
    var a = this.archivo;
    var fd = new FormData();
    fd.append('token', a.vectorToken);
    fd.append('formato', formato);
    if (formato === 'png' && c && c.mm) {
      fd.append('ancho_mm', String(Math.round(c.mm[0] * 10) / 10));
      fd.append('alto_mm', String(Math.round(c.mm[1] * 10) / 10));
    }
    var r = await fetch(this.servidorVector('producir'), { method: 'POST', body: fd });
    if (!r.ok) {
      var msg = 'No hemos podido preparar el archivo vectorizado.';
      try { var j = await r.json(); if (j && j.error) msg = j.error; } catch (e) {}
      throw new Error(msg);
    }
    var blob = await r.blob();
    var base = a.name.replace(/\.[^.]+$/, '') + '-vectorizado.' + formato;
    return new File([blob], base, { type: formato === 'svg' ? 'image/svg+xml' : 'image/png' });
  };

  // alternativa: formulario multipart clásico
  Subida.prototype.enviarFormulario = function (campos, a) {
    var form = $(this.root, '[data-form]');
    form.innerHTML = '';
    campos.concat([['form_type', 'product'], ['utf8', '✓']]).forEach(function (f) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = f[0]; i.value = f[1]; form.appendChild(i);
    });
    var fi = document.createElement('input'); fi.type = 'file'; fi.name = 'properties[Diseño]';
    var dt = new DataTransfer(); dt.items.add(a.file); fi.files = dt.files; form.appendChild(fi);
    form.submit();
  };

  function init() {
    document.querySelectorAll('[data-subida-dtf]').forEach(function (el) { if (!el._sdtf) el._sdtf = new Subida(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();